import { Component, ViewChild, OnInit, AfterViewInit, HostListener, AfterContentInit, ElementRef } from '@angular/core';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
// import {KonvaComponent} from 'ng2-konva';
import * as Konva from 'konva';
// import htmlString = JQuery.htmlString;
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreenService } from '../../services/screen.service';
import { RegistrationService } from '../../services/Registration.service';
import { AppSettingsService } from '../../services/app-settings.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from '../../services/data.service';
import { NgForm } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { createElement } from '@angular/core/src/view/element';
import { DatePipe } from '@angular/common';
import { HtmlParser } from '@angular/compiler';
import { element } from 'protractor';
import { Options } from '@angular-slider/ngx-slider';
import { time } from 'console';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY } from '@angular/cdk/a11y';
import { validateVerticalPosition } from '@angular/cdk/overlay';
import { SubscriptionService } from '../../services/subscription.service';
import { decode } from 'punycode';
//import { group } from 'console';
//import { Console } from 'console';
// import { interval } from 'rxjs';

//import { Script } from 'vm';
// declare const Konva: any;
let ng: any;
declare var jquery: any;
declare var $: any;
declare var jscolor: any;
declare var playerStatusIntervalID: any;
let draggedPlayListItemId: any;

@Component({
  selector: 'app-screen-builder',
  templateUrl: './screen-builder.component.html',
  styleUrls: [
    './screen-builder.component.css'
  ]
})
export class ScreenBuilderComponent implements OnInit, AfterViewInit, AfterContentInit {
  currentUser: User;
  public canvasBgColor = '#ffffff';
  public signName = '';
  public registrationCode = '';
  public screenName = '';
  public newScreenName = '';
  public viewScreenshotfile = '';
  public playerScreenshotHeader = '';
  public imagefilename = '';
  public audiofilename = '';
  public videofilename = '';
  public playerName = '';
  public stage: any;
  public layer: any;
  public dragLayer: any;
  public stageWidth = 1280;
  public stageHeight = 720;
  public list: Array<any> = [];
  public imageList: Array<any> = [];
  public videoLlist: Array<any> = [];
  public textList: Array<any> = [];
  public currentXmls: Array<any> = [];
  public currentScreens: Array<any> = [];
  public gFilesToBeDelivered: Array<any> = [];
  public gContentAllFiles: Array<any> = [];
  public currentImages: Array<any> = [];
  public currentVideos: Array<any> = [];
  public currentAudios: Array<any> = [];
  public videoAssets: Array<any> = [];
  public templateMenu: Array<any> = [];
  public videoChannelAssets: Array<any> = [];
  public
  currentTemplates = { hdTemplate: [], fullHdTemplate: [], allTemplates: [], fullScreenWithImageTemplate: [], fullScreenWithVideoTemplate: [], menuTemplates: [] };
  public currentUserServers: Array<any> = [];
  public activeAssetId;
  public publishLineup = false;
  public activeImageParent;
  public channelUpdatePath;
  public screenshotAppPath;
  public siteLogAppPath;
  public timer: any;
  public sly;  // this is used for the horizontal slide of assets
  private gContentDirectory = '../Content/';
  // public gActiveResolution = '1280x720';
  public gActiveResolution = '1920x1080';
  public selectedResolution = this.gActiveResolution;
  public selectedModel = null;
  public _templatePath: any = false;
  private publishOnlyVideos = false;
  private publishVideos = true;
  public lastSaveDateTime;
  public oldMinutes = 0;
  public previewEndPoint = {
    UserID: null,
    userName: null,
    Connection: 'FTP',
    IPAddress: '127.0.0.1',
    Port: 21,
    ServerName: 'preview end point'
  };
  public contentServer = {
    Name: '',
    UserID: null,
    userID: null,
    userName: null,
    Connection: 'FTP',
    IPAddress: '127.0.0.1',
    Port: 21,
    UserName: '',
    Password: '',
    ContentDirectory: '',
    TransferDirectory: '',
    FileMasks: '',
    ServerName: 'content server',
    EndpointLocationName: null,
    iD: null
  };
  public ezTvServer = {
    UserID: null,
    userName: null,
    Protocol: 'FTP',
    IPAddress: '127.0.0.1',
    UserName: '',
    Password: '',
    ServerName: 'ez tv server'
  };
  public userObj = {
    UserName: null,
    Password: null,
    UserRole: '',
    FirstName: null,
    LastName: null,
    EmailID: '',
    UserId: null,
    HomeDirectory: null
  };
  public userList = [];
  public userServersList = [];
  public editUserObj = {};
  public contentServerUserObj = { userID: null, userName: null };
  public contentServerObj = {};
  public publichContentServerObj = { endpointLocationName: '' };
  public isAddNewUser = false;
  public isAddNewUserServer = false;
  public dmbTVStatusList = [];
  public volumeLocally = false;
  public screenStatus = false;
  public active = false;
  public hideSlider = true;
  public showNotSet = false;
  public dateUpdatedOnSiteStatsTable = '';
  public playerRegistrationCode = '';
  public xValue = 0;
  public yValue = 0;
  public widthValue = 0;
  public heightValue = 0;
  public isObjectMoved = false;
  public dmbplayerName = '';
  public isPortraitView = false;
  public tod_no_of_players = 0;
  public isEditRule = false;
  public previewScreenUrl = '';
  // public editUserObj= {};
  // public userRoles = ['admin', 'user'];
  public userRoles: Array<any> = [];
  dmbform = {
    Volume: '',
    ScreenStatus: '',
    ReebootTime: '',
  };

  value: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100
  };

  zoomValue: number = 100;
  zoomOptions: Options = {
    floor: 40,
    ceil: 100
  };

  public timenow: number;
  TimeArray = [{ id: '-1', name: 'Not Set' }, { id: '0', name: 'Restart Now' }, { id: '01:00', name: '1:00 AM' }, { id: '02:00', name: '2:00 AM' }, { id: '03:00', name: '3:00 AM' }, { id: '04:00', name: '4:00 AM' }, { id: '05:00', name: '5:00 AM' }, { id: '06:00', name: '6:00 AM' }, { id: '07:00', name: '7:00 AM' }, { id: '08:00', name: '8:00 AM' }, { id: '09:00', name: '9:00 AM' }, { id: '10:00', name: '10:00 AM' }, { id: '11:00', name: '11:00 AM' }, { id: '12:00', name: '12:00 PM' }, { id: '13:00', name: '1:00 PM' }, { id: '14:00', name: '2:00 PM' }, { id: '15:00', name: '3:00 PM' }, { id: '16:00', name: '4:00 PM' }, { id: '17:00', name: '5:00 PM' }, { id: '18:00', name: '6:00 PM' }, { id: '19:00', name: '7:00 PM' }, { id: '20:00', name: '8:00 PM' }, { id: '21:00', name: '9:00 PM' }, { id: '22:00', name: '10:00 PM' }, { id: '23:00', name: '11:00 PM' }];
  public isSavingUser = false;
  public isDeletingUser = false;
  public screenAttributes = [
    { name: 'Sign Name', id: 'sign_name' },
    { name: 'Background Color', id: 'bkg_color' }
  ];
  public imageAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_image_options' },
    { name: 'FullScreen', id: '_fullscreen', ControlType: 'checkbox', ShowAsDetails: false },
    { name: 'Border', id: '_border', ControlType: 'checkbox', ShowAsDetails: false },
    //  { name: 'IsBorder',id: '_isborder', hidden: false,ShowAsDetails: true },
    { name: '', id: '_def_source', ShowAsDetails: false },
    { name: 'Source', id: '_source', ShowAsDetails: false, maxlength: 2000 },
    { name: '', id: '_resize_to_source', ShowAsDetails: false, maxlength: 2000 },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', default: 20, ShowAsDetails: true },
    { name: 'Y', id: '_y', default: 20, ShowAsDetails: true },
    { name: 'Width', id: '_width', default: 400, ShowAsDetails: true },
    { name: 'Height', id: '_height', default: 300, ShowAsDetails: true },
    { name: 'PlayList', id: '_playlist', ControlType: 'checkbox', hidden: false, ShowAsDetails: true },
    // { name: 'File Name', id: '_file_name', hidden: true, ShowAsDetails: true },
    { name: 'Item Duration', id: '_item_duration', hidden: true, ShowAsDetails: true },
    // { name: 'Transition', id: '_transtion', hidden: true, ShowAsDetails: true }
    { name: 'FULLSCREEN SHUFFLE', id: '_image_wall', ControlType: 'checkbox', hidden: true, ShowAsDetails: true },
  ];
  public videoAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_video_options' },
    { name: 'FullScreen', id: '_fullscreen', ControlType: 'checkbox', ShowAsDetails: false },
    { name: 'Border', id: '_border', ControlType: 'checkbox', ShowAsDetails: false },
    { name: '', id: '_def_source', ShowAsDetails: false },
    { name: '', id: '_audio_def_source', ShowAsDetails: false },
    { name: 'Name', id: '_name', ShowAsDetails: false },
    { name: 'Source', id: '_source', ShowAsDetails: false, maxlength: 2000 },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'PlayList', id: '_playlist', ControlType: 'checkbox', checked: false, disabled: true, hidden: true, ShowAsDetails: false, ShowForHls: true },
    { name: 'Item Duration', id: '_item_duration', hidden: true, ShowAsDetails: false, ShowForHls: true },
    // { name: 'Inc. Videos', id: '_publish_videos', ControlType: 'checkbox', hidden: false, ShowAsDetails: true },
    // { name: 'PlayList', id: '_playlist', ControlType: 'checkbox', hidden: false, ShowAsDetails: true },
    // { name: 'File Name', id: '_file_name', hidden: true, ShowAsDetails: true }
  ];
  public textAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_text_options' },
    { name: 'Source', id: '_source', defaultVal: '--Text--', ShowAsDetails: false, maxlength: 700 },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Font', id: '_font', defaultVal: 'Default', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true },
    { name: 'FONT INSET', id: '_font_special', ControlType: 'checkbox', ShowAsDetails: true }
  ];
  public browserAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_browser_options' },
    { name: 'FullScreen', id: '_fullscreen', ControlType: 'checkbox', ShowAsDetails: false },
    { name: 'Source', id: '_source', defaultVal: '-- Browser --', ShowAsDetails: false, maxlength: 2000 },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Refresh Interval', id: '_refresh_interval', ShowAsDetails: true }];
  public channelAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_channel_options' },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Font', id: '_font', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true }
  ];
  public clockAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_clock_options' },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Date Format', id: '_date_format', defaultVal: 'MM/DD/YY', ShowAsDetails: true },
    { name: 'Time Format', id: '_time_format', defaultVal: '12h no seconds + AMPM', ShowAsDetails: true },
    { name: 'Time Zone', id: '_time_zone', defaultVal: 'Default', ShowAsDetails: true },
    { name: 'Font', id: '_font', defaultVal: 'Default', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true }
  ];
  public rssAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_rss_options' },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'Source', id: '_source', defaultVal: '-- Options --', ShowAsDetails: true },
    { name: '', id: '_def_source', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Font', id: '_font', ShowAsDetails: true },
    { name: 'Direction', id: '_direction', ShowAsDetails: true },
    { name: 'Rate', id: '_rate', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true }
  ];
  public textScrollAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_textscroll_options' },
    { name: 'Source', id: '_source', defaultVal: '-- Text Scroll --', ShowAsDetails: false, maxlength: 700 },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Font', id: '_font', defaultVal: 'Default', ShowAsDetails: true },
    // { name: 'Direction', id: '_direction', ShowAsDetails: true },
    { name: 'Rate', id: '_rate', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true },
    { name: 'FONT INSET', id: '_font_special', ControlType: 'checkbox', ShowAsDetails: true }
  ];
  public textMultilineAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_textmultiline_options' },
    { name: 'Name', id: '_name', ShowAsDetails: true },
    { name: 'Source', id: '_source', defaultVal: '-- Text Multiline --', ShowAsDetails: true },
    { name: 'X', id: '_x', ShowAsDetails: true },
    { name: 'Y', id: '_y', ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    { name: 'Background Color', id: '_txt_bkg_color', ShowAsDetails: true },
    { name: 'Background Transparency', id: '_txt_bkg_opacity', ShowAsDetails: true },
    { name: '', id: '_txt_opacity_label', ShowAsDetails: true },
    { name: 'Foreground Color', id: '_txt_font_color', ShowAsDetails: true },
    { name: 'Font', id: '_font', ShowAsDetails: true },
    { name: 'Font Size', id: '_font_size', ShowAsDetails: true }
  ];
  public youtubeAttributes = [
    // { name: 'Type', id: '_type' },
    { name: '', id: '_youtube_options' },
    { name: 'FullScreen', id: '_fullscreen', ControlType: 'checkbox', ShowAsDetails: false },
    { name: 'Name', id: '_name', ShowAsDetails: false },
    { name: '', id: '_search_youtube', ShowAsDetails: false },
    { name: 'Playlist ID', id: '_source', ShowAsDetails: false, maxlength: 700 },
    { name: 'X', id: '_x', default: 20, ShowAsDetails: true },
    { name: 'Y', id: '_y', default: 20, ShowAsDetails: true },
    { name: 'Width', id: '_width', ShowAsDetails: true },
    { name: 'Height', id: '_height', ShowAsDetails: true },
    {
      name: '', id: '_note', message: 'Note: Take the following steps to find your YouTube Channel ID:<br/>' +
        '1) Log into your YouTube account<br/>' +
        '2) Click on your profile image in the top right corner<br/>' +
        '3) Choose Settings in the menu<br/>' +
        '4) Click on the link: View advanced settings<br/>' +
        '5) You can copy your YouTube Channel ID on this page with the Copy button<br/><br/>Each video in the playlist must support embedded playback in order to play as part of the digital signage screen.', ShowAsDetails: true
    }
  ];
  public isPlayListAcitve = false;
  public playListItems = [];
  private allowPreview = false;
  ////////////
  // public fontOption = [
  //   '', 'Andale Mono', 'Addale Sans', 'Arial', 'Aurora Bold Condenced', 'Avenir-Pro',
  //   'Clearface Gothic', 'College', 'Copper', 'Copper Italic', 'Courier Bold', 'Courier Bold Italic',
  //   'DIN Alternate', 'DIN Condensed', 'DIN Office', 'DIN Office Black', 'DIN Office Black Italic', 'DIN Office Bold',
  //   'DIN Office Bold Italic', 'DIN Office Italic', 'DIN Office Light', 'DIN Office Light Italic', 'DIN Office Medium',
  //   'DOM Casual', 'DOM Casual Italic', 'DTV TG', 'DTV TG Italic', 'Frankfurt', 'Frutiger Italic', 'Frutiger Mono',
  //   'Frutiger Mono Italic', 'Frutiger Roman', 'Gotham Black', 'Gotham Bold', 'Gotham Medium', 'Helvetica',
  //   'Helvetica Narrow', 'Helvetica-Black-SemiBold', 'Kaufmann Bold', 'Kaufmann Bold Italic', 'Kefa', 'Minion Pro',
  //   'moderna', 'Nasalization', 'Open Sans', 'PresicavLt-Regular', 'PresicavRg-Regular', 'Smudgie Crayon',
  //   'Times Europa', 'Times Europa Italic'
  // ];
  public fontOption = [
    { value: 'Default', text: 'Default' }, { value: 'Arial', text: 'Arial' }, { value: 'Arial-Italic', text: 'Arial (w/ Italic)' },
    { value: 'Verdana', text: 'Verdana' }, { value: 'Georgia', text: 'Georgia' }, { value: 'Times New Roman', text: 'Times New Roman' },
    { value: 'Times New Roman-Italic', text: 'Times New Roman (w/ Italic)' },
    { value: 'Courier New', text: 'Courier New' }, { value: 'Courier New-Italic', text: 'Courier New (w/ Italic)' }
  ];
  public dateFormatOptions = [
    '', 'MM/DD/YYYY', 'MM/DD/YY', 'MMM DD YY', 'MMM DD YYYY', 'DD/MM/YYYY', 'DD/MM/YY', 'DD MMM YY', 'DD MMM YYYY'
  ];
  public timeFormatOptions = [
    '', '24h + seconds', '24h + no seconds', '12h + seconds + AMPM', '12h + seconds no AMPM',
    '12h no seconds + AMPM', ' 12h no seconds no AMPM'
  ];
  public directionOptions = [
    '', 'left-to-right', 'right-to-left'
  ];
  // public rateOption = [
  //   '', '1', '2', '3', '4', '5'
  // ];
  public rateOption = [
    { value: '', text: '' }, { value: '1', text: 'Slow ' }, { value: '2', text: 'Medium' }, { value: '3', text: 'Fast ' }
  ];
  public rssValueOptions = [
    { "title": "- Select -", "value": "" }
  ];
  // public timezoneOption = ['', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau'
  //   , 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta'
  //   , 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown'
  //   , 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum'
  //   , 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville'
  //   , 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru'
  //   , 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou'
  //   , 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak'
  //   , 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina'
  //   , 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis',
  //   'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan'
  //   , 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem'
  //   , 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise'
  //   , 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas'
  //   , 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao'
  //   , 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit'
  //   , 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador'
  //   , 'America/Fort_Nelson', 'America/Fortaleza'
  //   , 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk'
  //   , 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana'
  //   , 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis'
  //   , 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City'
  //   , 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica',
  //   'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Kralendijk', 'America/La_Paz'
  //   , 'America/Lima', 'America/Los_Angeles', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique'
  //   , 'America/Matamoros', 'America/Mazatlan', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton'
  //   , 'America/Monterrey', 'America/Montevideo', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/North_Dakota/Beulah'
  //   , 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo'
  //   , 'America/Phoenix', 'America/Port_of_Spain', 'America/Port-au-Prince', 'America/Porto_Velho'
  //   , 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet'
  //   , 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo'
  //   , 'America/Scoresbysund', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent'
  //   , 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto'
  //   , 'America/Tortola', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife',
  //   'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson',
  //   'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll'
  //   , 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr'
  //   , 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok'
  //   , 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Colombo', 'Asia/Damascus'
  //   , 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron'
  //   , 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka'
  //   , 'Asia/Karachi', 'Asia/Kathmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk'
  //   , 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qyzylorda', 'Asia/Riyadh'
  //   , 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent'
  //   , 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ulaanbaatar', 'Asia/Urumqi', 'Asia/Ust-Nera'
  //   , 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faroe',
  //   'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley'
  //   , 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla'
  //   , 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney'];

  public timezoneOption = [{ value: 'Default', text: 'Default' }, { value: 'America/New_York', text: 'America/Eastern' }
    , { value: 'America/New_York/DST', text: 'America/Eastern/DST' }, { value: 'America/Chicago', text: 'America/Central' }
    , { value: 'America/Chicago/DST', text: 'America/Central/DST' }, { value: 'America/Denver', text: 'America/Mountain' }
    , { value: 'America/Denver/DST', text: 'America/Mountain/DST' }, { value: 'America/Los_Angeles', text: 'America/Pacific' }
    , { value: 'America/Los_Angeles/DST', text: 'America/Pacific/DST' }, { value: 'Europe/Madrid', text: 'Europe/Madrid' }
    , { value: 'Europe/Madrid/DST', text: 'Europe/Madrid/DST' }, { value: 'Europe/London', text: 'Europe/London' }
    , { value: 'Europe/London/DST', text: 'Europe/London/DST' }, { value: 'Europe/Paris', text: 'Europe/Paris' }
    , { value: 'Europe/Paris/DST', text: 'Europe/Paris/DST' }, { value: 'Europe/Moscow', text: 'Europe/Moscow' }];

  public transitionOption = ['Image Wall', 'Dissolve', 'Slide from top', 'Slide from left', 'Slide from bottom', 'Slide from right', 'Open from top', 'Open from left', 'Open from bottom', 'Open from right', 'Open from center', 'Blinds from top', 'Blinds from left', 'Blinds from bottom', 'Blinds from right', 'Expand from top', 'Expand from left', 'Expand from bottom', 'Expand from right', 'Expand and rotate', 'All – sequential', 'All – random'];

  public channels: Array<any> = [{ channelId: 'Channel 0 ( Default )', channelValue: 0 }, { channelId: 'Channel 1', channelValue: 1 }, { channelId: 'Channel 2', channelValue: 2 }, { channelId: 'Channel 3', channelValue: 3 }, { channelId: 'Channel 4', channelValue: 4 }, { channelId: 'Channel 5', channelValue: 5 }, { channelId: 'Channel 6', channelValue: 6 }, { channelId: 'Channel 7', channelValue: 7 }, { channelId: 'Channel 8', channelValue: 8 }, { channelId: 'Channel 9', channelValue: 9 }];
  public myElement: Array<any> = [];

  ////////
  public shadowOffset = 20;
  public tween = null;
  public blockSnapSize = 30;
  public shadowRectangle: any;
  public gridLayer: any;
  public snapToEnabled = true;

  public gActiveScreenlistFile = 'dmb.screenlist.00.xml';  // 'dmb.screenlist.0.xml';
  public isScreenSaved = false;
  public savigFile = false;
  public subscriptionDetails: any;
  public isAddDaysView: boolean = false;

  @ViewChild('fileNameModel') private fileNameModel;
  @ViewChild('screenSettingsModal') private screenSettingsModal;
  @ViewChild('signPreviewModal') private signPreviewModal;
  @ViewChild('confirmResolutionChange') private confirmResolutionChange;
  @ViewChild('uploadImageModal') private uploadImageModal;
  @ViewChild('uploadVideoModal') private uploadVideoModal;
  @ViewChild('updateChannelModal') private updateChannelModal;
  @ViewChild('screenShotModal') private screenShotModal;
  @ViewChild('logWebModal') private logWebModal;
  @ViewChild('updateChannelLineupModal') private updateChannelLineupModal;
  @ViewChild('publishServerModal') private publishServerModal;
  @ViewChild('publishToPlayerModal') private publishToPlayerModal;
  @ViewChild('viewSelectPlayersModal') private viewSelectPlayersModal;
  @ViewChild('playerRegistrationModal') private playerRegistrationModal;
  @ViewChild('invalidPlayerIdModal') private invalidPlayerIdModal;
  @ViewChild('editPlayerModal') private editPlayerModal;
  @ViewChild('editScreenModal') private editScreenModal;
  @ViewChild('playerStatusModal') private playerStatusModal;
  @ViewChild('timeOfDayModal') private timeOfDayModal;
  @ViewChild('previewScreenListModal') private previewScreenListModal;
  @ViewChild('viewScreenshotModal') private viewScreenshotModal;
  @ViewChild('deleteImageModal') private deleteImageModal;
  @ViewChild('deleteAudioModal') private deleteAudioModal;
  @ViewChild('deleteVideoModal') private deleteVideoModal;
  @ViewChild('searchYoutubeModal') private searchYoutubeModal;
  @ViewChild('dmbTVModel') private dmbTVModel;
  @ViewChild('accountSubscriptionModal') private accountSubscriptionModal;
  @ViewChild('noSubscriptionModal') private noSubscriptionModal;

  private screenSettingsModalObj;
  public mediaUrl: any = null;
  public previewUrl = null;
  public filePath = null;
  public counter = 0;
  public username = null;
  public userIdleTime = 0;
  public currentTime = new Date;
  userInactive: Subject<any> = new Subject();

  public accountDaysRemaining = 0;

  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private screenService: ScreenService,
    private registrationService: RegistrationService,
    private spinnerService: Ng4LoadingSpinnerService,
    private data: DataService,
    public sanitizer: DomSanitizer,
    private elRef: ElementRef,
    private userService: UserService,
    private appSettings: AppSettingsService,
    private subscriptionService: SubscriptionService) {
    this.mediaUrl = this.appSettings.getConfig('MEDIA_URL');
    this.previewUrl = this.appSettings.getConfig('PREVIEW_URL');
    this.filePath = this.appSettings.getConfig('FILE_PATH') + this.authService.currentUser.userName;
    this.username = this.authService.currentUser.userName;
    this.data.currentFile.subscribe(fileName => {
      if (fileName !== '' && fileName !== null) {
        this.load_screenlist(fileName);
      }
    });
    (<any>window).ReceivePlayListID = this.ReceivePlayListID.bind(this);
  }
  // userActivity:any;
  // userInactive: Subject<any> = new Subject();
  //  checkUserIdle() {
  //   this.counter  =0;
  //   //start timer

  //   // setTimeout(function() {

  //  setInterval(()=>{
  //   this.counter = this.counter +1;
  //   //alert(this.counter);
  //  if(this.counter == 50)
  //  {
  //    this.counter =0;
  //    this.onLogout();
  //  }
  // }, 10000);
  // },1000);

  //debugger;
  // this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3000);
  //}

  //userActivity:any;


  public imageUploadconfig = {
    // Change this to your upload POST address:
    url: this.appSettings.getConfig('API_ENDPOINT') + 'upload',
    //maxFilesize: 50,
    maxFiles: 2,
    parallelUploads: 2,
    acceptedFiles: 'image/*',
    // init: function () {
    //   this.on("thumbnail", function (file) {
    //     file.acceptDimensions();
    //   });
    // },
    // accept: function (file, done) {
    //   file.acceptDimensions = done;
    //   file.rejectDimensions = function () {
    //     //done("The maximum image file upload resolution is 1920x1080"); 
    //     ng.authService.showNotification('', 'The maximum image file upload <br/> resolution is 1920x1080', 'error');
    //     ng.closeModal();
    //   };
    // },
    // transformFile: function (file, done) {
    //   const width = file.width;
    //   const height = file.height;

    //   if(this.gActiveResolution === '1080x1920') {
    //     // (a) Resize if width > 1080px AND height > 1920px
    //     if (width > 1080 && height > 1920) {
    //       return this.resizeImage(file, 1080, 1920, 'contain', done);
    //     }
    //     // (b) Upload as-is if width <= 1920px AND height <= 1080px
    //     else if (width <= 1080 && height <= 1920) {
    //       return done(file); // Proceed without resizing
    //     }
    //     // (c) Reject if width > 1920px AND height < 1080px
    //     else if (width > 1080 && height < 1920) {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //     // (d) Reject if height > 1080px AND width < 1920px
    //     else if (height > 1920 && width < 1080) {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //     else {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //   } else {

    //     // (a) Resize if width > 1920px AND height > 1080px
    //     if (width > 1920 && height > 1080) {
    //       return this.resizeImage(file, 1920, 1080, 'contain', done);
    //     }
    //     // (b) Upload as-is if width <= 1920px AND height <= 1080px
    //     else if (width <= 1920 && height <= 1080) {
    //       return done(file); // Proceed without resizing
    //     }
    //     // (c) Reject if width > 1920px AND height < 1080px
    //     else if (width > 1920 && height < 1080) {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //     // (d) Reject if height > 1080px AND width < 1920px
    //     else if (height > 1080 && width < 1920) {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //     else {
    //       ng.authService.showNotification('', 'Please re-size the image before uploading', 'error');
    //       return this.removeFile(file);
    //     }
    //   }
    // },
    success: function (response) {
      var jsonresp = JSON.parse(response.xhr.response);
      if (jsonresp.status === 'error') {
        ng.authService.showNotification('', jsonresp.message, 'error');
      }
      else {
        ng.authService.showNotification('', 'Images uploaded successfully', 'success');
      }
    }
  };

  public videoUploadconfig = {
    // Change this to your upload POST address:
    url: this.appSettings.getConfig('API_ENDPOINT') + 'upload',
    // maxFilesize: 24,
    // acceptedFiles: 'video/*'
    maxFiles: 1,
    parallelUploads: 1,
    acceptedFiles: 'video/mp4, video/quicktime, video/3gp, video/3gpp, .3gp, .mp3',
    init: function () {
      // this.on("maxfilesexceeded", function(file){
      //   this.removeAllFiles();
      //   ng.authService.showNotification('', 'Cannot upload more than 3 files together', 'error');
      // });
      this.on("addedfile", function (file) {
        if (this.files[1] != null) {
          this.removeAllFiles();
          // ng.authService.showNotification('', 'Cannot upload more than 2 <br/> files together', 'error');
          ng.authService.showNotification('', 'Upload only one file at a time', 'error');
          ng.closeModal();
        } else if (parseFloat((file.size / (1024 * 1024)).toFixed(2)) > 80) {
          this.removeAllFiles();
          ng.authService.showNotification('', 'The maximum audio/video file <br/> upload size is 80MB', 'error');
          ng.closeModal();
        }
      });
    },
    success: function (response) {
      var jsonresp = JSON.parse(response.xhr.response);
      if (jsonresp.status === 'error') {
        ng.authService.showNotification('', jsonresp.message, 'error');
      }
      else {
        ng.authService.showNotification('', 'Files uploaded successfully', 'success');
      }
    }
  };

  public currentAssets = [];  // the current (active) list of assets currently on the stage (note: this is a javascript object not array)
  public currentAssetsAnchors: Array<any> = []; // the current list of assets' 'Anchors' that are used to resize the assets

  public configStage = Observable.of({
    width: this.stageWidth,
    height: this.stageHeight
  });
  private imageSliderLoaded = false;
  private videoSliderLoaded = false;
  public isSavingFile = false;
  public isRegisterPlayer = false;
  private color_picker_canvas;
  private modalRef;

  public isSavingpreviewEndPoint = false;
  public isSavingContentServer = false;
  public isSavingEzTvServer = false;
  private registeredPlayers: Array<any> = [];
  public currentTimeOfDay: any;
  public currentRules: any = [];
  public currentRule: any;
  private playerStatusObject;
  private players;
  pipe = new DatePipe('en-US');
  public ngOnInit() {
    this.authService.currentUserObj.subscribe(res => {
      if (res === 'string') {
        this.currentUser = JSON.parse(res);
        // console.log(res);
      } else {
        this.currentUser = res;
      }
      // console.log('user aupdate');
      // console.log(this.currentUser);
      // console.log('====================================');
    });

    ng = this;

    document.addEventListener('mousemove', function (this) {

      ng.resetUserIdleTime();
    });



    document.addEventListener('mousewheel', function (this) {
      ng.resetUserIdleTime();
    });

    document.addEventListener('click', function (this) {

      ng.resetUserIdleTime();
    });

    document.addEventListener('keypress', function (this) {
      ng.resetUserIdleTime();
    });

    document.addEventListener('mouseover', function () {
      ng.mousein = true;
      ng.resetUserIdleTime();
    })

    this.checkUserIdleTime();

    this.shadowRectangle = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.blockSnapSize * 6,
      height: this.blockSnapSize * 3,
      fill: '#FF7B17',
      opacity: 0.6,
      stroke: '#CF6412',
      strokeWidth: 3,
      dash: [20, 2]
    });

    document.getElementById('full-hd').classList.add('hd');
    this.stage = new Konva.Stage({
      container: 'canvasContainer',
      width: this.stageWidth,
      height: this.stageHeight
    });
    const gridLayer = this.createGridLayer();
    this.stage.add(gridLayer);
    this.layer = new Konva.Layer();

    this.shadowRectangle.hide();
    this.layer.add(this.shadowRectangle);

    // console.log(this.stage);
    this.stage.add(this.layer);

    // create color picker
    const canvasBgInput = document.getElementById('bkg_color');
    this.color_picker_canvas = new jscolor(canvasBgInput, {
      valueElement: null
    });
    this.color_picker_canvas.onFineChange = function () {
      // console.log('bkg_color')
      ng.updateColor(ng.color_picker_canvas, 'bkg_color');
    };
    this.color_picker_canvas.fromRGB(255, 255, 255);
    this.getUserList();
    this.getCurrentUserServers();
    this.getUserRoleList();
    this.TogglePlayerRegistrationLink();

    this.username = this.authService.currentUser.userName;
    if (this.username) {
      this.subscriptionService.getSubscriptionDetails(this.username).subscribe(
        (response) => {
          if (response && response.data) {

            if(response.status === 'error') {
              this.accountDaysRemaining = 0;
              $(".navAccountDaysValidation").hide();
              this.openModel(this.noSubscriptionModal, { size: 'lg' });
            } else {

              this.accountDaysRemaining = response.data.accountDaysRemaining;
              if(this.accountDaysRemaining <= 0) {
                  $(".navAccountDaysValidation").hide();
                  this.openModel(this.noSubscriptionModal, { size: 'lg' });
              }
            }
          } else {
            this.accountDaysRemaining = 0;
            $(".navAccountDaysValidation").hide();
            this.openModel(this.noSubscriptionModal, { size: 'lg' });
          }
        },
        (error) => {
          this.accountDaysRemaining = 0;
          $(".navAccountDaysValidation").hide();
          this.openModel(this.noSubscriptionModal, { size: 'lg' });
        }
      );
    }
    
    $("#signResolution").selectpicker();
  }

  checkUserIdleTime() {
    setInterval(function () {
      var now = new Date(); // poll new current time
      var second = ((now.getTime() / 1000) - (ng.currentTime.getTime() / 1000))
      //console.log(second);        
      //ng.userIdleTime++;
      if (second >= 1200) {
        ng.onLogout();
      }
    }, 1000);
  }

  resetUserIdleTime() {
    // ng.userIdleTime = 0;
    ng.currentTime = new Date();
  }


  changeCanvasColor(): void {
    // console.log(this.color);
  }

  onDragStart(ev): void {
    ev.dataTransfer.setData('text', ev.target.id);
    // console.log('onDragStart');
  }

  onDragEnd(ev): void {
    // console.log('onDragEnd');
    ev.preventDefault();  // prevent the browser default handling of the data (default is open as link on drop)
    const data = ev.dataTransfer.getData('text');
    ev.target.appendChild(document.getElementById(data));
  }

  allowDrop(ev): void {
    ev.preventDefault();  // prevent  the browser default handling of the data (default is open as link on drop)
  }

  /* --------------------------------------------------------------------------------------------------------------------- */
  /* This function drops a new image (copy) onto the target AND DOES NOT removes the image from the 'old' location */

  /* --------------------------------------------------------------------------------------------------------------------- */
  dropcopy(ev): void {
    ev.preventDefault();  // prevent the browser default handling of the data (default is open as link on drop)
    const data = ev.dataTransfer.getData('Text');
    const original = document.getElementById(data) as HTMLInputElement;
    if (this.gActiveResolution === '1920x1080') {
      if (original.id === 'image') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false);
      } else if (original.id === 'video') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 1000, 600, 30, 30, false);
      } else if (original.id === 'text') {
        // this.add_new_asset(original.id, original.src, 350, 65, 20, 20, false); // id, source, width, height, x, y
        this.add_new_asset(original.id, 'Text', 1900, 100, 10, 850, false); // id, source, width, height, x, y
      } else if (original.id === 'browser') {
        this.add_new_asset(original.id, original.src, 600, 600, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'channel_number') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'text_crawl') {
        this.add_new_asset(original.id, 'Text Scroll', 1900, 100, 10, 850, false); // id, source, width, height, x, y
      } else if (original.id === 'clock') {
        this.add_new_asset(original.id, original.src, 500, 200, 30, 30, false); // id, source, width, height, x, y
      } else if (original.id === 'rss') {
        this.add_new_asset(original.id, original.src, 1170, 65, 60, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'overlay') {
        this.add_new_asset(original.id, original.src, 150, 150, 35, 35, false); // id, source, width, height, x, y
      } else if (original.id === 'text_multiline') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'youtube') {
        this.add_new_asset(original.id, original.src, 1000, 600, 30, 30, false); // id, source, width, height, x, y
      }
    } else if (this.gActiveResolution === '1080x1920') {
      if (original.id === 'image') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 200, 200, 20, 20, false);
      } else if (original.id === 'video') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false);
      } else if (original.id === 'text') {
        // this.add_new_asset(original.id, original.src, 350, 65, 20, 20, false); // id, source, width, height, x, y
        this.add_new_asset(original.id, 'Text', 1060, 75, 10, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'browser') {
        this.add_new_asset(original.id, original.src, 450, 450, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'channel_number') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'text_crawl') {
        this.add_new_asset(original.id, 'Text Scroll', 1060, 75, 10, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'clock') {
        this.add_new_asset(original.id, original.src, 400, 100, 30, 30, false); // id, source, width, height, x, y
      } else if (original.id === 'rss') {
        this.add_new_asset(original.id, original.src, 1170, 65, 60, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'overlay') {
        this.add_new_asset(original.id, original.src, 150, 150, 35, 35, false); // id, source, width, height, x, y
      } else if (original.id === 'text_multiline') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'youtube') {
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false); // id, source, width, height, x, y
      }
    } else {
      if (original.id === 'image') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 200, 200, 20, 20, false);
      } else if (original.id === 'video') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false);
      } else if (original.id === 'text') {
        // this.add_new_asset(original.id, original.src, 350, 65, 20, 20, false); // id, source, width, height, x, y
        this.add_new_asset(original.id, 'Text', 1260, 75, 10, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'browser') {
        this.add_new_asset(original.id, original.src, 450, 450, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'channel_number') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'text_crawl') {
        this.add_new_asset(original.id, 'Text Scroll', 1260, 75, 10, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'clock') {
        this.add_new_asset(original.id, original.src, 400, 100, 30, 30, false); // id, source, width, height, x, y
      } else if (original.id === 'rss') {
        this.add_new_asset(original.id, original.src, 1170, 65, 60, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'overlay') {
        this.add_new_asset(original.id, original.src, 150, 150, 35, 35, false); // id, source, width, height, x, y
      } else if (original.id === 'text_multiline') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'youtube') {
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false); // id, source, width, height, x, y
      }
    }
  }

  onAssetDoubleClick(ev) {
    ev.preventDefault();
    const original = ev.target;

    if (this.gActiveResolution === '1920x1080') {
      if (original.id === 'image') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false);
      } else if (original.id === 'video') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 1000, 600, 30, 30, false);
      } else if (original.id === 'text') {
        // this.add_new_asset(original.id, original.src, 350, 65, 20, 20, false); // id, source, width, height, x, y
        this.add_new_asset(original.id, 'Text', 1900, 100, 10, 850, false); // id, source, width, height, x, y
      } else if (original.id === 'browser') {
        this.add_new_asset(original.id, original.src, 600, 600, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'channel_number') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'text_crawl') {
        this.add_new_asset(original.id, 'Text Scroll', 1900, 100, 10, 850, false); // id, source, width, height, x, y
      } else if (original.id === 'clock') {
        this.add_new_asset(original.id, original.src, 500, 200, 30, 30, false); // id, source, width, height, x, y
      } else if (original.id === 'rss') {
        this.add_new_asset(original.id, original.src, 1170, 65, 60, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'overlay') {
        this.add_new_asset(original.id, original.src, 150, 150, 35, 35, false); // id, source, width, height, x, y
      } else if (original.id === 'text_multiline') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'youtube') {
        this.add_new_asset(original.id, original.src, 1000, 600, 30, 30, false); // id, source, width, height, x, y
      }
    }
    else {
      if (original.id === 'image') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 200, 200, 20, 20, false);
      } else if (original.id === 'video') {
        // this.add_new_asset(original.id, original.src, original.dataset.width, original.dataset.height, 20, 20, false);
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false);
      } else if (original.id === 'text') {
        // this.add_new_asset(original.id, original.src, 350, 65, 20, 20, false); // id, source, width, height, x, y
        this.add_new_asset(original.id, 'Text', 1260, 75, 10, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'browser') {
        this.add_new_asset(original.id, original.src, 450, 450, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'channel_number') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'text_crawl') {
        this.add_new_asset(original.id, 'Text Scroll', 1260, 75, 10, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'clock') {
        this.add_new_asset(original.id, original.src, 400, 100, 30, 30, false); // id, source, width, height, x, y
      } else if (original.id === 'rss') {
        this.add_new_asset(original.id, original.src, 1170, 65, 60, 600, false); // id, source, width, height, x, y
      } else if (original.id === 'overlay') {
        this.add_new_asset(original.id, original.src, 150, 150, 35, 35, false); // id, source, width, height, x, y
      } else if (original.id === 'text_multiline') {
        this.add_new_asset(original.id, original.src, 300, 300, 20, 20, false); // id, source, width, height, x, y
      } else if (original.id === 'youtube') {
        this.add_new_asset(original.id, original.src, 600, 400, 30, 30, false); // id, source, width, height, x, y
      }
    }
  }

  add_new_asset(assetType, url, w, h, x, y, reopen, assetReObj?: any): void {
    if (typeof assetReObj === 'undefined') {
      assetReObj = {};
    }

    var aCount = 0;
    var browserCount = 0;
    var clockCount = 0;

    for (const key in this.currentAssets) {
      aCount++;
    }
    if (aCount === 5) {
      this.authService.showNotification('Error', 'A screen is permitted up to five assets only', 'error');
      return;
    }

    for (const key in this.currentAssets) {
      if (this.currentAssets[key].Type === 'browser')
        browserCount++;
    }
    if (assetType === 'browser' && browserCount === 4) {
      this.authService.showNotification('Error', 'A screen is permitted up to <br/> four browser assets only', 'error');
      return;
    }
    for (const key in this.currentAssets) {
      if (this.currentAssets[key].Type === 'clock')
        clockCount++;
    }
    if (assetType === 'clock' && clockCount === 4) {
      this.authService.showNotification('Error', 'A screen is permitted up to <br/> four clock assets only', 'error');
      return;
    }

    if (assetType === 'video' || assetType === 'youtube') {
      for (const key in this.currentAssets) {
        if (this.currentAssets[key].Type === 'video' || this.currentAssets[key].Type === 'youtube') {
          this.authService.showNotification('Error', 'A screen is permitted only one <br/> Video or YouTube asset', 'error');
          return;
        }
      }
    }

    if (assetType === 'clock') {
      for (const key in this.currentAssets) {
        if (this.currentAssets[key].Type === 'image' && this.currentAssets[key].playlist) {
          this.authService.showNotification('Error', 'There is a image playlist on the screen. <br/> Adding a clock asset is not permitted', 'error');
          return;
        }
      }
    }

    const asset_id = this.ramdomid();  // get an id for this new asset
    let assetGroup;
    let assetObj;

    var aFontFamily = typeof assetReObj.font !== 'undefined' && assetReObj.font !== null
      && assetReObj.font !== '' ? assetReObj.font.replace('-Italic', '') : 'Calibri';
    var afontStyle = typeof assetReObj.font !== 'undefined' && assetReObj.font !== null
      && assetReObj.font.includes('-Italic') ? 'Italic' : 'Normal';
    var afontSize = typeof assetReObj.font_size !== 'undefined' && assetReObj.font !== null
      && assetReObj.font_size !== '' ? assetReObj.font_size :
      assetType === 'text' || assetType === 'text_crawl' ? 40 : 30;

    if (assetType === 'image') {
      let imgSrc = (assetType === 'video') ? 'assets/img/video_skewed.png' : url;
      if (reopen && (assetReObj.source === null || assetReObj.source === "")) {
        imgSrc = 'assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png';
      }
      const imageObj1 = new Image();
      assetObj = new Konva.Image({
        width: w,
        height: h,
        image: imageObj1,
        id: asset_id
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);

      imageObj1.onload = function () {
        assetObj.image(imageObj1);
        ng.layer.draw();
      };
      imageObj1.src = imgSrc;

    } else if (assetType === 'video') {
      const imgSrc = (reopen && assetType === 'video' && url.split('.').pop().toLowerCase() === 'mp3') ? 'assets/img/Audio-Circle-Icon-1920x1080.png'
        : 'assets/img/video_skewed.png';

      const imageObj1 = new Image();
      assetObj = new Konva.Image({
        width: w,
        height: h,
        image: imageObj1,
        id: asset_id,
        fill: '#a31627'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);

      imageObj1.onload = function () {
        assetObj.image(imageObj1);
        ng.layer.draw();
      };
      imageObj1.src = imgSrc;

    } else if (assetType === 'text') {
      // console.log(url);
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = url;
      if (reopen && assetType === 'text') {
        textSource = url;
      }
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        //offsetY: this.gActiveResolution === '1920x1080' ? 0 - (((assetObj.getHeight()) / 2) - 21) : 0 - (((assetObj.getHeight()) / 2) - 19),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: afontSize,
        fontFamily: aFontFamily,
        fontStyle: afontStyle,
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetObjText.offsetY(assetObjText.getHeight() / 2 - assetObj.getHeight() / 2);
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'browser') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      const textSource = 'Browser';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: 0 - (((assetObj.getHeight()) / 2) - 17),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: 30,
        fontFamily: 'Calibri',
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'channel_number') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = 'Channel Number';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: 0 - (((assetObj.getHeight()) / 2) - 17),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: 30,
        fontFamily: 'Calibri',
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'clock') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = 'Clock';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: this.gActiveResolution === '1920x1080' ? 0 - (((assetObj.getHeight()) / 2) - 10) : 0 - (((assetObj.getHeight()) / 2) - 12),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: afontSize,
        fontFamily: aFontFamily,
        fontStyle: afontStyle,
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'rss') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = 'RSS';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: 0 - (((assetObj.getHeight()) / 2) - 17),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: 30,
        fontFamily: 'Calibri',
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'overlay') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = 'Overlay';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: 0 - (((assetObj.getHeight()) / 2) - 17),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: 30,
        fontFamily: 'Calibri',
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'text_multiline') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      let textSource = 'Text Multiline';
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: 0 - (((assetObj.getHeight()) / 2) - 17),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: 30,
        fontFamily: 'Calibri',
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } else if (assetType === 'text_crawl') {
      assetObj = new Konva.Rect({
        width: w,
        height: h,
        stroke: '#666',
        fill: 'black',
        strokeWidth: 2,
        name: asset_id,
        id: asset_id
      });
      // let textSource = 'Text Scroll';
      let textSource = url;
      if (reopen && assetType === 'text_crawl') {
        textSource = url;
      }
      textSource = textSource.length > 20 ? textSource.substring(0, 20) + '...' : textSource;
      const assetObjText = new Konva.Text({
        x: 0,
        y: 0,
        offsetY: this.gActiveResolution === '1920x1080' ? 0 - (((assetObj.getHeight()) / 2) - 21) : 0 - (((assetObj.getHeight()) / 2) - 19),
        width: assetObj.getWidth(),
        text: textSource,
        fontSize: afontSize,
        fontFamily: aFontFamily,
        fontStyle: afontStyle,
        fill: 'white',
        align: 'center',
        name: asset_id + '-Text',
        id: asset_id + '-Text'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      assetGroup.add(assetObjText);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);
      this.layer.draw();
    } if (assetType === 'youtube') {
      const imgSrc = (assetType === 'youtube') ? 'assets/img/video_skewed.png' : url;

      const imageObj1 = new Image();
      assetObj = new Konva.Image({
        width: w,
        height: h,
        image: imageObj1,
        id: asset_id,
        fill: '#a31627'
      });
      assetGroup = new Konva.Group({
        x: x,
        y: y,
        draggable: true,
        id: asset_id + '-Group',
        dragBoundFunc: function (pos) {
          return ng.restrictDragWithinStage(pos, assetObj.width(), assetObj.height(), asset_id, this.getAbsolutePosition());
        }
      });
      assetGroup.setAttr('asset_type', assetType);
      this.layer.add(assetGroup);
      assetGroup.add(assetObj);
      const lW = (parseInt(w, 0) - 10);
      const lH = (parseInt(h, 0) - 10);
      this.addAnchor(assetGroup, 0, 0, 'topLeft-' + asset_id);
      this.addAnchor(assetGroup, lW, 0, 'topRight-' + asset_id);
      this.addAnchor(assetGroup, lW, lH, 'bottomRight-' + asset_id, true);
      this.addAnchor(assetGroup, 0, lH, 'bottomLeft-' + asset_id);

      imageObj1.onload = function () {
        assetObj.image(imageObj1);
        ng.layer.draw();
      };
      imageObj1.src = imgSrc;
    }
    assetGroup.attrs._assetId = asset_id;
    assetGroup.attrs.name = (reopen && (assetReObj.name !== null || assetReObj.name !== "")) ? assetReObj.name : asset_id;
    this.myElement.push(assetGroup);
    this.show_attributes(assetType, asset_id);

    // when the user 'mouses' over the asset
    assetGroup.on('mouseenter', function () {
      document.body.style.cursor = 'pointer';
    });

    // when the user 'mouses' away from the asset
    assetGroup.on('mouseleave', function () {
      document.body.style.cursor = 'default';
    });

    // when the asset is clicked .....
    assetGroup.on('click', function () {
      // console.log(asset_id);
      ng.show_attributes(this.getAttr('asset_type'), asset_id);    // show image attributes
      //ng.currentAssets[asset_id].playlist = false;
      ng.newAssetClicked(this, asset_id);
    });

    assetGroup.on('mousedown', function () {
      // console.log(asset_id);
      ng.setCurrentActiveAsset(assetGroup);
    });

    // when the asset is moved ...
    assetGroup.on('dragmove', function () {
      if (asset_id === ng.activeAssetId) {
        // make sure the user first 'clicks' the asset before dragging it on the stage
        ng.updateStats(this, asset_id);
      }
      if (ng.snapToEnabled) {
        // console.log('J')
        const assRect = assetGroup.getClientRect();
        ng.shadowRectangle.height(parseInt(assRect.height + 10));
        ng.shadowRectangle.width(parseInt(assRect.width + 10));
        ng.shadowRectangle.position({

          x: Math.round(assetGroup.x() / ng.blockSnapSize) * ng.blockSnapSize,
          y: Math.round(assetGroup.y() / ng.blockSnapSize) * ng.blockSnapSize
        });
        ng.stage.batchDraw();
      }
      if (assetType === 'browser') {
        ng.hideBrowserFrame(asset_id);
      }
    });

    assetGroup.on('dragstart', (e) => {
      if (ng.snapToEnabled) {
        // ng.shadowRectangle.show();
        // ng.shadowRectangle.moveToTop();
      }
      //assetGroup.moveToTop();
    });

    assetGroup.on('dragend', (e) => {
      if (ng.snapToEnabled) {


        assetGroup.position({
          x: Math.round(assetGroup.x() / ng.blockSnapSize) * ng.blockSnapSize,
          y: Math.round(assetGroup.y() / ng.blockSnapSize) * ng.blockSnapSize
        });
        this.isObjectMoved = true;
        // alert(this.isObjectMoved);
        this.widthValue = ng.stage.findOne('#' + asset_id).getWidth();
        this.heightValue = ng.stage.findOne('#' + asset_id).getHeight();
        //this.xValue =  assetGroup.x();
        // this.yValue = assetGroup.y();

        this.xValue = Math.round(assetGroup.x() / ng.blockSnapSize) * ng.blockSnapSize;
        this.yValue = Math.round(assetGroup.y() / ng.blockSnapSize) * ng.blockSnapSize;
        // alert(Math.round(assetGroup.x() / ng.blockSnapSize) * ng.blockSnapSize);
        // alert(Math.round(assetGroup.y() / ng.blockSnapSize) * ng.blockSnapSize);
        ng.stage.batchDraw();
        ng.shadowRectangle.hide();
      }
      //ng.repositionBrowserFrame(this, asset_id);
    });

    // show the initial coordinate values
    if (document.getElementById(asset_id + '_x') != null) {
      (<HTMLInputElement>document.getElementById(asset_id + '_x')).value = x;
      (<HTMLInputElement>document.getElementById(asset_id + '_y')).value = y;
      (<HTMLInputElement>document.getElementById(asset_id + '_width')).value = w;
      (<HTMLInputElement>document.getElementById(asset_id + '_height')).value = h;
    }

    // by default, make the asset just added to the stage the active one
    this.activeImageParent = assetObj.getParent();
    if (reopen !== true) {
      this.show_assets(assetType);
    }

    // set the global var for the asset id to the one just selected
    this.activeAssetId = asset_id;

    // const opacityMapping = {
    //   0: 0,
    //   26: 0.1,
    //   51: 0.2,
    //   77: 0.3,
    //   102: 0.4,
    //   128: 0.5,
    //   153: 0.6,
    //   179: 0.7,
    //   204: 0.8,
    //   230: 0.9,
    //   255: 1.0
    // };

    const opacityMapping = {
      255: 0,
      230: 0.1,
      204: 0.2,
      179: 0.3,
      153: 0.4,
      128: 0.5,
      102: 0.6,
      77: 0.7,
      51: 0.8,
      26: 0.9,
      0: 1
    };

    // add this new asset to the list of current assets on the stage (note that this is a js object not an array)
    const aUrl = url.split('/');
    var default_font_size = '30';
    if (assetType === 'clock')
      default_font_size = '30';
    else if (assetType === 'text' || assetType === 'text_crawl')
      default_font_size = '40';
    else
      default_font_size = '30';

    var isfullscreen = false;
    if (reopen && this.gActiveResolution.split('x')[0].toString() === w.toString() && this.gActiveResolution.split('x')[1].toString() === h.toString()) {
      isfullscreen = true;
    }

    this.currentAssets[asset_id] = {
      'Type': assetType,
      'Name': (reopen && (assetReObj.name !== null || assetReObj.name !== "")) ? assetReObj.name : asset_id,
      'Source': assetReObj.source ? assetReObj.source : (reopen === true ? aUrl[aUrl.length - 1] : ''),
      'full_screen': isfullscreen,
      'border': (reopen && (assetReObj.border !== null || assetReObj.border !== "")) ? assetReObj.border : "No",
      'X': x,
      'Y': y,
      'Width': w,
      'Height': h,
      'background_color': assetReObj.background_color,
      'opacity': typeof assetReObj.opacity !== 'undefined' ? opacityMapping[parseInt(assetReObj.opacity)] : 0,
      'font_color': assetReObj.font_color,
      'time_zone': (typeof assetReObj.time_zone !== 'undefined' ? assetReObj.time_zone : 'America/New_York'),
      'time_format': (typeof assetReObj.time_format !== 'undefined' ? assetReObj.time_format : '12h no seconds + AMPM'),
      'date_format': (typeof assetReObj.date_format !== 'undefined' ? assetReObj.date_format : 'MM/DD/YY'),
      'direction': (typeof assetReObj.direction !== 'undefined' ? assetReObj.direction : ''),
      'Rate': (typeof assetReObj.rate !== 'undefined' ? assetReObj.rate : ''),
      'Font': (typeof assetReObj.font !== 'undefined' && assetReObj.font !== '' ? assetReObj.font : 'Default'),
      'font_size': (typeof assetReObj.font_size !== 'undefined' ? assetReObj.font_size : default_font_size),
      'font_special': (typeof assetReObj.font_special !== 'undefined' ? assetReObj.font_special : false),
      'RefreshInterval': (typeof assetReObj.refresh_interval !== 'undefined' ? assetReObj.refresh_interval : ''),
    };
    this.applyColor(asset_id, '_txt_bkg_color', assetReObj.background_color);
    this.changeOpacity(opacityMapping[parseInt(assetReObj.opacity)], asset_id);
    this.applyColor(asset_id, '_txt_font_color', assetReObj.font_color);
    try {

      (<HTMLInputElement>document.getElementById(asset_id + '_name')).value = this.currentAssets[asset_id].Name;

    } catch (error) {

    }
    if (reopen && assetType === 'clock') {
      (<HTMLInputElement>document.getElementById(asset_id + '_date_format')).value = this.currentAssets[asset_id].date_format;
      (<HTMLInputElement>document.getElementById(asset_id + '_time_format')).value = this.currentAssets[asset_id].time_format;
      (<HTMLInputElement>document.getElementById(asset_id + '_time_zone')).value = this.currentAssets[asset_id].time_zone;
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (reopen && assetType === 'rss') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_direction')).value = this.currentAssets[asset_id].direction;
      (<HTMLInputElement>document.getElementById(asset_id + '_rate')).value = this.currentAssets[asset_id].Rate;
      (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
      this.currentAssets[asset_id].source = assetReObj.source;
      (<HTMLInputElement>document.getElementById(asset_id + '_def_source')).value = assetReObj.source;
    }
    if (reopen && assetType === 'browser') {
      (<HTMLInputElement>document.getElementById(asset_id + '_refresh_interval')).value = this.currentAssets[asset_id].RefreshInterval;
      (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
    }
    if (reopen && assetType === 'text_crawl') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      // (<HTMLInputElement>document.getElementById(asset_id + '_direction')).value = this.currentAssets[asset_id].direction;
      (<HTMLInputElement>document.getElementById(asset_id + '_rate')).value = this.currentAssets[asset_id].Rate;
      (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (reopen && assetType === 'text_multiline') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (reopen && (assetType === 'image' || assetType === 'video') && assetReObj.playlist) {
      // console.log(assetReObj);
      this.currentAssets[asset_id].playlist = assetReObj.playlist;
      this.currentAssets[asset_id].file_name = assetReObj.file_name;
      this.currentAssets[asset_id].playlist_items = assetReObj.playlist_items;
      //(<HTMLInputElement>document.getElementById(asset_id + '_playlist')).value = this.currentAssets[asset_id].playlist;
      if (this.currentAssets[asset_id].playlist) {
        this.isPlayListAcitve = true;
        const playListChkBox = (<HTMLInputElement>document.getElementById(asset_id + '_playlist'));
        playListChkBox.checked = true;
        $('.attr_hidden').show();
        $('#sortable').html('');
        // /addItemToPlayList
        if (this.currentAssets[asset_id].playlist_items !== null) {
          this.currentAssets[asset_id].playlist_items.forEach((item, itemIndex) => {
            this.addItemToPlayList(item.name, item.type, item.assetUrl);
            // console.log('add new PlayList item' + item.name);
            const _asset_src = (item.asset_src === null) ? item.name : item.asset_src;
            // this.createPlayListItem(itemIndex, _asset_src, item.type, item.assetUrl);
          });
        }
        this.show_assets(assetType);
        if (assetType === 'image') {
          setTimeout(function () {
            ng.playListUpdate();
          }, 2000);
        }
      }
      if (assetType === 'image') {
        this.currentAssets[asset_id].item_duration = assetReObj.item_duration;
        this.currentAssets[asset_id].transtion = assetReObj.transtion;
        this.currentAssets[asset_id].image_wall = assetReObj.transition === 'image_wall' ? true : false;
        (<HTMLInputElement>document.getElementById(asset_id + '_item_duration')).value = this.currentAssets[asset_id].item_duration;
        //(<HTMLInputElement>document.getElementById(asset_id + '_transtion')).value = this.currentAssets[asset_id].transtion;
        (<HTMLInputElement>document.getElementById(asset_id + '_image_wall')).checked = this.currentAssets[asset_id].image_wall;
      }
      if (assetType === 'video') {
        this.currentAssets[asset_id].item_duration = assetReObj.item_duration;
        (<HTMLInputElement>document.getElementById(asset_id + '_item_duration')).value = this.currentAssets[asset_id].item_duration;
      }
      // (<HTMLInputElement>document.getElementById(asset_id + '_file_name')).value = this.currentAssets[asset_id].file_name;
    }
    if (reopen && assetType === 'text') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }

    if (reopen && assetType === 'channel_number') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (reopen && assetType === 'youtube') {
      (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
    }

    $('.selectpicker').selectpicker('refresh');
  }
  applyColor(id, asset, refColor): any {
    if (id && asset && refColor &&
      (this.currentAssets[id].Type !== 'video' && this.currentAssets[id].Type !== 'image' && this.currentAssets[id].Type !== 'browser' && this.currentAssets[id].Type !== 'youtube') // Added Check to not to fill backgroud color
    ) {
      const screen_bkg_color = refColor;
      const color = screen_bkg_color.split('.');
      const sel_color = 'rgb(' + color[1] + ',' + color[2] + ',' + color[3] + ')';
      const ele = document.getElementById(id + asset);
      if (ele) {
        ele.style.backgroundColor = sel_color;
      }

      // Apply color on actual asset
      if (asset === '_txt_font_color') {  // if the user has selected to update the font color of a text asset
        const active_txt_asset_font = this.stage.findOne('#' + this.activeAssetId + '-Text');
        active_txt_asset_font.fill(sel_color);
      } else if (asset === '_txt_bkg_color') {  // background color of the text asset
        const active_txt_asset = this.stage.findOne('#' + this.activeAssetId);
        active_txt_asset.fill(sel_color);
      }
    }
  }

  ramdomid(): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  // image resize function
  updateImage(activeAsset): void {
    // console.log(activeAsset)
    const group = activeAsset.getParent();
    const aType = activeAsset.getName().split('-');
    const position = aType[0];
    const unique_id = aType[1];
    const topLeft = group.get('.' + 'topLeft-' + unique_id)[0];
    const topRight = group.get('.' + 'topRight-' + unique_id)[0];
    const bottomRight = group.get('.' + 'bottomRight-' + unique_id)[0];
    const bottomLeft = group.get('.' + 'bottomLeft-' + unique_id)[0];
    const anchorX = activeAsset.getX();
    const anchorY = activeAsset.getY();

    // update anchor positions
    switch (position) {
      case 'topLeft':
        topRight.setY(anchorY);
        bottomLeft.setX(anchorX);
        break;
      case 'topRight':
        topLeft.setY(anchorY);
        bottomRight.setX(anchorX);
        break;
      case 'bottomRight':
        bottomLeft.setY(anchorY);
        topRight.setX(anchorX);
        break;
      case 'bottomLeft':
        bottomRight.setY(anchorY);
        topLeft.setX(anchorX);
        break;
    }

    const width = topRight.getX() - topLeft.getX() + 10;
    const height = bottomLeft.getY() - topLeft.getY() + 10;

    // re-size the object (e.g., image) inside of the konva group
    const group_child = group.getChildren()[0];
    const group_child_two = group.getChildren()[1];
    group_child.position(topLeft.position());
    if (width && height) {
      group_child.width(width);
      group_child.height(height);
      // If this object is a text or text crawl then it has an extra text box that we need to re-size
      if ((group.getAttr('asset_type') === 'text') || (group.getAttr('asset_type') === 'text_crawl')) {
        group_child_two.width(group_child.getWidth());
        const offsetY = 0 - (((topLeft.getY() + bottomLeft.getY()) / 2) - 23);
        group_child_two.offsetY(offsetY);
      }
      else if ((group.getAttr('asset_type') === 'browser') || (group.getAttr('asset_type') === 'clock')) {
        group_child_two.width(group_child.getWidth());
        const offsetY = 0 - (((topLeft.getY() + bottomLeft.getY()) / 2) - 12);
        group_child_two.offsetY(offsetY);
      }
    }
  }

  addAnchor(group, x, y, name, is_dragaable = false): void {
    // first, add this new Anchor to the list
    this.currentAssetsAnchors.push(name);
    const stage = group.getStage();
    const layer = group.getLayer();

    var asset_id = name.split('-')[1];
    if (name.includes('bottomRight-')) {
      x = x + 10;
      y = y + 10;
    }
    const anchor = new Konva.Circle({
      x: x,
      y: y,
      radius: is_dragaable ? 10 : 0,
      // width: is_dragaable ? 10 : 0,
      // height: is_dragaable ? 10 : 0,
      stroke: '#FFCC99',
      fill: '#FFCC99',
      strokeWidth: 2,
      name: name,
      id: name,
      draggable: is_dragaable,
      dragBoundFunc: function (pos) {
        return ng.restrictDragWithinStage(pos, 10, 10, asset_id, this.getAbsolutePosition());
      }
    });

    anchor.on('dragmove', function () {
      if (is_dragaable) {
        ng.updateImage(this);
        layer.draw();
      }
    });

    anchor.on('mousedown touchstart', function () {
      if (is_dragaable) {
        group.setDraggable(false);
        //this.moveToTop();
      }
    });

    anchor.on('dragend', function () {
      if (is_dragaable) {
        group.setDraggable(true);
        layer.draw();
      }
    });

    // add hover styling
    anchor.on('mouseover', function () {
      if (is_dragaable) {
        const layer2 = this.getLayer();
        document.body.style.cursor = 'pointer';
        this.setStrokeWidth(4);
        layer2.draw();
      }
    });

    anchor.on('mouseout', function () {
      if (is_dragaable) {
        const layer2 = this.getLayer();
        document.body.style.cursor = 'default';
        this.setStrokeWidth(2);
        if (layer2 !== null) {
          layer2.draw();
        }
      }
    });

    group.add(anchor);
  }

  restrictDragWithinStage(pos, assetWidth, assetHeight, asset_id, absPos) {
    let currentX = pos.x < 0 ? 0 : pos.x;
    let currentY = pos.y < 0 ? 0 : pos.y;
    const currentWidth = assetWidth;
    const currentHeight = assetHeight;

    if (asset_id && this.activeAssetId !== asset_id) {
      return absPos;
    }
    if (pos.x + currentWidth > this.stageWidth) {
      currentX = this.stageWidth - currentWidth;
    }

    if (pos.y + currentHeight > this.stageHeight) {
      currentY = this.stageHeight - currentHeight;
    }

    return {
      x: currentX,
      y: currentY
    };
  }

  /**
   * After a new asset is droped onto the stage, this function builds (and shows) the list of attributes for that asset type
   * @param assetType
   * @param assetId
   */
  show_attributes(assetType, assetId): void {
    //
    $('.pl-asset-item').removeClass('pl-asset-item-active');
    $('#' + assetId + '-asset-item').addClass('pl-asset-item-active');

    setTimeout(() => {
      $('.pl-asset-item').removeClass('pl-asset-item-active');
      $('#' + assetId + '-asset-item').addClass('pl-asset-item-active');
    }, 200);
    // first,  clear out any old attributes that may already be showing
    document.getElementById('attributes').innerHTML = '';

    // second,  determine which asset's attributes to show
    let aAttributes = [];
    let attributes_div;
    switch (assetType) {
      case 'screen':
        aAttributes = this.screenAttributes;
        attributes_div = document.getElementById('screen_attributes');
        break;
      case 'image':
        aAttributes = this.imageAttributes;
        attributes_div = document.getElementById('attributes');
        break;
      case 'text':
        aAttributes = this.textAttributes;
        attributes_div = document.getElementById('attributes');
        break;
      case 'video':
        aAttributes = this.videoAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'browser':
        aAttributes = this.browserAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'channel_number':
        aAttributes = this.channelAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'clock':
        aAttributes = this.clockAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'rss':
        aAttributes = this.rssAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'overlay':
        aAttributes = this.rssAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'text_multiline':
        aAttributes = this.textMultilineAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'text_crawl':
        aAttributes = this.textScrollAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
      case 'youtube':
        aAttributes = this.youtubeAttributes;  // NOTE: Doesn't exist yet ...
        attributes_div = document.getElementById('attributes');
        break;
    }
    let addPlayListBox = false;
    // then, loop over each attribute and add it to the attributes div on the screen
    for (let i = 0; i < aAttributes.length; i++) {
      // console.log(aAttributes[i].id)
      const attribute = document.createElement('div');
      let attrClass = '';
      if (typeof aAttributes[i].hidden !== 'undefined' && aAttributes[i].hidden
        && typeof aAttributes[i].ShowAsDetails !== 'undefined' && aAttributes[i].ShowAsDetails) {
        attrClass = 'attribute_div form-group attr_hidden attr_showasdetails';
        attribute.style.display = 'none';
      } else if (typeof aAttributes[i].hidden !== 'undefined' && aAttributes[i].hidden) {
        attrClass = 'attribute_div form-group attr_hidden';
        attribute.style.display = 'none';
      } else if (typeof aAttributes[i].ShowAsDetails !== 'undefined' && aAttributes[i].ShowAsDetails) {
        attrClass = 'attribute_div form-group attr_showasdetails';
        attribute.style.display = 'none';
      } else {
        attrClass = 'attribute_div form-group ';
      }

      attribute.setAttribute('class', attrClass);
      if (typeof aAttributes[i].ControlType !== 'undefined' && aAttributes[i].ControlType === 'checkbox') {
        attribute.classList.add('pretty');
        attribute.classList.add('p-default');
        attribute.classList.add('p-thick');
        attribute.classList.add('p-pulse');
      }

      if (typeof aAttributes[i].ShowForHls !== 'undefined' && aAttributes[i].ShowForHls) {
        attribute.classList.add('attr_showforhls');
      }

      if (aAttributes[i].name === 'PlayList') {
        attribute.style.marginTop = '10px';
      }

      // if(assetType === 'youtube' && aAttributes[i].id === '_source') {
      //   const attribute_searchbutton = document.createElement('button');
      //   attribute_searchbutton.setAttribute('class', 'btn btn-secondary');
      //   attribute_searchbutton.style.width = '100%';
      //   attribute_searchbutton.style.marginTop = '10px';
      //   attribute_searchbutton.innerText = 'Search YouTube';
      //   attribute_searchbutton.addEventListener('click', function (event) {
      //    ng.openSearchYoutubeModal();
      //   });
      //   attribute.appendChild(attribute_searchbutton);

      // }

      if (aAttributes[i].name != undefined && aAttributes[i].name != '') {
        const attribute_title = document.createElement('label');
        attribute_title.innerHTML = aAttributes[i].name;
        if (aAttributes[i].name === 'Refresh Interval') {
          attribute_title.innerHTML = 'Refresh Interval';
        } else if (aAttributes[i].name === 'Item Duration') {
          attribute_title.innerHTML = 'Item Duration';
        } else if (aAttributes[i].name === 'PlayList') {
          attribute_title.innerHTML = 'Playlist';
        }

        // if (aAttributes[i].name === 'Type') {
        //   attribute_title.setAttribute('class', 'attribute_title attribute_title_bold');
        // } else
        if (aAttributes[i].name === 'PlayList') {
          attribute_title.setAttribute('class', 'attribute_title chk_attribute_title');
        } else if (aAttributes[i].id === '_publish_videos') {
          attribute_title.setAttribute('class', 'attribute_title chk_attribute_title');
        } else {
          attribute_title.setAttribute('class', 'attribute_title ');
        }

        attribute_title.setAttribute('class', 'custom-label-normal');

        attribute_title.setAttribute('for', assetId + aAttributes[i].id);

        if (aAttributes[i].ControlType !== 'checkbox') {
          attribute.appendChild(attribute_title);
        }
      }
      // if(aAttributes[i].name == "Background Color"){  //if this attribute requires a 'special' input
      // if this attribute requires a 'special' Color Picker input
      if ((aAttributes[i].id === 'bkg_color') || (aAttributes[i].id === '_txt_bkg_color') || (aAttributes[i].id === '_txt_font_color')) {

        // create a button that can be used to update the stage background color
        const attribute_button = document.createElement('input');
        attribute_button.setAttribute('id', assetId + aAttributes[i].id);
        attribute_button.setAttribute('class', 'form-control jscolor-input');
        attribute_button.readOnly = true;
        const color_picker = new jscolor(attribute_button, {
          valueElement: null
        });
        color_picker.onFineChange = function () {
          ng.updateColor(color_picker, aAttributes[i].id);
        };
        if (aAttributes[i].id === '_txt_bkg_color') {
          color_picker.fromRGB(0, 0, 0);  // set the default stage color to black
        } else {
          color_picker.fromRGB(255, 255, 255);  // set the default stage color to white
        }
        attribute.appendChild(attribute_button);  // add the button to the div
      } else if (aAttributes[i].id === '_txt_bkg_opacity') {

        const attribute_range = document.createElement('input');
        attribute_range.type = 'range';
        attribute_range.setAttribute('name', assetId + aAttributes[i].id);
        attribute_range.setAttribute('id', assetId + aAttributes[i].id);
        attribute_range.setAttribute('class', 'attribute_text_box form-control-slider slider');
        attribute_range.setAttribute('style', 'border:none');
        attribute_range.setAttribute('min', '0');
        attribute_range.setAttribute('max', '1');
        attribute_range.setAttribute('step', '0.1');
        attribute_range.setAttribute('value', '0');
        attribute.appendChild(attribute_range);

        attribute_range.addEventListener('change', function (this) {
          ng.changeOpacity(this.value, assetId);
        });
      } else if (aAttributes[i].id === '_txt_opacity_label') {

        const attribute_range = document.createElement('input');
        attribute_range.type = 'text';
        attribute_range.setAttribute('name', assetId + aAttributes[i].id);
        attribute_range.setAttribute('id', assetId + aAttributes[i].id);
        attribute_range.setAttribute('class', 'attribute_text_box form-control txt_opacity');
        attribute_range.setAttribute('disabled', 'disabled');
        attribute.appendChild(attribute_range);
      } else if (assetType === 'rss' && aAttributes[i].id === '_def_source') {
        // console.log('_def_source');
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.rssValueOptions.length; i++) {
          const option = document.createElement('option');
          option.value = this.rssValueOptions[i].value;
          option.text = this.rssValueOptions[i].title;
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);

        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + '_def_source', '_def_source');
          // ng.updateRssSource(assetId + aAttributes[i].text, aAttributes[i].value);
        });
      } else if (aAttributes[i].id === '_fullscreen') {
        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control');
        attribute.appendChild(attribute_checkbox);

        attribute_checkbox.addEventListener('change', function (this) {
          ng.updateFullScreenStats(assetType, assetId, this.checked);
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      }
      else if (aAttributes[i].id === '_border') {
        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control');
        attribute.setAttribute('style', 'display:block!important');
        attribute.appendChild(attribute_checkbox);

        attribute_checkbox.addEventListener('change', function (this) {
          if ((<HTMLInputElement>document.getElementById(assetId + '_fullscreen')).checked)
            ng.updateFullScreenStats(assetType, assetId, false);
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      }
      else if (aAttributes[i].id === '_image_wall') {

        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control');
        attribute.appendChild(attribute_checkbox);

        attribute_checkbox.addEventListener('change', function (this) {
          if ((<HTMLInputElement>document.getElementById(assetId + '_fullscreen')).checked !== attribute_checkbox.checked) {
            (<HTMLInputElement>document.getElementById(assetId + '_fullscreen')).click();
          }
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      }
      // else if (aAttributes[i].name === 'Type') {   // else, just show the name of the attribute, no input field

      //   const attribute_name = document.createElement('b');
      //   if (assetType === 'text_crawl') {
      //     attribute_name.innerHTML = 'Text Scroll';
      //   } else if (assetType === 'text_multiline') {
      //     attribute_name.innerHTML = 'Text Multiline';
      //   } else if (assetType === 'channel_number') {
      //     attribute_name.innerHTML = 'Channel Number';
      //   } else if (assetType === 'rss') {
      //     attribute_name.innerHTML = 'RSS';
      //   } else if (assetType === 'image') {
      //     if (this.currentUser.userRole == 'admin' || this.currentUser.userRole == 'user_with_image_upload' || this.currentUser.userRole == 'user_with_image_and_video_upload') {
      //       // attribute_name.innerHTML = assetType + ' <a class="uploadBtn">[Upload New]</a>';
      //       // attribute_name.addEventListener('click', function () {
      //       //   ng.uploadImageAsset();
      //       // });
      //       attribute_name.innerHTML = assetType;
      //     } else {
      //       attribute_name.innerHTML = assetType;
      //     }
      //   } else if (assetType === 'video') {
      //     if (this.currentUser.userRole === 'admin' || this.currentUser.userRole === 'user_with_image_and_video_upload') {
      //       // attribute_name.innerHTML = assetType + ' <a class="uploadBtn" >[Upload New]</a>';
      //       // attribute_name.addEventListener('click', function () {
      //       //   ng.uploadVideoAsset();
      //       // });

      //       attribute_name.innerHTML = assetType;
      //       attribute.appendChild(attribute_name);
      //     } else {
      //       attribute_name.innerHTML = assetType;
      //     }
      //   } else {
      //     attribute_name.innerHTML = assetType;
      //   }
      //   attribute_name.setAttribute('class', 'attribute_title title-bold');
      //   attribute_name.setAttribute('class', 'custom-label-normal');
      //   attribute_name.setAttribute('style', 'padding-left: 4.3em;');
      //   attribute.appendChild(attribute_name);
      // }
      else if (aAttributes[i].id === '_image_options') {
        if (this.currentUser.userRole === 'admin'
          || this.currentUser.userRole === 'user_with_image_and_video_upload'
          || this.currentUser.userRole === 'user_with_image_upload') {

          // const attribute_select3 = document.createElement('select');

          // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
          // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);
          // attribute_select3.setAttribute('value', 'Video');

          const attribute_opt_div = document.createElement('div');
          attribute_opt_div.setAttribute('class', 'dropdown w-100');
          // attribute_opt_div.setAttribute('class', 'attribute_text_box hovr-dropdown');
          attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
          attribute_opt_div.setAttribute('value', 'Image');

          const drpbtn = document.createElement('button');
          drpbtn.setAttribute('type', 'button');
          drpbtn.setAttribute('color', 'primary');
          drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
          drpbtn.setAttribute('data-toggle', 'dropdown');
          drpbtn.setAttribute('aria-haspopup', 'true');
          drpbtn.setAttribute('aria-expanded', 'false');
          drpbtn.textContent = 'Image';
          // drpbtn.setAttribute('class', 'btn btn-success hovr-dropdown-btn');

          attribute_opt_div.appendChild(drpbtn);

          const divcontent = document.createElement('div');
          divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

          attribute_opt_div.appendChild(divcontent);

          const imageOptions = [
            // { val: '1', text: '- Select -' },
            // { val: '1', text: 'Image', hidden: true },
            { val: '2', text: 'Upload Image(s)', hidden: false },
            { val: '4', text: 'Delete Image(s)', hidden: false },
            { val: '3', text: 'Show Details', hidden: false }
            // { val: '3', text: 'Webpage Screenshot' }
          ];

          imageOptions.forEach(element => {
            // const option = document.createElement('option');
            // option.value = '' + element.val;
            // option.text = element.text;
            // option.hidden = element.hidden;
            // attribute_select3.appendChild(option);

            const anchoritem = document.createElement('a');
            anchoritem.href = 'javascript:void(0)';
            anchoritem.text = element.text;
            anchoritem.setAttribute('id', assetId + '_image_options_a_' + element.val)
            anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

            divcontent.appendChild(anchoritem);

            anchoritem.addEventListener('click', function () {
              if (element.val === '2') {
                ng.uploadImageAsset();
              } else if (element.val === '3') {
                // ng.openScreenshotPopUp();
                if ($("#" + assetId + '_image_options_a_' + element.val).text() === 'Show Details') {
                  $('.attr_showasdetails').show();
                  element.text = 'Hide Details';
                  anchoritem.text = 'Hide Details';
                  $("#" + assetId + '_image_options_a_' + element.val).text('Hide Details');
                }
                else if ($("#" + assetId + '_image_options_a_' + element.val).text() === 'Hide Details') {
                  $('.attr_showasdetails').hide();
                  element.text = 'Show Details';
                  anchoritem.text = 'Show Details';
                  $("#" + assetId + '_image_options_a_' + element.val).text('Show Details');
                }
                if (!ng.currentAssets[assetId].playlist) {
                  $('.attr_hidden').hide();
                }
              } else if (element.val === '4') {
                ng.imagefilename = '';
                ng.openModel(ng.deleteImageModal);
                ng.BindImageSources(<HTMLSelectElement>document.getElementById('ddlSelectedImage'));
                $('.selectpicker').selectpicker('refresh');
                $(".bootstrap-select").removeClass('dropup')
              }
            });
          });

          attribute.appendChild(attribute_opt_div);

          //attribute.appendChild(attribute_select3);
          // attribute_select3.addEventListener('change', function () {
          //   if (this.value === '2') {
          //     ng.uploadImageAsset();
          //   } else if (this.value == '3') {
          //     // ng.openScreenshotPopUp();
          //     $('.attr_showasdetails').show();
          //   }
          //   attribute_select3.value = '1';
          // });
        }
      } else if (aAttributes[i].id === '_video_options') {
        // if (this.currentUser.userRole === 'admin' || this.currentUser.userRole === 'user_with_image_and_video_upload') {

        // const attribute_select2 = document.createElement('select');
        // attribute_select2.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select2.setAttribute('id', assetId + aAttributes[i].id);
        // attribute_select2.setAttribute('value', 'Video');

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Video');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Audio / Video';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const videoOptions = [
          // { val: '1', text: '- Select -' },
          // { val: '1', text: 'Video', hidden: true },
          { val: '2', text: 'Upload New File(s)', hidden: false },
          { val: '6', text: 'Delete .MP3 File(s)', hidden: false },
          { val: '7', text: 'Delete Video(s)', hidden: false },
          // { val: '3', text: 'Edit Streaming Channels', hidden: false },
          // { val: '4', text: 'Edit Channel Lineup', hidden: false },
          { val: '5', text: 'Show Details', hidden: false }
        ];

        videoOptions.forEach(element => {
          if (element.val === '2' && this.currentUser.userRole !== 'admin'
            && this.currentUser.userRole !== 'user_with_image_and_video_upload') {
            return;
          }
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select2.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            ng.videoOptionAction(element, anchoritem);
          });
        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select2);

        // attribute_select2.addEventListener('change', function () {
        //   ng.videoOptionAction(this.value);
        //   attribute_select2.value = '1';
        // });

        //   ng.uploadVideoAsset();
        // }
      } else if (aAttributes[i].id === '_text_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Text');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Text';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const textOptions = [
          // { val: '1', text: 'Text', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        textOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);
          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_browser_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Browser');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Browser';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const browserOptions = [
          // { val: '1', text: 'Browser', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        browserOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });
        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_channel_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Channel Number');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Channel Number';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);


        const channelOptions = [
          // { val: '1', text: 'Channel Number', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        channelOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_clock_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Clock');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Clock';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const clockOptions = [
          // { val: '1', text: 'Clock', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        clockOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });
        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_rss_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);
        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'RSS');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'RSS';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const rssOptions = [
          // { val: '1', text: 'RSS', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        rssOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_textmultiline_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Text Multiline');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Text Multiline';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);


        const textmultilineOptions = [
          // { val: '1', text: 'Text Multiline', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        textmultilineOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_textscroll_options') {

        // const attribute_select3 = document.createElement('select');

        // attribute_select3.setAttribute('class', 'attribute_text_box form-control');
        // attribute_select3.setAttribute('id', assetId + aAttributes[i].id);

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'Text Scroll');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'Text Scroll';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const textscrollOptions = [
          // { val: '1', text: 'Text Scroll', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        textscrollOptions.forEach(element => {
          // const option = document.createElement('option');
          // option.value = '' + element.val;
          // option.text = element.text;
          // option.hidden = element.hidden;
          // attribute_select3.appendChild(option);

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);

        // attribute.appendChild(attribute_select3);
        // attribute_select3.addEventListener('change', function () {
        //   if (this.value == '2') {
        //     $('.attr_showasdetails').show();
        //   }
        //   attribute_select3.value = '1';
        // });
      } else if (aAttributes[i].id === '_youtube_options') {

        const attribute_opt_div = document.createElement('div');
        attribute_opt_div.setAttribute('class', 'dropdown w-100');
        attribute_opt_div.setAttribute('id', assetId + aAttributes[i].id);
        attribute_opt_div.setAttribute('value', 'YouTube');

        const drpbtn = document.createElement('button');
        drpbtn.setAttribute('type', 'button');
        drpbtn.setAttribute('color', 'primary');
        drpbtn.setAttribute('class', 'mdb-btn mdb-btn-primary dropdown-toggle mr-4 waves-effect waves-light drp_attr_font w-100');
        drpbtn.setAttribute('data-toggle', 'dropdown');
        drpbtn.setAttribute('aria-haspopup', 'true');
        drpbtn.setAttribute('aria-expanded', 'false');
        drpbtn.textContent = 'YouTube';

        attribute_opt_div.appendChild(drpbtn);

        const divcontent = document.createElement('div');
        divcontent.setAttribute('class', 'dropdown-menu dropdown-primary w-100');

        attribute_opt_div.appendChild(divcontent);

        const youtubeOptions = [
          // { val: '1', text: 'YouTube', hidden: true },
          { val: '2', text: 'Show Details', hidden: false }
        ];

        youtubeOptions.forEach(element => {

          const anchoritem = document.createElement('a');
          anchoritem.href = 'javascript:void(0)';
          anchoritem.text = element.text;
          anchoritem.setAttribute('class', 'dropdown-item drp_attr_font');

          divcontent.appendChild(anchoritem);

          anchoritem.addEventListener('click', function () {
            if (element.val === '2') {
              if (element.text === 'Show Details') {
                $('.attr_showasdetails').show();
                element.text = 'Hide Details';
                anchoritem.text = 'Hide Details';
              }
              else if (element.text === 'Hide Details') {
                $('.attr_showasdetails').hide();
                element.text = 'Show Details';
                anchoritem.text = 'Show Details';
              }
            }
          });

        });

        attribute.appendChild(attribute_opt_div);
      } else if (aAttributes[i].name === 'Font') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        //attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.fontOption.length; i++) {
          const option = document.createElement('option');
          option.value = this.fontOption[i].value;
          option.text = this.fontOption[i].text;
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);

        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
        attribute_select.value = aAttributes[i].defaultVal;
      } else if (aAttributes[i].id === '_font_special') {

        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control');
        attribute.appendChild(attribute_checkbox);

        attribute_checkbox.addEventListener('change', function (this) {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      } else if (aAttributes[i].name === 'Rate') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control attribute_text_box_rate');
        attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.rateOption.length; i++) {
          const option = document.createElement('option');
          option.value = this.rateOption[i].value;
          option.text = this.rateOption[i].text;
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);//
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      } else if (aAttributes[i].name === 'Direction') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control attribute_text_box_direction');
        attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.directionOptions.length; i++) {
          const option = document.createElement('option');
          option.value = this.directionOptions[i];
          option.text = this.directionOptions[i];
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);//Direction
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      } else if (aAttributes[i].name === 'Date Format') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', aAttributes[i].defaultVal);

        for (let i = 0; i < this.dateFormatOptions.length; i++) {
          const option = document.createElement('option');
          option.value = this.dateFormatOptions[i];
          option.text = this.dateFormatOptions[i];
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);//Direction
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
        // console.log(aAttributes[i])
        attribute_select.value = aAttributes[i].defaultVal;
      } else if (aAttributes[i].name === 'Time Format') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.timeFormatOptions.length; i++) {
          const option = document.createElement('option');
          option.value = this.timeFormatOptions[i];
          option.text = this.timeFormatOptions[i];
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select); // Direction
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
        attribute_select.value = aAttributes[i].defaultVal;
      } else if (aAttributes[i].name === 'Time Zone') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        //attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.timezoneOption.length; i++) {
          const option = document.createElement('option');
          option.value = this.timezoneOption[i].value;
          option.text = this.timezoneOption[i].text;
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select); // Direction
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
        attribute_select.value = aAttributes[i].defaultVal;
      } else if (aAttributes[i].name === 'Transition') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');

        for (let i = 0; i < this.transitionOption.length; i++) {
          const option = document.createElement('option');
          option.value = this.transitionOption[i];
          option.text = this.transitionOption[i];
          attribute_select.appendChild(option);
        }
        attribute.appendChild(attribute_select);//Direction
        attribute_select.addEventListener('change', function () {
          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
        });
      } else if (aAttributes[i].name === 'PlayList') {

        if(assetType !== 'video') {
          addPlayListBox = true;
        }

        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control play_list_checkbox');
        attribute_checkbox.setAttribute('value', '1');
        if(aAttributes[i].checked !== 'undefined' && aAttributes[i].checked) {
          attribute_checkbox.setAttribute('checked', 'true'); 
        }
        if(aAttributes[i].disabled !== 'undefined' && aAttributes[i].disabled) {
          attribute_checkbox.setAttribute('disabled', 'disabled');
        }
        attribute.appendChild(attribute_checkbox); //Direction

        // add span
        let _span = document.createElement('span');
        _span.setAttribute('class', 'box');
        attribute.appendChild(_span); //Direction

        attribute_checkbox.addEventListener('change', function (this) {

          var isPlayListExist = false;
          for (const key in ng.currentAssets) {
            if (ng.currentAssets[key].playlist) {
              isPlayListExist = true;
              break;
            }
          }

          if (attribute_checkbox.checked && isPlayListExist) {
            attribute_checkbox.checked = false;
            ng.authService.showNotification('', 'There is already an asset with <br/> a playlist on the stage', 'error');
            return;
          }

          for (const key in ng.currentAssets) {
            if (ng.currentAssets[key].Type === 'clock' && attribute_checkbox.checked) {
              attribute_checkbox.checked = false;
              ng.authService.showNotification('Error', 'There is a clock asset on the screen. <br/> Adding Playlist is not permitted', 'error');
              return;
            }
          }

          ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
          ng.togglePlaylistAttributes(this, assetType);
          // ng.mediaSelected((<HTMLInputElement>document.getElementById(assetId + '_source')).value, 'image');
          ng.mediaSelected((<HTMLInputElement>document.getElementById(assetId + '_source')).value, assetType);

          if(assetType === 'image') {
            ng.ImageSourceChanged();
          }
        });
      } else if (aAttributes[i].id === '_publish_videos') {
        addPlayListBox = true;
        const attribute_checkbox = document.createElement('input');
        attribute_checkbox.type = 'checkbox';
        attribute_checkbox.setAttribute('id', assetId + aAttributes[i].id);
        attribute_checkbox.setAttribute('class', 'attribute_text_box form-control play_list_checkbox');
        attribute_checkbox.setAttribute('value', '1');
        attribute_checkbox.setAttribute('checked', 'checked');
        // attribute_checkbox.setAttribute('checked', 'false');
        attribute.appendChild(attribute_checkbox); //Direction

        // add span
        let _span = document.createElement('span');
        _span.setAttribute('class', 'box');
        attribute.appendChild(_span); //Direction

        attribute_checkbox.addEventListener('change', function (this) {
          ng.toggleVideosPublish(this);
        });
      } else if (assetType === 'image' && aAttributes[i].id === '_def_source') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');
        const heading = document.createElement('option');
        heading.value = '0';
        heading.text = '-- Images --';
        attribute_select.appendChild(heading);

        this.currentImages.forEach(image => {
          const option = document.createElement('option');
          option.value = image.name;
          option.text = image.name;
          attribute_select.appendChild(option);
        });
        attribute.appendChild(attribute_select);

        attribute_select.addEventListener('change', function () {
          ng.mediaSelected(this.value, 'image');
          attribute_select.selectedIndex = 0;
          // ng.updateRssSource(assetId + aAttributes[i].text, aAttributes[i].value);
        });
      } else if (assetType === 'video' && aAttributes[i].id === '_def_source') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');

        ng.BindVideoSources(attribute_select);
        // let streamingAdded = false;
        // const heading = document.createElement('option');
        // heading.value = '0';
        // heading.text = '-- Videos --';
        // attribute_select.appendChild(heading);

        // const heading3 = document.createElement('option');
        // heading3.value = '1';
        // heading3.text = '-- Video Files --';
        // attribute_select.appendChild(heading3);

        // // const heading6 = document.createElement('option');
        // // heading6.value = '6';
        // // heading6.text = 'Play All Videos';
        // // attribute_select.appendChild(heading6);

        // this.currentVideos.forEach(video => {
        //   const option = document.createElement('option');
        //   if (video.isEztvItem && !streamingAdded) {
        //     const heading2 = document.createElement('option');
        //     heading2.value = '2';
        //     heading2.text = '-- Video Streams -- ';
        //     attribute_select.appendChild(heading2);
        //     streamingAdded = true;
        //   }
        //   if (video.isEztvItem) {
        //     option.value = video.url;
        //     option.text = video.name;
        //   } else {
        //     option.value = video.name;
        //     option.text = video.name;
        //   }
        //   attribute_select.appendChild(option);
        // });

        // const publishHeading = document.createElement('option');
        // publishHeading.value = '4';
        // publishHeading.text = '-- Publish --';
        // attribute_select.appendChild(publishHeading);

        // const publishOption = document.createElement('option');
        // publishOption.value = '3';
        // publishOption.text = 'Publish All Videos';
        // attribute_select.appendChild(publishOption);

        // const publishOption5 = document.createElement('option');
        // publishOption5.value = '5';
        // publishOption5.text = 'Publish Channel Line-Up File';
        // attribute_select.appendChild(publishOption5);

        attribute.appendChild(attribute_select);

        attribute_select.addEventListener('change', function () {
          // ng.updateAsset(assetId + '_def_source', '_def_source');
          ng.mediaSelected(this.value, 'video');
          attribute_select.selectedIndex = 0;
          // ng.updateRssSource(assetId + aAttributes[i].text, aAttributes[i].value);
        });
      } else if (assetType === 'video' && aAttributes[i].id === '_audio_def_source') {
        const attribute_select = document.createElement('select');
        attribute_select.setAttribute('id', assetId + aAttributes[i].id);
        attribute_select.setAttribute('class', 'selectpicker attribute_text_box form-control');
        attribute_select.setAttribute('value', '');

        ng.BindAudioSources(attribute_select);

        attribute.appendChild(attribute_select);

        attribute_select.addEventListener('change', function () {
          // ng.updateAsset(assetId + '_def_source', '_def_source');
          ng.mediaSelected(this.value, 'audio');
          attribute_select.selectedIndex = 0;
          // ng.updateRssSource(assetId + aAttributes[i].text, aAttributes[i].value);
        });
      } else if (aAttributes[i].id === '_note') {

        const attribute_label = document.createElement('label');
        attribute_label.setAttribute('class', 'attribute_text_box');
        attribute_label.style.color = 'white';
        attribute_label.innerHTML = aAttributes[i].message;
        attribute.appendChild(attribute_label);

      } else if (aAttributes[i].id === '_search_youtube') {
        const attribute_searchbutton = document.createElement('button');
        attribute_searchbutton.setAttribute('class', 'btn btn-secondary');
        attribute_searchbutton.style.width = '100%';
        attribute_searchbutton.style.marginTop = '10px';
        attribute_searchbutton.innerText = 'Search YouTube';
        attribute_searchbutton.addEventListener('click', function (event) {
          ng.openSearchYoutubeModal();
        });
        attribute.appendChild(attribute_searchbutton);
      } else if (aAttributes[i].id === '_resize_to_source') {
        const attribute_resizebutton = document.createElement('button');
        attribute_resizebutton.setAttribute('id', aAttributes[i].id);
        attribute_resizebutton.setAttribute('class', 'btn btn-secondary disabled');
        attribute_resizebutton.style.width = '70%';
        attribute_resizebutton.style.marginTop = '10px';
        attribute_resizebutton.innerText = 'Resize To Source';
        attribute_resizebutton.addEventListener('click', function (event) {
          ng.ResizeImageAssetToSource();
        });
        attribute.appendChild(attribute_resizebutton);
      } else {
        // else, this attribute can use a text input
        var attribute_text_box;
        if (assetType === 'text' && aAttributes[i].id === '_source') {
          attribute_text_box = document.createElement('textarea');
        }
        else {
          attribute_text_box = document.createElement('input');
        }
        if (aAttributes[i].id === '_refresh_interval') {
          attribute_text_box.setAttribute('type', 'number');
        }

        if (assetType === 'screen') { // if this is a screen attribute then we don't connect the id it to the asset id
          attribute_text_box.setAttribute('id', aAttributes[i].id);
        } else {
          attribute_text_box.setAttribute('id', assetId + aAttributes[i].id);
          if (assetType === 'image' && aAttributes[i].id === '_source') {
            attribute_text_box.addEventListener('blur', function (event) {
              const imgSource = (<HTMLInputElement>event.target).value;
              ng.updateImageAsset(imgSource, 'image', imgSource, true, imgSource);
              ng.ImageSourceChanged();
            });
          } else {
            attribute_text_box.addEventListener('blur', function () {
              if (assetType === 'video') {
                ng.VideoSourceChanged();
              }
              ng.updateAsset(assetId + aAttributes[i].id, aAttributes[i].id);
            });
          }
        }

        attribute_text_box.setAttribute('class', 'attribute_text_box form-control');
        attribute_text_box.setAttribute('value', '');
        if (aAttributes[i].id === '_font_size') {
          //attribute_text_box.setAttribute('type', 'number');
          if (assetType === 'clock')
            attribute_text_box.setAttribute('value', '30');
          else if (assetType === 'text' || assetType === 'text_crawl')
            attribute_text_box.setAttribute('value', '40');
          else
            attribute_text_box.setAttribute('value', '30');

          attribute_text_box.addEventListener('keypress', function (e) {
            var result = ng.onlyNumberKey(e);
            if (!result) {
              e.preventDefault();
            }
          });

        } else if (aAttributes[i].id === '_item_duration') {
          attribute_text_box.setAttribute('value', '10');
        }

        if (aAttributes[i].id === '_source' && typeof aAttributes[i].maxlength !== 'undefined') {
          attribute_text_box.setAttribute('maxlength', aAttributes[i].maxlength);
        }

        // if(typeof aAttributes[i].defaultVal !== 'undefined') {
        //   console.log(aAttributes[i].defaultVal);
        //   attribute_text_box.setAttribute('value', aAttributes[i].defaultVal);
        // }
        attribute.appendChild(attribute_text_box);

        // if(assetType === 'browser' && aAttributes[i].id === '_source') {
        //   const attribute_testbutton = document.createElement('button');
        //   attribute_testbutton.setAttribute('class', 'btn btn-secondary');
        //   attribute_testbutton.style.marginTop = '10px';
        //   attribute_testbutton.innerText = 'Test Webpage';
        //   attribute_testbutton.addEventListener('click', function (event) {
        //     const browserUrl = (<HTMLInputElement>document.getElementById(assetId + '_source')).value;
        //     ng.loadBrowserSource(assetId, browserUrl);
        //   });
        //   attribute.appendChild(attribute_testbutton);
        // }
      }

      if (typeof aAttributes[i].ControlType !== 'undefined' && aAttributes[i].ControlType === 'checkbox') {
        const title_div = document.createElement('div');
        const attribute_title = document.createElement('label');
        attribute_title.innerHTML = aAttributes[i].name;
        attribute_title.setAttribute('class', 'custom-label-normal');
        attribute_title.setAttribute('for', assetId + aAttributes[i].id);
        title_div.setAttribute('class', 'state p-warning-o');
        title_div.appendChild(attribute_title);
        attribute.appendChild(title_div);
      }

      attributes_div.appendChild(attribute);   // add this attribute to the list

    }
    if (addPlayListBox) {
      const playListDiv = document.createElement('div');
      // playListDiv.setAttribute('class', 'play-list-box attr_hidden row mt10');
      playListDiv.setAttribute('class', 'play-list-box attr_hidden attr_showasdetails mt10');
      playListDiv.style.display = 'none';
      const inHtml = '<h5 style="margin-bottom:0px;text-transform: capitalize;color:white"><u>' + assetType +
        ' Playlist</u></h5><div id="sortable"  class=" play-list-items-list col-lg-12" style="padding-left:0">\n </div>';
      playListDiv.innerHTML = inHtml;
      attributes_div.appendChild(playListDiv);
      $('#sortable').sortable({
        stop: function (event, ui) {
          ng.playListUpdate();
        },
      });
    }
    $(".selectpicker").selectpicker();
  }

  BindImageSources(attribute_select): void {
    $("#" + attribute_select.id).empty();
    const heading = document.createElement('option');
    heading.value = '0';
    heading.text = '-- Images --';
    attribute_select.appendChild(heading);

    this.currentImages.forEach(image => {
      const option = document.createElement('option');
      option.value = image.name;
      option.text = image.name;
      attribute_select.appendChild(option);
    });
  }

  BindVideoSources(attribute_select): void {
    $("#" + attribute_select.id).empty();
    let streamingAdded = false;
    const heading = document.createElement('option');
    heading.value = '0';
    heading.text = '-- Videos --';
    attribute_select.appendChild(heading);

    const heading3 = document.createElement('option');
    heading3.value = '1';
    heading3.text = '-- Video Files --';
    attribute_select.appendChild(heading3);

    // const heading6 = document.createElement('option');
    // heading6.value = '6';
    // heading6.text = 'Play All Videos';
    // attribute_select.appendChild(heading6);

    this.currentVideos.forEach(video => {
      const option = document.createElement('option');
      if (video.isEztvItem && !streamingAdded) {
        const heading2 = document.createElement('option');
        heading2.value = '2';
        heading2.text = '-- Video Streams -- ';
        attribute_select.appendChild(heading2);
        streamingAdded = true;
      }
      if (video.isEztvItem) {
        option.value = video.url;
        option.text = video.name;
      } else {
        option.value = video.name;
        option.text = video.name;
      }
      attribute_select.appendChild(option);
    });
  }

  BindVideoOnlySources(attribute_select): void {
    $("#" + attribute_select.id).empty();
    const heading = document.createElement('option');
    heading.value = '0';
    heading.text = '-- Videos --';
    attribute_select.appendChild(heading);

    const heading3 = document.createElement('option');
    heading3.value = '1';
    heading3.text = '-- Video Files --';
    attribute_select.appendChild(heading3);

    this.currentVideos.forEach(video => {
      if (!video.isEztvItem) {
        const option = document.createElement('option');
        option.value = video.name;
        option.text = video.name;
        attribute_select.appendChild(option);
      }
    });
  }

  BindAudioSources(attribute_select): void {
    $("#" + attribute_select.id).empty();

    const heading = document.createElement('option');
    heading.value = '0';
    heading.text = '-- .MP3 Files --';
    attribute_select.appendChild(heading);

    // const heading3 = document.createElement('option');
    // heading3.value = '1';
    // heading3.text = '-- Audio Files --';
    // attribute_select.appendChild(heading3);

    this.currentAudios.forEach(audio => {
      const option = document.createElement('option');
      option.value = audio.name;
      option.text = audio.name;

      attribute_select.appendChild(option);
    });
  }

  toggleVideosPublish(item) {
    this.publishVideos = item.checked;
  }

  mediaSelected(imgName, type) {

    // const active_asset = this.stage.findOne('#' + this.activeAssetId + '-Group');  // get the Konva asset object
    // const group_child = active_asset.getChildren()[0];

    // if(type === 'audio') {

    // } else if(type === 'video') {

    // }

    if (imgName === '5' && type === 'video') {
      this.publishLineup = true;
      this.openModel(this.publishServerModal);
    } else if (imgName === '3' && type === 'video') {
      this.show_publish_modal(false);
    } else if (imgName === '6' && type === 'video') {
      ng.updateImageAsset('folder', type, null, true, 'folder');
    } else if (type === 'image') {
      this.currentImages.forEach(image => {
        if (image.name === imgName) {
          ng.updateImageAsset('assets/content/' + image.name, type, image.url);
          this.ImageSourceChanged();
        }
      });
    } else if (type === 'audio') {
      this.currentAudios.forEach(audio => {
        if (audio.name === imgName) {
          ng.updateImageAsset('assets/content/' + audio.name, type, audio.url);
        }
      });

      this.VideoSourceChanged();

    } else {
      this.currentVideos.forEach(video => {
        if (video.name === imgName || video.url === imgName) {
          if (video.isEztvItem) {
            ng.updateImageAsset(video.url, type, null, true, video.name);
          } else {
            ng.updateImageAsset('assets/content/' + video.name, type, null, false, video.name);
          }
        }
      });

      this.VideoSourceChanged();
    }
  }

  newAssetClicked(asset_group, asset_id): void {
    // Get and show the X, Y, Width, Height values for the asset just clikced
    const active_x = asset_group.getX();
    const active_y = asset_group.getY();
    const active_width = ng.stage.findOne('#' + asset_id).getWidth();
    const active_height = ng.stage.findOne('#' + asset_id).getHeight();
    this.show_assets(this.currentAssets[asset_id].Type);

    const assetObj = ng.stage.findOne('#' + asset_id);
    this.activeImageParent = assetObj.getParent();
    (<HTMLInputElement>document.getElementById(asset_id + '_x')).value = active_x;
    (<HTMLInputElement>document.getElementById(asset_id + '_y')).value = active_y;
    (<HTMLInputElement>document.getElementById(asset_id + '_width')).value = active_width;
    (<HTMLInputElement>document.getElementById(asset_id + '_height')).value = active_height;

    if (this.currentAssets[asset_id].Type === 'image' || this.currentAssets[asset_id].Type === 'video' || this.currentAssets[asset_id].Type === 'browser' || this.currentAssets[asset_id].Type === 'youtube') {
      (<HTMLInputElement>document.getElementById(asset_id + '_fullscreen')).checked = this.currentAssets[asset_id].full_screen;
      if (this.currentAssets[asset_id].Type === 'image' || this.currentAssets[asset_id].Type === 'video') {
        (<HTMLInputElement>document.getElementById(asset_id + '_border')).checked = this.currentAssets[asset_id].border == 'yes' ? true : false;
      }
    }

    if (this.currentAssets[asset_id].Name !== 'undefined') {
      try {
        (<HTMLInputElement>document.getElementById(asset_id + '_name')).value = this.currentAssets[asset_id].Name;
      } catch (error) {

      }
    }
    if ((this.currentAssets[asset_id].Type === 'image' || this.currentAssets[asset_id].Type === 'text' || this.currentAssets[asset_id].Type === 'video' || this.currentAssets[asset_id].Type === 'browser' || this.currentAssets[asset_id].Type === 'rss' || this.currentAssets[asset_id].Type === 'text_multiline' || this.currentAssets[asset_id].Type === 'text_crawl' || this.currentAssets[asset_id].Type === 'youtube') && this.currentAssets[asset_id].Source.length > 0) {
      if (this.currentAssets[asset_id].Type === 'video' || !this.currentAssets[asset_id].playlist) {
        (<HTMLInputElement>document.getElementById(asset_id + '_source')).value = this.currentAssets[asset_id].Source;
      }
    }
    if (this.currentAssets[asset_id].Type === 'browser') {
      (<HTMLInputElement>document.getElementById(asset_id + '_refresh_interval')).value = this.currentAssets[asset_id].RefreshInterval;
    }
    if (this.currentAssets[asset_id].Type === 'clock') {
      (<HTMLInputElement>document.getElementById(asset_id + '_time_format')).value = this.currentAssets[asset_id].time_format;
      (<HTMLInputElement>document.getElementById(asset_id + '_date_format')).value = this.currentAssets[asset_id].date_format;
      (<HTMLInputElement>document.getElementById(asset_id + '_time_zone')).value = this.currentAssets[asset_id].time_zone;
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (this.currentAssets[asset_id].Type === 'rss' || this.currentAssets[asset_id].Type === 'text_multiline' || this.currentAssets[asset_id].Type === 'text_crawl' || this.currentAssets[asset_id].Type === 'text' || this.currentAssets[asset_id].Type === 'channel_number') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font')).value = this.currentAssets[asset_id].Font;
      (<HTMLInputElement>document.getElementById(asset_id + '_font_size')).value = this.currentAssets[asset_id].font_size;
    }
    if (this.currentAssets[asset_id].Type === 'text' || this.currentAssets[asset_id].Type === 'text_crawl') {
      (<HTMLInputElement>document.getElementById(asset_id + '_font_special')).checked = this.currentAssets[asset_id].font_special;
    }
    if (this.currentAssets[asset_id].Type === 'rss') { // || this.currentAssets[asset_id].Type === 'text_crawl') {
      (<HTMLInputElement>document.getElementById(asset_id + '_rate')).value = this.currentAssets[asset_id].Rate;
      (<HTMLInputElement>document.getElementById(asset_id + '_direction')).value = this.currentAssets[asset_id].direction;
    }
    if (this.currentAssets[asset_id].Type === 'text_crawl') {
      (<HTMLInputElement>document.getElementById(asset_id + '_rate')).value = this.currentAssets[asset_id].Rate;
    }
    
    if (this.currentAssets[asset_id].Type === 'image' || this.currentAssets[asset_id].Type === 'video') {
      //(<HTMLInputElement>document.getElementById(asset_id + '_playlist')).value = this.currentAssets[asset_id].playlist;
      if (this.currentAssets[asset_id].playlist) {
        const playListChkBox = (<HTMLInputElement>document.getElementById(asset_id + '_playlist'));
        playListChkBox.checked = true;
        $('.attr_showasdetails').show();
        $('.attr_hidden').show();
        $("#" + asset_id + '_image_options_a_3').text('Hide Details');
        $('#sortable').html('');
        // /addItemToPlayList
        this.currentAssets[asset_id].playlist_items.forEach((item, itemIndex) => {
          // this.addItemToPlayList(item.asset_src, item.type, item.assetUrl );
          const _asset_src = (item && item.asset_src) ? item.asset_src : item.name;
          this.createPlayListItem(itemIndex, _asset_src, item.type, item.assetUrl);
        });
        if (this.currentAssets[asset_id].Type === 'image') {
          setTimeout(function () {
            ng.playListUpdate();
          }, 2000);
        }
      }
      if (this.currentAssets[asset_id].Type === 'image') {
        if (typeof this.currentAssets[asset_id].item_duration === 'undefined') {
          this.currentAssets[asset_id].item_duration = 10;
        }
        (<HTMLInputElement>document.getElementById(asset_id + '_item_duration')).value = this.currentAssets[asset_id].item_duration;
        //(<HTMLInputElement>document.getElementById(asset_id + '_transtion')).value = this.currentAssets[asset_id].transtion;
        (<HTMLInputElement>document.getElementById(asset_id + '_image_wall')).checked = this.currentAssets[asset_id].image_wall;
      }
      // (<HTMLInputElement>document.getElementById(asset_id + '_file_name')).value = this.currentAssets[asset_id].file_name;     
    }

    // Turn each assets' 'Anchors to the default color
    for (let i = 0; i < this.currentAssetsAnchors.length; i++) {
      const anchor = this.stage.findOne('#' + this.currentAssetsAnchors[i]);
      anchor.setFill('#ddd');
    }

    // Turn the selected asset's 'Anchors' (e.g., highlight) green
    const topLeft = this.stage.findOne('#topLeft-' + asset_id);
    topLeft.setFill('green');
    const topRight = this.stage.findOne('#topRight-' + asset_id);
    topRight.setFill('green');
    const bottomRight = this.stage.findOne('#bottomRight-' + asset_id);
    bottomRight.setFill('#FFCC99');
    const bottomLeft = this.stage.findOne('#bottomLeft-' + asset_id);
    bottomLeft.setFill('green');
    this.stage.draw();

    // set the global var for the asset id to the one just selected
    this.activeAssetId = asset_id;

    if (this.currentAssets[asset_id].Type === 'image') {
      this.ImageSourceChanged();      
    }
    if(this.currentAssets[asset_id].Type === 'video') {
      this.VideoSourceChanged();
    }

    var startHide = false;

    for (const key in this.currentAssets) {
      const assetGrp = ng.stage.findOne('#' + key + '-Group');
      assetGrp.show();
      if (startHide) {
        assetGrp.hide();
      }
      if (key === asset_id) {
        startHide = true;
      }
    }

    this.layer.draw();

    this.applyColor(asset_id, '_txt_bkg_color', this.currentAssets[asset_id].background_color);
    this.applyColor(asset_id, '_txt_font_color', this.currentAssets[asset_id].font_color);
    if (this.currentAssets[asset_id].opacity) {
      const opacity = this.currentAssets[asset_id].opacity
      // this.changeOpacity(asset_id, this.currentAssets[asset_id].opacity);
      $('#' + asset_id + '_txt_opacity_label').val(((opacity ? opacity : 0) * 100) + "%");
      const opacElement = document.getElementById(asset_id + '_txt_bkg_opacity');
      if (opacElement) {
        (<HTMLInputElement>opacElement).value = opacity;
      }
    }
    $('.selectpicker').selectpicker('refresh');
  }

  /* ------------------------------------------------------------------------------------------------------ */
  /* While the user is re-sizing and moving the active asset on the stage, this function shows the
  current attribute values  */

  /* ------------------------------------------------------------------------------------------------------ */
  adjustTextPosition(asset_group): void {
    let group_child = asset_group.getChildren()[0];
    let group_child_two = asset_group.getChildren()[1];
    if (asset_group.getAttr('asset_type') === 'text' || asset_group.getAttr('asset_type') === 'text_crawl') {
      group_child_two.offsetY(group_child_two.getHeight() / 2 - group_child.getHeight() / 2);
    }
  }
  updateStats(asset_group, asset_id): void {
    const active_x = asset_group.getX();
    const active_y = asset_group.getY();
    const active_width = this.stage.findOne('#' + asset_id).getWidth();
    const active_height = this.stage.findOne('#' + asset_id).getHeight();

    let group_child = asset_group.getChildren()[0];
    let group_child_two = asset_group.getChildren()[1];
    if (asset_group.getAttr('asset_type') === 'text' || asset_group.getAttr('asset_type') === 'text_crawl') {
      group_child_two.offsetY(group_child_two.getHeight() / 2 - group_child.getHeight() / 2);
    }

    // update X value
    const xObject = (<HTMLInputElement>document.getElementById(asset_id + '_x'));
    this.currentAssets[this.activeAssetId].X = active_x;
    xObject.value = active_x;
    xObject.focus();
    xObject.blur();

    // update Y value
    const yObject = (<HTMLInputElement>document.getElementById(asset_id + '_y'));
    this.currentAssets[this.activeAssetId].Y = active_y;
    yObject.value = active_y;
    yObject.focus();
    yObject.blur();

    // update Width value
    const wObject = (<HTMLInputElement>document.getElementById(asset_id + '_width'));
    this.currentAssets[this.activeAssetId].Width = active_width;
    wObject.value = active_width;
    wObject.focus();
    wObject.blur();

    // update Height value
    const hObject = (<HTMLInputElement>document.getElementById(asset_id + '_height'));
    this.currentAssets[this.activeAssetId].Height = active_height;
    hObject.value = active_height;
    hObject.focus();
    hObject.blur();

    try {
      if ((this.gActiveResolution.split('x')[0].toString() !== active_x.toString()
        || this.gActiveResolution.split('x')[1].toString() !== active_y.toString())
        && (<HTMLInputElement>document.getElementById(asset_id + '_fullscreen')).checked) {
        (<HTMLInputElement>document.getElementById(asset_id + '_fullscreen')).checked = false;
        this.currentAssets[asset_id].full_screen = false;
      }
    } catch (e) { }
  }

  updateFullScreenStats(assetType, asset_id, isfullscreen): void {
    var active_x = 0;
    var active_y = 0;
    var active_width = 0;
    var active_height = 0;
    if (isfullscreen) {
      if (this.gActiveResolution === '1920x1080') {
        active_width = 1920;
        active_height = 1080;
      } else if (this.gActiveResolution === '1080x1920') {
        active_width = 1080;
        active_height = 1920;
      } else if (this.gActiveResolution === '1280x720') {
        active_width = 1280;
        active_height = 720;
      }
    }
    else {
      if (this.gActiveResolution === '1920x1080' || this.gActiveResolution === '1080x1920') {
        if (assetType === 'image') {
          active_x = 20;
          active_y = 20;
          active_width = 300;
          active_height = 300;
        } else if (assetType === 'video') {
          active_x = 30;
          active_y = 30;
          active_width = 1000;
          active_height = 600;
        } else if (assetType === 'browser') {
          active_x = 20;
          active_y = 20;
          active_width = 600;
          active_height = 600;
        } else if (assetType === 'youtube') {
          active_x = 30;
          active_y = 30;
          active_width = 1000;
          active_height = 600;
        }
      }
      else {
        if (assetType === 'image') {
          active_x = 20;
          active_y = 20;
          active_width = 200
          active_height = 200

        } else if (assetType === 'video') {
          active_x = 30;
          active_y = 30;
          active_width = 600;
          active_height = 400;
        } else if (assetType === 'browser') {
          active_x = 20;
          active_y = 20;
          active_width = 450;
          active_height = 450;
        } else if (assetType === 'youtube') {
          active_x = 30;
          active_y = 30;
          active_width = 600;
          active_height = 400;
        }
      }
    }
    // update X value
    const xObject = (<HTMLInputElement>document.getElementById(asset_id + '_x'));
    this.currentAssets[this.activeAssetId].X = active_x;
    xObject.value = active_x.toString();
    ng.updateAsset(asset_id + '_x', '_x');

    // update Y value
    const yObject = (<HTMLInputElement>document.getElementById(asset_id + '_y'));
    this.currentAssets[this.activeAssetId].Y = active_y;
    yObject.value = active_y.toString();
    ng.updateAsset(asset_id + '_y', '_y');

    // update Width value
    const wObject = (<HTMLInputElement>document.getElementById(asset_id + '_width'));
    this.currentAssets[this.activeAssetId].Width = active_width;
    wObject.value = active_width.toString();
    ng.updateAsset(asset_id + '_width', '_width');

    // update Height value
    const hObject = (<HTMLInputElement>document.getElementById(asset_id + '_height'));
    this.currentAssets[this.activeAssetId].Height = active_height;
    hObject.value = active_height.toString();
    ng.updateAsset(asset_id + '_height', '_height');
  }

  updateAsset(assetId, type): void {
    if ((Object.keys(this.currentAssets).length > 0) && (((<HTMLInputElement>document.getElementById(assetId)).value.length > 0) || (type === '_source') || (type === '_refresh_interval'))) {   // verify that there are assets on the stage and the value for the text box is not empty ....
      /* ---------------------------------------------------- */
      /* resize and move the selected as necessary */
      /* ---------------------------------------------------- */

      // update border value
      //const sourceObject = (<HTMLInputElement>document.getElementById(assetId + '_isborder'));
      // this.currentAssets[this.activeAssetId].IsBorder = 'yes';
      //sourceObject.value = 'test';
      //ng.updateAsset(assetId + '_isborder', '_isborder');

      const active_asset = this.stage.findOne('#' + this.activeAssetId + '-Group');  // get the Konva asset object
      let image = active_asset.get('Image')[0];  // get the image of the asset to update
      if (image === undefined) { // if there is no image as part of this asset group then make the image just the asset itself
        image = active_asset;
      }

      // get each of the current anchor positions to be used if the width or height of the asset is updated
      const topLeft = this.stage.findOne('#topLeft-' + this.activeAssetId);
      const topRight = this.stage.findOne('#topRight-' + this.activeAssetId);
      const bottomRight = this.stage.findOne('#bottomRight-' + this.activeAssetId);
      const bottomLeft = this.stage.findOne('#bottomLeft-' + this.activeAssetId);

      // determine what current value to update (e.g., Width or Height or X or Y)
      let group_child;
      switch (type) {
        case '_name':
          this.currentAssets[this.activeAssetId].Name = ((<HTMLInputElement>document.getElementById(assetId)).value);
          active_asset.attrs.name = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_fullscreen':
          this.currentAssets[this.activeAssetId].full_screen = ((<HTMLInputElement>document.getElementById(assetId)).checked);
          // update active list of assets with new value
          this.currentAssets[this.activeAssetId].border = 'no';
          (<HTMLInputElement>document.getElementById(this.activeAssetId + '_border')).checked = false;
          group_child = active_asset.getChildren()[0];
          group_child.stroke('');
          // if(this.currentAssets[this.activeAssetId].border === 'yes') {
          //   (<HTMLInputElement>document.getElementById(this.activeAssetId + '_border')).checked = false;
          //   group_child = active_asset.getChildren()[0];
          //   group_child.stroke('');
          // }

          // (<HTMLInputElement>document.getElementById(assetId + '_border')).checked = false;
          break;
        case '_border':
          this.currentAssets[this.activeAssetId].border = (<HTMLInputElement>document.getElementById(assetId)).checked ? 'yes' : 'no';
          // update active list of assets with new value
          // if(this.currentAssets[this.activeAssetId].border === 'yes') {
          //   alert(' border');
          // }
          group_child = active_asset.getChildren()[0];
          // console.log(this.currentAssets);
          if (this.currentAssets[this.activeAssetId].border === 'yes') {
            (<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked = false;
            group_child.stroke('#CCCCCC');
            if (this.currentAssets[this.activeAssetId].Type === 'image') {
              if (this.currentAssets[this.activeAssetId].Source != "") {
                group_child.strokeWidth(20);
              }
              else {
                group_child.strokeWidth(10);
              }
            }
            else {
              group_child.strokeWidth(10);
            }
            //}
            group_child.lineJoin('bevel');
            group_child.lineCap('bevel');

          } else {
            group_child.stroke('');
          }

          // group_child.setAttrs({
          //   borderSize: 5,
          //   borderColor: 'red',
          // });
          // const group_child_two2 = active_asset.getChildren()[1];

          // group_child_two2.style.border = 5;
          //group_child.borderColor('red');
          break;

        case '_x':
          // if((<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked) {
          //,0  removed
          active_asset.setX(parseInt((<HTMLInputElement>document.getElementById(assetId)).value));    // update the X value of the asset
          this.currentAssets[this.activeAssetId].X = parseInt((<HTMLInputElement>document.getElementById(assetId)).value);
          //  }
          // update active list of assets with new value
          break;
        case '_y':
          //  if((<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked) {
          active_asset.setY(parseInt((<HTMLInputElement>document.getElementById(assetId)).value));   // update the Y value of the asset
          this.currentAssets[this.activeAssetId].Y = parseInt((<HTMLInputElement>document.getElementById(assetId)).value);

          // }
          // update active list of assets with new value
          break;
        case '_width':
          let currentwidth1 = (<HTMLInputElement>document.getElementById(assetId)).value;
          if (this.gActiveResolution.split('x')[0].toString() !== currentwidth1
            && <HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen') !== null
            && (<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked) {
            (<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked = false;
            this.currentAssets[this.activeAssetId].full_screen = false;
            (<HTMLInputElement>document.getElementById(assetId)).value = currentwidth1;
          }
          image.width(parseInt(currentwidth1), 0);  // update the Width of the asset
          //image.height(parseInt(currentheight1), 0);

          topRight.setX((topLeft.getX() + image.getWidth()));
          bottomRight.setX((bottomLeft.getX() + image.getWidth()));

          group_child = active_asset.getChildren()[0];
          const w = parseInt(currentwidth1);
          group_child.width(w);
          //group_child.height(h);

          // If this object is a text or text crawl then it has an extra text box that we need to re-size
          if (
            (active_asset.getAttr('asset_type') === 'text') || (active_asset.getAttr('asset_type') === 'text_crawl')
            || (active_asset.getAttr('asset_type') === 'browser')
            || (active_asset.getAttr('asset_type') === 'channel_number')
            || (active_asset.getAttr('asset_type') === 'rss')
            || (active_asset.getAttr('asset_type') === 'text_multiline')
            || (active_asset.getAttr('asset_type') === 'clock')
          ) {
            let group_child_two = active_asset.getChildren()[1];
            group_child_two.width(group_child.getWidth());
            //group_child_two.height(group_child.getHeight());
          }

          this.currentAssets[this.activeAssetId].Width = parseInt(currentwidth1);  //update active list of assets with new value
          break;
        case '_height':
          let currentheight2 = (<HTMLInputElement>document.getElementById(assetId)).value;
          if (this.gActiveResolution.split('x')[1].toString() !== currentheight2
            && <HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen') !== null
            && (<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked) {
            (<HTMLInputElement>document.getElementById(this.activeAssetId + '_fullscreen')).checked = false;
            this.currentAssets[this.activeAssetId].full_screen = false;
            (<HTMLInputElement>document.getElementById(assetId)).value = currentheight2;
          }
          image.height(parseInt(currentheight2));  // update the Height of the asset

          bottomLeft.setY((topLeft.getY() + image.getHeight()));
          bottomRight.setY((topRight.getY() + image.getHeight()));

          group_child = active_asset.getChildren()[0];
          const h1 = parseInt(currentheight2);
          group_child.height(h1);

          // If this object is a text or text crawl then it has an extra text box that we need to re-size
          if ((active_asset.getAttr('asset_type') === 'text') || (active_asset.getAttr('asset_type') === 'text_crawl')) {
            // console.log(active_asset.getAttr('asset_type'));
            this.adjustTextPosition(active_asset);
          }
          else if ((active_asset.getAttr('asset_type') === 'browser')
            || (active_asset.getAttr('asset_type') === 'channel_number')
            || (active_asset.getAttr('asset_type') === 'rss')
            || (active_asset.getAttr('asset_type') === 'text_multiline')
            || (active_asset.getAttr('asset_type') === 'clock')
          ) {
            // console.log(active_asset.getAttr('asset_type'));
            const group_child_two = active_asset.getChildren()[1];
            const offsetY = 0 - (((topLeft.getY() + bottomLeft.getY()) / 2) - 12);
            group_child_two.offsetY(offsetY);
          }
          this.currentAssets[this.activeAssetId].Height = parseInt(currentheight2);  // update active list of assets with new value
          break;
        case '_source':
          this.currentAssets[this.activeAssetId].Source = (<HTMLInputElement>document.getElementById(assetId)).value;
          if ((<HTMLInputElement>document.getElementById(assetId)).value.length > 0) {
            if ((active_asset.getAttr('asset_type') === 'text') || (active_asset.getAttr('asset_type') === 'text_multiline')) {
              const active_asset_text_msg = this.stage.findOne('#' + this.activeAssetId + '-Text');
              active_asset_text_msg.setText((<HTMLInputElement>document.getElementById(assetId)).value);
            } else if (active_asset.getAttr('asset_type') === 'text_crawl') {
              const active_asset_text_msg = this.stage.findOne('#' + this.activeAssetId + '-Text');
              const assetText = (<HTMLInputElement>document.getElementById(assetId)).value;
              active_asset_text_msg.setText(assetText.length > 20 ? assetText.substring(0, 20) + '...' : assetText);
            }
          } else {
            if (active_asset.getAttr('asset_type') === 'text') {
              const active_asset_text_msg = this.stage.findOne('#' + this.activeAssetId + '-Text');
              active_asset_text_msg.setText('Text');
            } else if (active_asset.getAttr('asset_type') === 'text_crawl') {
              const active_asset_text_msg = this.stage.findOne('#' + this.activeAssetId + '-Text');
              active_asset_text_msg.setText('Text Scroll');
            }
          }
          group_child = active_asset.getChildren()[0];
          if (active_asset.getAttr('asset_type') === 'text') {
            const group_child_two = active_asset.getChildren()[1];
            group_child_two.offsetY(group_child_two.getHeight() / 2 - group_child.getHeight() / 2);
          }
          break;
        case '_font':
          this.currentAssets[this.activeAssetId].Font = ((<HTMLInputElement>document.getElementById(assetId)).value);
          const group_child_two = active_asset.getChildren()[1];
          if (this.currentAssets[this.activeAssetId].Font === 'Default') {
            this.currentAssets[this.activeAssetId].Font = '';
            group_child_two.fontFamily('Calibri');
          }
          else {
            group_child_two.fontFamily(this.currentAssets[this.activeAssetId].Font.replace('-Italic', ''));
          }
          group_child_two.fontStyle(this.currentAssets[this.activeAssetId].Font.includes('-Italic') ? 'Italic' : 'Normal');
          // update active list of assets with new value
          this.adjustTextPosition(active_asset);
          break;
        case '_font_size':
          if (parseInt((<HTMLInputElement>document.getElementById(assetId)).value) > 100) {
            (<HTMLInputElement>document.getElementById(assetId)).value = '100';
            return;
          }
          this.currentAssets[this.activeAssetId].font_size = ((<HTMLInputElement>document.getElementById(assetId)).value);
          const group_child_2 = active_asset.getChildren()[1];
          group_child_2.fontSize(this.currentAssets[this.activeAssetId].font_size);
          // update active list of assets with new value

          this.adjustTextPosition(active_asset);
          break;
        case '_font_special':
          this.currentAssets[this.activeAssetId].font_special = ((<HTMLInputElement>document.getElementById(assetId)).checked);
          // update active list of assets with new value
          break;
        case '_rate':
          this.currentAssets[this.activeAssetId].Rate = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_direction':
          this.currentAssets[this.activeAssetId].direction = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_time_zone':
          this.currentAssets[this.activeAssetId].time_zone = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_time_format':
          this.currentAssets[this.activeAssetId].time_format = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_date_format':
          this.currentAssets[this.activeAssetId].date_format = ((<HTMLInputElement>document.getElementById(assetId)).value);
          // update active list of assets with new value
          break;
        case '_refresh_interval':
          this.currentAssets[this.activeAssetId].RefreshInterval = ((<HTMLInputElement>document.getElementById(assetId)).value);
          break;
        case '_file_name':
          this.currentAssets[this.activeAssetId].file_name = ((<HTMLInputElement>document.getElementById(assetId)).value);
          break;
        case '_item_duration':
          this.currentAssets[this.activeAssetId].item_duration = ((<HTMLInputElement>document.getElementById(assetId)).value);
          break;
        case '_transtion':
          this.currentAssets[this.activeAssetId].transtion = ((<HTMLInputElement>document.getElementById(assetId)).value);
          break;
        case '_image_wall':
          this.currentAssets[this.activeAssetId].image_wall = ((<HTMLInputElement>document.getElementById(assetId)).checked);
          break;
        case '_def_source':
          const value = (<HTMLInputElement>document.getElementById(assetId)).value;
          const tempAssetId = assetId.replace('_def_source', '') + '_source';

          if (!value || value === '0' || value === '1' || value === '2' || value === '4') {
            ((<HTMLInputElement>document.getElementById(tempAssetId)).value) = '';
            break;
          } if (value === '6') {
            ((<HTMLInputElement>document.getElementById(tempAssetId)).value) = 'folder';
            break;
          } else if (value === '3') {
            this.show_publish_modal(false);
            break;
          }
          this.currentAssets[this.activeAssetId].Source = value;
          ((<HTMLInputElement>document.getElementById(tempAssetId)).value) = this.currentAssets[this.activeAssetId].Source;
          // console.log(tempAssetId);
          break;
        case '_audio_def_source':
          const audioSourceValue = (<HTMLInputElement>document.getElementById(assetId)).value;
          const sourceAssetId = assetId.replace('_audio_def_source', '') + '_source';
          this.currentAssets[this.activeAssetId].Source = audioSourceValue;
          ((<HTMLInputElement>document.getElementById(sourceAssetId)).value) = this.currentAssets[this.activeAssetId].Source;
          break;
      }

      this.layer.draw();
    }
  }

  /* ------------------------------------------------------------------------------------------------------ */
  /* When the user wants to delete the active asset on the stage */

  /* ------------------------------------------------------------------------------------------------------ */
  delete_active_asset(): boolean {
    const group = this.stage.findOne('#' + this.activeAssetId + '-Group');  // get the asset that needs to be removed
    if (typeof group === 'undefined') {
      return false;
    }
    group.destroy();  // remove the asset from the stage
    this.layer.draw();

    // Remove the anchors for this asset from the array of list of asset' anchors
    this.remove_anchors('topLeft-' + this.activeAssetId);
    this.remove_anchors('topRight-' + this.activeAssetId);
    this.remove_anchors('bottomRight-' + this.activeAssetId);
    this.remove_anchors('bottomLeft-' + this.activeAssetId);
    // this.currentAssetsAnchors.remove_from_array('topLeft-' + this.activeAssetId);
    // this.currentAssetsAnchors.remove_from_array('topRight-' + this.activeAssetId);
    // this.currentAssetsAnchors.remove_from_array('bottomRight-' + this.activeAssetId);
    // this.currentAssetsAnchors.remove_from_array('bottomLeft-' + this.activeAssetId);

    // Then, remove this asset from the list of active assets array
    delete this.currentAssets[this.activeAssetId];
    // currentAssets.remove_from_array(activeAssetId);

    // Lastly, clear out the coordinates values that are showing for this asset
    // show the initial coordinate values
    (<HTMLInputElement>document.getElementById(this.activeAssetId + '_x')).value = '';
    (<HTMLInputElement>document.getElementById(this.activeAssetId + '_y')).value = '';
    (<HTMLInputElement>document.getElementById(this.activeAssetId + '_width')).value = '';
    (<HTMLInputElement>document.getElementById(this.activeAssetId + '_height')).value = '';

    this.show_assets('');
    this.show_attributes('', '');
    return true;
  }

  openScreenshotPopUp() {
    // this.screenshotAppPath = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.digitalmediabridge.tv/Screen-Builder/assets/content/admin/manageclients/UpdateScreenshot/ss.html');
    this.screenshotAppPath = this.sanitizer.bypassSecurityTrustResourceUrl(this.appSettings.getConfig('APP_NAME') + 'assets/content/' + this.currentUser.homeDirectory + '/manageclients/UpdateScreenshot/ss.html');

    // this.screenshotAppPath = this.sanitizer.bypassSecurityTrustResourceUrl('/assets/content/' + this.currentUser.homeDirectory + '/manageclients/UpdateScreenshot/ss.html');
    this.openModel(this.screenShotModal, { windowClass: 'screenshotModalClass' }, 'screenshot');
  }

  openSiteLogModal() {
    this.siteLogAppPath = this.sanitizer.bypassSecurityTrustResourceUrl(this.appSettings.getConfig('APP_NAME') + 'assets/content/' + this.currentUser.homeDirectory + '/manageclients/UpdateSiteLogs/lf.html');
    this.openModel(this.logWebModal, { windowClass: 'siteLogModalClass' }, 'siteLog');
  }

  delete_an_asset(assetId): boolean {
    const group = this.stage.findOne('#' + assetId + '-Group');  // get the asset that needs to be removed
    if (typeof group === 'undefined') {
      return false;
    }
    group.destroy();  // remove the asset from the stage
    this.layer.draw();

    if (this.currentAssets[assetId].Type === 'browser') {

      try {
        document.getElementById('canvasContainer').removeChild(document.getElementById(assetId + '_div_browser_source'));
        document.getElementById('canvasContainer').removeChild(document.getElementById(assetId + '_lbl_browser_timer'));
      }
      catch (e) {

      }
    }

    // Remove the anchors for this asset from the array of list of asset' anchors
    this.remove_anchors('topLeft-' + assetId);
    this.remove_anchors('topRight-' + assetId);
    this.remove_anchors('bottomRight-' + assetId);
    this.remove_anchors('bottomLeft-' + assetId);

    // Then, remove this asset from the list of active assets array
    delete this.currentAssets[assetId];
    // currentAssets.remove_from_array(activeAssetId);

    // Lastly, clear out the coordinates values that are showing for this asset
    // show the initial coordinate values
    if ((<HTMLInputElement>document.getElementById(assetId + '_x')) !== null) {
      (<HTMLInputElement>document.getElementById(assetId + '_x')).value = '';
      (<HTMLInputElement>document.getElementById(assetId + '_y')).value = '';
      (<HTMLInputElement>document.getElementById(assetId + '_width')).value = '';
      (<HTMLInputElement>document.getElementById(assetId + '_height')).value = '';
    }

    this.show_assets('');
    this.show_attributes('', '');
    return true;
  }
  setCurrentActiveAsset(asset) {
    // console.log(asset);
    const myAsset = this.stage.findOne('#' + asset.getAttr('_assetId') + '-Group');
    if (typeof myAsset !== 'undefined') {
      ng.show_attributes(asset.getAttr('asset_type'), asset.getAttr('_assetId'));    // show image attributes
      //this.currentAssets[asset.getAttr('_assetId')].playlist = false;
      ng.newAssetClicked(asset, asset.getAttr('_assetId'));
    }
  }
  deleteAssetFromList($event, asset) {
    this.myElement.splice($event, 1);
    // console.log('dssfsfsdf first ', this.currentAssets, asset);
    // this.currentAssets.splice(0);
    this.delete_an_asset(asset.attrs._assetId);
    // console.log('dssfsfsdf last', this.currentAssets);
  }


  remove_anchors(what: string): void {
    const a = arguments;
    let L = a.length;
    let ax;
    while (L && this.currentAssetsAnchors.length) {
      what = a[--L];
      while ((ax = this.currentAssetsAnchors.indexOf(what)) !== -1) {
        this.currentAssetsAnchors.splice(ax, 1);
      }
    }
  }
  // @HostListener('window:mousemove') refreshUserState() {
  //   debugger;
  //   this.counter = 0;
  //   this.checkUserIdle();
  //   //clearTimeout(this.userActivity);
  //   //this.checkUserIdle();

  //   // if(this.counter >= 5) //2 minutes
  //   // {
  //   //   //reset counter value = 0
  //   //   this.counter =0;
  //   //   this.onLogout();
  //   //   //clearTimeout(this.userActivity);
  //   //   //this.setTimeout();
  //   // }
  //   // else{
  //   //  // this.counter = 0;
  //   // }
  // }

  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent): void {
    event.stopPropagation();
    if (event.keyCode === 46 && document.activeElement.tagName === 'BODY') {
      this.delete_active_asset();
    }
  }

  updateColor(picker, asset) {
    const sel_color = picker.toHEXString();
    let sel_color_hex = picker.toRGBString();
    sel_color_hex = sel_color_hex.replace(/rgb/g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/\,/g, '.');
    sel_color_hex = '255.' + sel_color_hex;
    if (asset === 'bkg_color') {  // c hange the sign background color
      const stage = document.getElementById('canvasContainer');
      stage.style.backgroundColor = sel_color;
    } else if (asset === '_txt_font_color') {  // if the user has selected to update the font color of a text asset
      const active_txt_asset_font = this.stage.findOne('#' + this.activeAssetId + '-Text');
      active_txt_asset_font.fill(sel_color);
      this.currentAssets[this.activeAssetId].font_color = sel_color_hex;
    } else if (asset === '_txt_bkg_color') {  // background color of the text asset
      const active_txt_asset = this.stage.findOne('#' + this.activeAssetId);
      active_txt_asset.fill(sel_color);
      this.currentAssets[this.activeAssetId].background_color = sel_color_hex;//+ '.0';
    }
    this.layer.draw();
  }

  changeOpacity(opacity, assetId) {
    if (this.currentAssets[assetId].Type != 'image' && this.currentAssets[assetId].Type != 'video') {
      const active_txt_asset = this.stage.findOne('#' + assetId);
      active_txt_asset.opacity(1 - opacity);
      this.layer.draw();
      this.currentAssets[assetId].opacity = opacity;
      $('#' + assetId + '_txt_opacity_label').val(((opacity ? opacity : 0) * 100) + "%");
    }
  }

  ngAfterViewInit() {

    this.changeCanvasResolution();
    this.setZoomLevel();

    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
    $('[data-submenu]').submenupicker();
    // $('.mdb-select').materialSelect();
    // this.ezTVLogin();
    $(".card-block").click(function () {
      ng.isScreenSaved = false;
    });
  }

  updateImageAsset(asset_src, type, assetUrl?: any, isEzTv?: boolean, asset_name?: string): any {
    // if (this.isPlayListAcitve && type === 'video' && isEzTv) {
    //   this.authService.showNotification('Please select files.', 'error');
    //   return false;
    // }
    var playlist_count = 0;
    if (this.currentAssets[this.activeAssetId].playlist) {
      for (const key in this.currentAssets[this.activeAssetId].playlist_items) {
        playlist_count++;
      }
    }

    if (playlist_count == 10) {
      this.authService.showNotification('', 'You cannot add more than 10 <br/> images in a playlist', 'error');
      return;
    }

    if (type === 'image') {
      //if (this.isPlayListAcitve) {
      const active_asset = this.stage.findOne('#' + this.activeAssetId + '-Group');
      const group_child_border = active_asset.getChildren(0);
      // group_child_border.strokeWidth(20);

      if (this.currentAssets[this.activeAssetId].playlist) {
        const fileName = asset_name ? asset_name : asset_src.replace(/^.*[\\\/]/, '');
        var isExistingItem = false;
        for (const key in this.currentAssets[this.activeAssetId].playlist_items) {
          if (this.currentAssets[this.activeAssetId].playlist_items[key].name === fileName) {
            isExistingItem = true;
            break;
          }
        }
        if (!isExistingItem) {
          (<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value = '';
          this.addItemToPlayList(asset_src, type, assetUrl, asset_name);
        }
      }
      const currentSrs = this.currentAssets[this.activeAssetId].Source;
      if (this.currentAssets[this.activeAssetId].playlist && currentSrs !== '') {
        return false;
      }
    } else if (type === 'audio') {
      const active_group = this.stage.findOne('#' + this.activeAssetId + '-Group');
      let group_child = active_group.getChildren()[0];
      const imageSrc = 'assets/img/Audio-Circle-Icon-1920x1080.png';
      const imageObj1 = new Image();
      imageObj1.onload = function () {
        group_child.image(imageObj1);
        ng.layer.draw();
      };
      imageObj1.src = imageSrc;
    } else if (type === 'video') {
      const active_group = this.stage.findOne('#' + this.activeAssetId + '-Group');
      let group_child = active_group.getChildren()[0];
      const imageSrc = 'assets/img/video_skewed.png';
      const imageObj1 = new Image();
      imageObj1.onload = function () {
        group_child.image(imageObj1);
        ng.layer.draw();
      };
      imageObj1.src = imageSrc;
    }
    this.updateImageAttributes(asset_src, type, assetUrl, isEzTv, asset_name);

    if (type === 'image') {
      this.ImageSourceChanged();
    }
    if (type === 'video') {
      this.VideoSourceChanged();
    }
  }

  updateImageAttributes(asset_src, type, assetUrl?: any, isEzTv?: boolean, asset_name?: string): any {

    if (type == "image") {
      if (asset_src) {
        var dotIndex = asset_src.lastIndexOf('.');
        var ext = asset_src.substring(dotIndex);
        if (asset_src.includes('http')) {
          //if http error then load default images
          var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
          assetUrl = url;
        }
        else {
          if (ext == '.jpg' || ext == '.png' || ext == '.jpeg' || ext == '.gif' || ext == '.bmp' || ext == '.svg' || ext == '.ico') {
            if (asset_src.includes('assets/content/')) {
              assetUrl = assetUrl;
            }
            else {
              var imageExist = false;
              this.currentImages.forEach(image => {
                if (image.name === asset_src) {
                  const user = this.authService.currentUser;
                  var url = window.location + "/assets/content/" + user.userName + "/images/" + asset_src;
                  assetUrl = url;
                  imageExist = true;
                }

              });
              if (!imageExist) {
                //if image not exist then load default images
                var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
                assetUrl = url;
              }
            }
          }
          else {
            //if type error then load default images
            var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
            assetUrl = url;
          }
        }
      }

    }

    const active_group = this.stage.findOne('#' + this.activeAssetId + '-Group');
    if (type === 'image') {
      // first, get the Object for the just added (or clicked) asset
      const imageObj = this.activeImageParent.get('Image')[0];
      // then, create a new Image object and replace the old with the new
      const NewImageObj = new Image();
      NewImageObj.onload = function () {
        imageObj.image(NewImageObj);
        ng.layer.draw();
      };

      NewImageObj.src = assetUrl;  // asset_src is passed into the function as: 'img/myimage.jpg'
    }
    // Lastly, update the list of assets object to include the source image just selected
    if (!isEzTv) {
      asset_src = (typeof asset_src === 'undefined') ? '' : asset_src;
      const url = asset_src.split('/');
      const just_file = url[url.length - 1];
      this.currentAssets[this.activeAssetId].Source = just_file.trim();
    } else {
      const url = asset_src;
      this.currentAssets[this.activeAssetId].Source = url;
    }
    if (type === 'audio') {
      let val = this.currentAssets[this.activeAssetId].Source;
      let name = $("#" + this.activeAssetId + "_audio_def_source" + " option[value='" + val + "']").text();
      this.currentAssets[this.activeAssetId].Name = name.substr(0, 30);
      active_group.attrs.name = this.currentAssets[this.activeAssetId].Name;
    } else if (type === 'video') {
      let val = this.currentAssets[this.activeAssetId].Source;
      let name = $("#" + this.activeAssetId + "_def_source" + " option[value='" + val + "']").text();
      this.currentAssets[this.activeAssetId].Name = name.substr(0, 30);
      active_group.attrs.name = this.currentAssets[this.activeAssetId].Name;
    }
    if (((typeof this.currentAssets[this.activeAssetId].playlist === 'undefined' || !this.currentAssets[this.activeAssetId].playlist) && type === 'image') || type === 'audio' || type === 'video') {
      this.currentAssets[this.activeAssetId].Source = this.currentAssets[this.activeAssetId].Source.substring(0, 2000);
      (<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value = this.currentAssets[this.activeAssetId].Source;
      (<HTMLInputElement>document.getElementById(this.activeAssetId + '_name')).value = this.currentAssets[this.activeAssetId].Name;
      // if (asset_name) {
      //   this.currentAssets[this.activeAssetId].Name = asset_name;
      //   (<HTMLInputElement>document.getElementById(this.activeAssetId + '_name')).value = this.currentAssets[this.activeAssetId].Name;
      // }
    }
  }

  ImageSourceChanged(): any {
    // alert(this.currentAssets[this.activeAssetId].Type);
    // alert((<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value);
    if(this.currentAssets[this.activeAssetId].Type === 'image' &&
      (<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value.trim() !== '' &&
    !this.currentAssets[this.activeAssetId].playlist) {
      $("#_resize_to_source").removeClass('disabled');
    } else {
      $("#_resize_to_source").addClass('disabled');
    }

    if((<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value.trim() === '' &&
    !this.currentAssets[this.activeAssetId].playlist) {
      const imageObj = this.activeImageParent.get('Image')[0];
      // then, create a new Image object and replace the old with the new
      const NewImageObj = new Image();
      NewImageObj.onload = function () {
        imageObj.image(NewImageObj);
        ng.layer.draw();
      };

      // Load default image
      var assetUrl = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
      NewImageObj.src = assetUrl;
    }
  }

  VideoSourceChanged(): any {

    var ext = (<HTMLInputElement>document.getElementById(this.activeAssetId + '_source')).value.split('.').pop() || '';
    var playlistCheckBox = document.getElementById(this.activeAssetId + '_playlist');
    // playlistCheckBox.setAttribute('checked', 'true');
    playlistCheckBox.removeAttribute('checked');
    playlistCheckBox.removeAttribute('disabled');

    if(ext === 'm3u') {
      $('.attr_showforhls').show();
      // playlistCheckBox.setAttribute('checked', 'true');
      // playlistCheckBox.dispatchEvent(new Event('change', { bubbles: true }));
      playlistCheckBox.click();
    } else {
      $('.attr_showforhls').hide();
    }

    playlistCheckBox.setAttribute('disabled', 'disabled');
  }

  ResizeImageAssetToSource(): any {
    var assetId = this.activeAssetId + '_source';
    var srcImg = new Image();
    srcImg.src = 'assets/content/' + this.username + '/images/' + encodeURIComponent((<HTMLInputElement>document.getElementById(assetId)).value);
    srcImg.onload = 
            function () {
              var width = srcImg.width;
              var height = srcImg.height;
              
              if(ng.isPortraitView && width > height) {
                ng.authService.showNotification('Error', 'Resize to source is not allowed for this image', 'error');
                return;

              } else if(!ng.isPortraitView && width < height) {
                ng.authService.showNotification('Error', 'Resize to source is not allowed for this image', 'error');
                return;
              }

              var active_x = 0;
              var active_y = 0;
              var active_width = width;
              var active_height = height;
      
              // update X value
              const xObject = (<HTMLInputElement>document.getElementById(ng.activeAssetId + '_x'));
              ng.currentAssets[ng.activeAssetId].X = active_x;
              xObject.value = active_x.toString();
              ng.updateAsset(ng.activeAssetId + '_x', '_x');

              // update Y value
              const yObject = (<HTMLInputElement>document.getElementById(ng.activeAssetId + '_y'));
              ng.currentAssets[ng.activeAssetId].Y = active_y;
              yObject.value = active_y.toString();
              ng.updateAsset(ng.activeAssetId + '_y', '_y');

              // update Width value
              const wObject = (<HTMLInputElement>document.getElementById(ng.activeAssetId + '_width'));
              ng.currentAssets[ng.activeAssetId].Width = active_width;
              wObject.value = active_width.toString();
              ng.updateAsset(ng.activeAssetId + '_width', '_width');

              // update Height value
              const hObject = (<HTMLInputElement>document.getElementById(ng.activeAssetId + '_height'));
              ng.currentAssets[ng.activeAssetId].Height = active_height;
              hObject.value = active_height.toString();
              ng.updateAsset(ng.activeAssetId + '_height', '_height');
            };  
  }

  show_assets(asset_type): void {
    // Console.log(asset_type)
    let aAssets = [];
    switch (asset_type) {

      case 'image':
        aAssets = this.currentImages;
        $('#video-slider-parent').hide();
        $('#no-slider-parent').hide();
        if (this.currentImages.length > 0) {
          $('#image-slider-parent').show();
          if (this.imageSliderLoaded === false) {
            const elements = document.getElementsByClassName('lSAction');
            while (elements.length > 0) {
              elements[0].parentNode.removeChild(elements[0]);
            }

            $('#image-slider').lightSlider({
              keyPress: false,
              pager: false,
              item: 5,
              loop: false,
              onSliderLoad: function () {
                $('#image-slider').removeClass('cS-hidden');
              }
            });
            this.imageSliderLoaded = true;
            this.videoSliderLoaded = false;
          }
        }
        break;
      case 'video':
        aAssets = this.currentVideos;
        $('#image-slider-parent').hide();
        $('#no-slider-parent').hide();
        if (this.currentVideos.length > 0) {
          $('#video-slider-parent').show();
          if (this.videoSliderLoaded === false) {
            const elements = document.getElementsByClassName('lSAction');
            while (elements.length > 0) {
              elements[0].parentNode.removeChild(elements[0]);
            }

            $('#video-slider').lightSlider({
              keyPress: false,
              pager: false,
              item: 5,
              loop: false,
              onSliderLoad: function () {
                $('#video-slider').removeClass('cS-hidden');
              }
            });
            this.videoSliderLoaded = true;
            this.imageSliderLoaded = false;
          }
        }
        break;
      default:
        $('#image-slider-parent').hide();
        $('#video-slider-parent').hide();
        $('#no-slider-parent').show();
        this.imageSliderLoaded = false;
        this.videoSliderLoaded = false;
        break;
    }
    // before showing the user the list of available assets, make sure that there are some to show
    if (aAssets.length === 0 && asset_type !== 'text') {
      if (this.authService.isLoggedIn) {
        // this.authService.showNotification('There are no ' + asset_type + ' assets for user.', 'error');
      } else {
        this.authService.showNotification('',
          'Please login to see the list of available ' + asset_type + ' assets you can add to the sign.', 'error');
      }
      return;
    }
  }

  /**
   *   When the user clicks the Save button from the toolbar open the pop-up window and ask for the screenlist file name
   */
  save_screenlist(isShowNotification: boolean): void {
    //  debugger;
    var currentDate = new Date();

    if (typeof this.lastSaveDateTime !== 'undefined' && this.lastSaveDateTime !== '') {
      var diff = (currentDate.valueOf() - this.lastSaveDateTime.valueOf());
      var resultInMinutes = Math.round(diff / 60000);
      if (resultInMinutes >= 120) {
        this.onLogout();
        return;
      }
    }

    this.lastSaveDateTime = currentDate;

    this.gActiveScreenlistFile = 'dmb.screenlist.01.xml';
    var isValid = true;

    if (this.authService.isLoggedIn) {
      if (Object.keys(this.currentAssets).length === 0) {
        if (isShowNotification) {
          this.authService.showNotification('', 'You must add at least one <br/> asset to the screen.', 'info');
        }
      } else {
        for (const key in this.currentAssets) {
          if ((this.currentAssets[key].playlist === true && $("#" + key + "_name").val() === '')) {
            if (isShowNotification) {
              this.authService.showNotification('Error', 'Please provide a name for playlist', 'error');
            }
            isValid = false;
            break;
          } else if (((this.currentAssets[key].Type === 'image' && this.currentAssets[key].playlist === false)
            || this.currentAssets[key].Type === 'video'
            || this.currentAssets[key].Type === 'text' || this.currentAssets[key].Type === 'browser'
            || this.currentAssets[key].Type === 'text_crawl' || this.currentAssets[key].Type === 'youtube')
            && (typeof this.currentAssets[key].Source === 'undefined' || this.currentAssets[key].Source === '')) {
            if (isShowNotification) {
              this.authService.showNotification('Error', 'Please provide a Source value for each asset', 'error');
            }
            isValid = false;
            break;
          } else if (this.currentAssets[key].Type === 'text' || this.currentAssets[key].Type === 'text_crawl') {
            const active_group = this.stage.findOne('#' + key + '-Group');
            let group_child = active_group.getChildren()[0];
            const group_child_two = active_group.getChildren()[1];

            if ((group_child_two.getHeight() - group_child.getHeight()) > 10) {
              if (this.currentAssets[key].Type === 'text') {
                if (isShowNotification) {
                  this.authService.showNotification('Error', 'The text inside the Text asset <br/> must fit inside the asset', 'error');
                }
              } else if (this.currentAssets[key].Type === 'text_crawl') {
                if (isShowNotification) {
                  this.authService.showNotification('Error', 'The text inside the Text Scroll <br/> asset must fit inside the asset', 'error');
                }
              }
              isValid = false;
              break;
            }
          } else if (this.currentAssets[key].Type === 'browser') {
            if (typeof this.currentAssets[key].RefreshInterval !== 'undefined' && this.currentAssets[key].RefreshInterval !== '') {
              var rI = parseFloat(this.currentAssets[key].RefreshInterval)
              if (rI < 15 || rI > 86400) {
                if (isShowNotification) {
                  this.authService.showNotification('Error', 'The value of refresh interval <br/> must be between 15 and 86400', 'error');
                }
                isValid = false;
                break;
              }
            }
          }
        }
        if (isValid) {
          this.create_screenlist_file(isShowNotification);
        }
      }
    } else {
      if (isShowNotification) {
        this.authService.showNotification('', 'Please login first.', 'info');
      }
    }

    //OLD CODE COMMENTED ON 04/29/2021 SOUNAK

    // this.gActiveScreenlistFile = 'dmb.screenlist.00.xml';
    // if (this.authService.isLoggedIn) {
    //   if (Object.keys(this.currentAssets).length === 0) {
    //     this.authService.showNotification('You must add at least one asset to the screen.', 'error');
    //   } else {
    //     this.openModel(this.fileNameModel);
    //   }
    // } else {
    //   this.authService.showNotification('Please login first.', 'error');
    // }

    //OLD CODE END
  }

  preview_screenlist() {

    if (!this.isScreenSaved) {
      this.authService.showNotification('', 'Please save file first to preview', 'error');
      return false;
    }
    this.openModel(this.previewScreenListModal, { size: 'previewScreen' }, 'Preview Screen');
    this.previewScreenUrl = 'assets/content/' + this.currentUser.homeDirectory + '/xmls/' + this.signName + '/preview.html';
    $('#iframePreviewScreen').attr('src', this.previewScreenUrl);

    if(parseInt(this.gActiveResolution.split('x')[0]) > parseInt(this.gActiveResolution.split('x')[1])) {
      $('#iframePreviewScreen').attr('width', '854px');
      $('#iframePreviewScreen').attr('height', '480px');
    } else {
      $('#iframePreviewScreen').attr('width', '480px');
      $('#iframePreviewScreen').attr('height', '854px');
    }
  }

  openModel(content, config?: object, type?: string) {
    if (typeof config === 'undefined') {
      config = {};
    }
    this.modalRef = this.modalService.open(content, config);

    if (type === 'channel-modal') {
      this.modalRef.result.then((result) => {
        this.updateVideoChannelList();
      }, (reason) => {
        this.updateVideoChannelList();
      });
    } else if (type === 'screenshot') {
      this.modalRef.result.then((result) => {
        // console.log('`Closed with: ${result}`');
      }, (reason) => {
        this.screenService.readScreenShotData('admin').subscribe((data) => {
          data = data.split('\n');
          this.updateImageAsset(data[1], 'image', data[1], true, data[0]);
        });
      });

    } else if (type === 'player_status') {
      this.modalRef.result.then((result) => {
        // console.log('`Closed with: ${result}`');
      }, (reason) => {
        clearInterval(ng.playerStatusIntervalID);
      });
    } else {
      this.modalRef.result.then((result) => {
        // console.log('`Closed with: ${result}`');

      }, (reason) => {
        if (this.selectedModel === 'resolution' && this.gActiveResolution !== this.selectedResolution) {
          this.gActiveResolution = this.selectedResolution;
        }
        this.selectedModel = null;
        // console.log('`Dismissed ${this.getDismissReason(reason)}`');
      });
    }
  }

  closeModal(): void {
    if (this.modalRef) {
      if (this.selectedModel === 'resolution' && this.gActiveResolution !== this.selectedResolution) {
        this.gActiveResolution = this.selectedResolution;
      }
      this.selectedModel = null;
      this.modalRef.close();
    }
  }

  valid_asset_position(asset) {
    if (asset.X < 0 || asset.Y < 0 || asset.X + asset.Width > this.stageWidth || asset.Y + asset.Height > this.stageHeight) {
      return false;
    }
    return true;
  }

  getBackGroundColor(key) {
    let backGroudColor = this.currentAssets[key].background_color ? this.currentAssets[key].background_color : '255.0.0.0';
    if (this.currentAssets[key].opacity) {
      // const opacityMapping = {
      //   0: 0,
      //   0.1: 26,
      //   0.2: 51,
      //   0.3: 77,
      //   0.4: 102,
      //   0.5: 128,
      //   0.6: 153,
      //   0.7: 179,
      //   0.8: 204,
      //   0.9: 230,
      //   1: 255
      // };

      const opacityMapping = {
        0: 255,
        0.1: 230,
        0.2: 204,
        0.3: 179,
        0.4: 153,
        0.5: 128,
        0.6: 102,
        0.7: 77,
        0.8: 51,
        0.9: 26,
        1: 0
      };

      opacityMapping[this.currentAssets[key].opacity]
      backGroudColor = opacityMapping[this.currentAssets[key].opacity] + '.' + backGroudColor.split('.').splice(1, 3).join('.')
    }
    return backGroudColor;

  }

  create_screenlist_array(): object {
    // first, tell the user that the saving process has started
    this.savigFile = true;

    this.gFilesToBeDelivered = [];
    // set the global var0iable name to the just provided screenlist name

    // *****************************************************
    // ** Get each of the required values to be entered into the file **
    // *****************************************************
    const now = new Date();
    const dmb_attributes = {
      'version': '1.0',
      'timestamp': this.currentTimeStamp()
    };
    const screenlist_attributes = {
      'filename': this.gActiveScreenlistFile,
      'name': ((<HTMLInputElement>document.getElementById('sign-name')).value.length > 0 ?
        (<HTMLInputElement>document.getElementById('sign-name')).value : this.signName.length > 0 ?
          this.signName : 'Screen ' + this.ramdomid()),
      'resolution': this.gActiveResolution,
      'content_directory': this.gContentDirectory
    };
    (<HTMLInputElement>document.getElementById('sign-name')).value = screenlist_attributes.name;
    this.signName = screenlist_attributes.name; 
    // the screen background color is from the global 'color_picker' object's current RGB color values
    const bkg_color = '255.' + Math.round(this.color_picker_canvas.rgb[0]) + '.' + Math.round(this.color_picker_canvas.rgb[1]) + '.' + Math.round(this.color_picker_canvas.rgb[2]);
    let screen_attributes = {
      'name': ((<HTMLInputElement>document.getElementById('sign-name')).value.length > 0 ?
        (<HTMLInputElement>document.getElementById('sign-name')).value : this.signName.length > 0 ?
          this.signName : 'Screen ' + this.ramdomid()),
      'on_boot_only': 'no',
      'active': 'yes',
      'background_color': bkg_color,
      'exit_on_video_end': 'no'
    };


    // *****************************************************
    // ** Loop over each asset on the stage to add to object before
    //   sending the object to PHP file  **
    // *****************************************************
    const assets = [];
    for (const key in this.currentAssets) {
      if (this.currentAssets.hasOwnProperty(key)) {
        // check if all  assets are within range
        if (!this.valid_asset_position(this.currentAssets[key])) {
          this.authService.showNotification('Assets cannot be placed outside of stage', 'error', 'error');
          return;
        }
        this.getBackGroundColor(key);

        const aType = this.currentAssets[key].Type;
        const assetItem = {
          'type': aType,
          // 'name': this.currentAssets[key].Type === 'youtube' ? 'YouTubePlayer' : this.currentAssets[key].Name,
          'name': this.currentAssets[key].Name,
          'x': this.currentAssets[key].X,
          'y': this.currentAssets[key].Y,
          'width': this.currentAssets[key].Width,
          'height': this.currentAssets[key].Height,
          'source': this.currentAssets[key].Source,
          'fit': 'yes',
          'background_color': this.getBackGroundColor(key),
          'font_color': this.currentAssets[key].font_color,
          'direction': this.currentAssets[key].direction,
          'rate': this.currentAssets[key].Rate,
          'font': this.currentAssets[key].Font === 'Default' ? '' : this.currentAssets[key].Font,
          'font_size': this.currentAssets[key].font_size,
          'time_zone': this.currentAssets[key].time_zone,
          'refresh_interval': this.currentAssets[key].RefreshInterval,
        };
        if (this.currentAssets[key].Type === 'video' && this.currentAssets[key].Source === 'folder') {
          assetItem['playlist'] = true;
          assetItem['file_name'] = 'folder';
          // assetItem['x'] = '0';
          // assetItem['y'] = '0';
          // assetItem['width'] = '1152';
          // assetItem['height'] = '648';
          // assetItem['background_color'] = '0.0.0.0';
          assetItem['item_order'] = 'random';
        }
        if ((this.currentAssets[key].Type === 'image' || this.currentAssets[key].Type === 'video')
          && typeof this.currentAssets[key].playlist !== 'undefined' && this.currentAssets[key].playlist) {
          if (this.currentAssets[key].Type === 'image') {
            assetItem['item_duration'] = this.currentAssets[key].item_duration;
            // assetItem['transition'] = this.currentAssets[key].transtion;
            if (typeof this.currentAssets[key].image_wall !== 'undefined' && this.currentAssets[key].image_wall)
              assetItem['transition'] = 'image_wall';
            else
              assetItem['transition'] = 'none';
            assetItem['background_color'] = '0.0.0.0';
          }
          if (this.currentAssets[key].Type === 'video') {
            assetItem['item_duration'] = this.currentAssets[key].item_duration;
          }
          assetItem['playlist'] = this.currentAssets[key].playlist;
          assetItem['playlist_items'] = this.currentAssets[key].playlist_items;
          assetItem['file_name'] = this.currentAssets[key].file_name;
        }
        if (this.currentAssets[key].Type === 'image') {
          assetItem['background_color'] = '0.0.0.0';
        }
        if (this.currentAssets[key].Type === 'image' || this.currentAssets[key].Type === 'video') {
          if (this.currentAssets[key].border != null) {
            assetItem['border'] = this.currentAssets[key].border.toLowerCase();
          }
          //  debugger;
          // alert(JSON.stringify(this.currentAssets));
          const active_asset = this.stage.findOne('#' + this.activeAssetId + '-Group');
          const group_child_border = active_asset.getChildren(0);
          if (assetItem['border'] == 'yes') {
            if (this.currentAssets[key].Type === 'image') {
              group_child_border.stroke('#CCCCCC');
              group_child_border.strokeWidth(10);
              group_child_border.lineJoin('bevel');
              group_child_border.lineCap('bevel');
            }
            else {
              group_child_border.stroke('#CCCCCC');
              group_child_border.strokeWidth(10);
              group_child_border.lineJoin('bevel');
              group_child_border.lineCap('bevel');
            }
          }
          else {
            group_child_border.stroke('');
          }
        }
        if (this.currentAssets[key].Type === 'clock') {
          assetItem['time_format'] = this.currentAssets[key].time_format;
          assetItem['date_format'] = this.currentAssets[key].date_format;
        }
        if (this.currentAssets[key].Type === 'text' || this.currentAssets[key].Type === 'text_crawl') {
          if (this.currentAssets[key].font_special) {
            assetItem['font_special'] = 'inset';
          }
        }

        // add this asset to the list of assets that need to be included when the screenlist file is built
        assets.push(assetItem);
        // if necessary, check to see if we need to include a seperate file that is required for this asset that should be delivered
        if (this.currentAssets[key].Type !== 'text' && this.currentAssets[key].Source.length > 0) {
          const file_to_send = $.grep(this.gContentAllFiles, function (element, index) {
            return element.name === ng.currentAssets[key].Source;
          });
          // console.log(file_to_send)
          if (typeof file_to_send[0] !== 'undefined') {
            this.gFilesToBeDelivered.push({
              'name': file_to_send[0].name,
              'last_modified': file_to_send[0].last_modified,
              'size': file_to_send[0].size
            });
          }
        }
      }
    }
    const user = this.authService.currentUser;
    let fileData;
    if (this._templatePath === false) {
      fileData = {
        UserName: user.userName,
        userID: user.userID,
        DmbAttributes: dmb_attributes,
        ScreenlistAttributes: screenlist_attributes,
        ScreenAttributes: screen_attributes,
        ScreenAssets: assets
      };
    } else {
      fileData = {
        UserName: user.userName,
        userID: user.userID,
        DmbAttributes: dmb_attributes,
        ScreenlistAttributes: screenlist_attributes,
        ScreenAttributes: screen_attributes,
        ScreenAssets: assets,
        RelativePath: this._templatePath
      };
    }
    return fileData;
  }

  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  create_screenlist_file(isShowNotification: boolean): void {

    const data = this.create_screenlist_array();

    if (!data) {
      //this.modalRef.close();
      return;
    }

    this.isSavingFile = true;
    this.screenService.saveXmlFile(data).subscribe((response) => {
      this.getUserFilesList();
      //this.authService.showNotification(response.message, 'success');
      if (isShowNotification) {
        if (response.status === 'error') {
          this.authService.showNotification(response.message, '', 'error');
        } else {
          this.authService.showNotification('Screen saved successfully', 'success', 'success');
        }
      }
      this.isSavingFile = false;
      this.isScreenSaved = true;
      //ng.modalRef.close();
      // setInterval(function () {
      //
      //   // window.location.reload();
      //   // ng.resetCompleteScreen();
      // }, 3000);
      //this.isSavingFile = false;
    }, error => {
      if (isShowNotification) {
        //this.authService.showNotification(error.message, 'error');
        this.authService.showNotification('', 'Some error occured. please try again later', 'error');
      }
      //this.modalRef.close();
      this.isSavingFile = false;
    });
  }

  register_player(): void {
    $("#lbl_registerplayer_errmsg").hide();

    const data = {

      RegistrationCode: this.registrationCode.toUpperCase(),
      PlayerName: this.playerName,
      Account: this.authService.currentUser.username
    }

    if (!data) {
      this.modalRef.close();
      return;
    }

    this.isRegisterPlayer = true;
    this.registrationService.registerPlayer(data).subscribe((response) => {
      if (response.status == 'success') {
        this.TogglePlayerRegistrationLink();
        this.authService.showNotification('Success', 'Player Registered successfully', 'success');
        this.isRegisterPlayer = false;
        ng.modalRef.close();
      }
      else if (response.status == 'error') {

        if (response.message.includes(' does not exist')) {
          this.openinvalidPlayerIdModal();
        }
        else {
          $("#lbl_registerplayer_errmsg").text(response.message);
          $("#lbl_registerplayer_errmsg").show();
        }
        //this.authService.showNotification('Failure', response.message, 'error');
        this.isRegisterPlayer = false;
      }

    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      this.modalRef.close();
      this.isRegisterPlayer = false;
    });
  }

  update_player(): void {
    $("#lbl_updateplayer_errmsg").hide();

    const data = {

      RegistrationCode: this.registrationCode.toUpperCase(),
      PlayerName: this.playerName,
      Account: this.authService.currentUser.username
    }

    if (!data) {
      this.modalRef.close();
      return;
    }

    this.registrationService.updatePlayer(data).subscribe((response) => {
      if (response.status == 'success') {
        this.authService.showNotification('Success', 'Player updated successfully', 'success');
        ng.modalRef.close();
      }
      else if (response.status == 'error') {
        $("#lbl_updateplayer_errmsg").text(response.message);
        $("#lbl_updateplayer_errmsg").show();
        //this.authService.showNotification('Failure', response.message, 'error');
      }

    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      this.modalRef.close();
    });
  }
  delete_player(): void {
    $("#lbl_updateplayer_errmsg").hide();

    const data = {

      RegistrationCode: this.registrationCode.toUpperCase(),
      PlayerName: this.playerName,
      Account: this.authService.currentUser.username
    }

    if (!data) {
      this.modalRef.close();
      return;
    }

    this.registrationService.deletePlayer(data).subscribe((response) => {
      if (response.status == 'success') {
        this.TogglePlayerRegistrationLink();
        this.authService.showNotification('Success', 'Player deleted successfully', 'success');
        ng.modalRef.close();
      }
      else if (response.status == 'error') {
        $("#lbl_updateplayer_errmsg").text(response.message);
        $("#lbl_updateplayer_errmsg").show();
        //this.authService.showNotification('Failure', response.message, 'error');
      }
    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      this.modalRef.close();
    });
  }

  update_screenName(): void {
    $("#lbl_updatescreen_errmsg").hide();

    const data = {

      screenName: this.screenName,
      newScreenName: this.newScreenName,
      userName: this.authService.currentUser.username
    }

    if (!data) {
      this.modalRef.close();
      return;
    }

    this.screenService.updateScreenName(data).subscribe((response) => {
      if (response.status == 'success') {
        this.getUserFilesList();
        this.authService.showNotification('Success', 'Screen name updated successfully', 'success');
        ng.modalRef.close();
      }
      else if (response.status == 'error') {
        $("#lbl_updatescreen_errmsg").text(response.message);
        $("#lbl_updatescreen_errmsg").show();
        //this.authService.showNotification('Failure', response.message, 'error');
      }

    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      this.modalRef.close();
    });
  }

  delete_screen(): void {
    $("#lbl_updatescreen_errmsg").hide();

    const data = {

      screenName: this.screenName,
      userName: this.authService.currentUser.username
    }

    if (!data) {
      this.modalRef.close();
      return;
    }

    this.screenService.deleteScreen(data).subscribe((response) => {
      if (response.status == 'success') {
        this.getUserFilesList();
        this.authService.showNotification('Success', 'Screen deleted successfully', 'success');
        ng.modalRef.close();
      }
      else if (response.status == 'error') {
        $("#lbl_updatescreen_errmsg").text(response.message);
        $("#lbl_updatescreen_errmsg").show();
        //this.authService.showNotification('Failure', response.message, 'error');
      }
    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      this.modalRef.close();
    });
  }

  currentTimeStamp(): string {
    const date = new Date(); // had to remove the colon (:) after the T in order to make it work
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const minutes = date.getMinutes();
    const hours = date.getHours();
    const seconds = date.getSeconds();
    const myFormattedDate = day + '-' + (monthIndex + 1) + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return myFormattedDate;
  }

  openSettingsModal(): void {
    // screenSettingsModal

    this.openModel(this.screenSettingsModal, { size: 'lg' });
    this.resetContentServerObj();
    this.resetUserObj();
  }

  resetCompleteScreen(): void {
    this.snapToEnabled = true;
    this.stage.destroyChildren();
    this.layer.destroyChildren();

    this.currentAssetsAnchors = [];
    this.currentAssets = [];
    this.stage = new Konva.Stage({
      container: 'canvasContainer',
      width: this.stageWidth,
      height: this.stageHeight
    });
    const gridLayer = this.createGridLayer();
    this.stage.add(gridLayer);

    this.layer = new Konva.Layer();
    this.shadowRectangle.hide();
    this.layer.add(this.shadowRectangle);
    // console.log(this.stage);
    this.stage.add(this.layer);
    //this.gActiveResolution = '1280x720';
    //this.changeCanvasResolution();

    this.color_picker_canvas.fromRGB(255, 255, 255);
    this.updateColor(this.color_picker_canvas, 'bkg_color');

    $('#image-slider-parent').hide();
    $('#video-slider-parent').hide();
    this.signName = '';
    this.isScreenSaved = false;
    this.show_attributes(null, null);
    this.isPlayListAcitve = false;
    this.myElement = [];
  }

  getUserFilesList(refreshAttributes = null): void {
    this.screenService.getCurrentUserFiles().subscribe((response) => {
      if (response.data !== '') {

        this.currentTemplates = { hdTemplate: [], fullHdTemplate: [], allTemplates: [], fullScreenWithImageTemplate: [], fullScreenWithVideoTemplate: [], menuTemplates: [] };
        this.currentImages = [];
        this.currentAudios = [];
        this.currentVideos = [];
        this.videoChannelAssets = [];
        this.videoAssets = [];
        this.templateMenu = [];
        // this.imageList = response.data.images;
        // this.currentImages = response.data.images;
        response.data.images.forEach(element => {
          // element.url = element.url.replace(/^http:\/\//i, 'https://');
          // element.url = element.url.replace(/^https:\/\//i, 'http://');
          // console.log(element.url);
          this.currentImages.push(element);
        });

        response.data.audios.forEach(element => {
          this.currentAudios.push(element);
        });
        // this.videoLlist = response.data.videos;
        response.data.videos.forEach(element => {
          element.isEztvItem = false;
          this.videoAssets.push(element);
        });
        this.currentVideos = this.videoAssets;
        this.ezTVLogin();
        this.currentXmls = response.data.xmls;
        this.currentScreens = response.data.screens;
        //alert(JSON.stringify(response.data.screens));

        response.data.templateMenus.forEach(element => {
          if (element.fileType.indexOf('TemplateMenu') > 0) {
            this.currentTemplates.menuTemplates.push(element);
          }

        })

        response.data.templates.forEach(element => {
          if (element.relativePath.indexOf('HD Template') > 0) {
            this.currentTemplates.hdTemplate.push(element);
          } else if (element.relativePath.indexOf('Full HD Template') > 0) {
            this.currentTemplates.fullHdTemplate.push(element);
          } else if (element.relativePath.indexOf('Full Screen with Image') > 0) {
            this.currentTemplates.fullScreenWithImageTemplate.push(element);
          } else if (element.relativePath.indexOf('Full Screen with Video') > 0) {
            this.currentTemplates.fullScreenWithVideoTemplate.push(element);
          }
          else {
            this.currentTemplates.allTemplates.push(element);
          }

        });

        this.currentTemplates.menuTemplates = response.data.templateMenus;
        // console.log(this.currentTemplates);
        this.readScreenlistFileDetails();
        this.gContentAllFiles = this.imageList.concat(this.videoLlist, this.currentXmls);
        this.data.changeMessage(this.currentXmls);
        this.data.changeScreen(this.currentScreens);
        this.data.changeTemplate(this.currentTemplates);

        if (refreshAttributes === 'video') {
          const active_group = this.stage.findOne('#' + this.activeAssetId + '-Group');  // get the Konva asset object
          // this.show_attributes(refreshAttributes, this.activeAssetId);
          // this.newAssetClicked(active_group, this.activeAssetId);
          //active_group.fire('click');
          // this.BindAudioSources(<HTMLSelectElement>document.getElementById(this.activeAssetId + '_audio_def_source'));
          // this.BindVideoSources(<HTMLSelectElement>document.getElementById(this.activeAssetId + '_def_source'));
        }
        else if (refreshAttributes) {
          //this.show_attributes(refreshAttributes, this.activeAssetId);
        }

        setTimeout(function () {
          $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
          });
        }, 1000);
      }
    }, (error) => {
      console.log(error);
    });
  }

  ngAfterContentInit(): void {
    this.getUserFilesList();
    this.getServerSettings();
  }

  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  preview_screenlist_file(): any {
    //
    if (!this.isScreenSaved) {
      this.authService.showNotification('', 'Please save file first to preview', 'info');
      return false;
    }
    this.openWindowCustomClass(this.signPreviewModal);
    // this.openModel(this.signPreviewModal);
    if (1 === 1) {
      return false;
    }
    let userName = '';
    if (!this.isScreenSaved) {
      this.authService.showNotification('', 'Please save the screen first <br/><br/> Note: Saving the screen will <br/> overwrite the existing screen', 'error');
      return false;
    }
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    let filesToUpload = {
      images: [],
      videos: [],
      xmls: [this.gActiveScreenlistFile],
      userName: userName,
      serverName: 'preview end point',
    };
    if (Object.keys(this.currentAssets).length > 0) {
      for (const key in this.currentAssets) {
        const value = this.currentAssets[key];
        if (value.Type === 'video' && this.publishVideos) {
          filesToUpload.videos.push(value.Source);
        } else if (value.Type === 'image') {
          filesToUpload.images.push(value.Source);
        }
      }
      this.spinnerService.show();
      this.screenService.previewScreenlistFile(filesToUpload).subscribe((response) => {
        this.spinnerService.hide();
        this.authService.showNotification(response.message, 'success');
      }, error => {
        this.spinnerService.hide();
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
      });
    } else {
      this.authService.showNotification('', 'You must add at least one asset to the screen', 'info');
    }
  }

  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  ep_preview_screenlist_file(): any {
    if (!this.isScreenSaved) {
      this.authService.showNotification('', 'Please save file first to preview');
      return false;
    }


    let userName = '';
    if (!this.isScreenSaved) {
      this.authService.showNotification('', 'Please save the screen first <br/><br/> Note: Saving the screen will <br/> overwrite the existing screen', 'error');
      return false;
    }
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    let filesToUpload = {
      images: [],
      videos: [],
      xmls: [this.gActiveScreenlistFile],
      userName: userName,
      serverName: 'preview end point',
    };
    if (Object.keys(this.currentAssets).length > 0) {
      for (const key in this.currentAssets) {
        const value = this.currentAssets[key];
        if (value.Type === 'video' && this.publishVideos) {
          filesToUpload.videos.push(value.Source);
        } else if (value.Type === 'image') {
          filesToUpload.images.push(value.Source);
        }
      }
      this.spinnerService.show();
      this.screenService.previewScreenlistFile(filesToUpload).subscribe((response) => {
        this.spinnerService.hide();
        this.authService.showNotification('', response.message, 'success');
      }, error => {
        this.spinnerService.hide();
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
      });
    } else {
      this.authService.showNotification('', 'You must add at least one asset to the screen', 'info');
    }
  }

  getRegisteredPlayersByUser(): any {
    const userName = this.username;
    this.registrationService.getTop10RegisteredPlayersByUser(userName).subscribe((response) => {
      this.registeredPlayers = response.data;
    });
  }
  getPlayerStatusObjectByUser(): any {
    const userName = this.username;
    this.registrationService.getPlayerStatusObjectByUser(userName).subscribe((response) => {
      this.playerStatusObject = response.data;

      this.playerStatusObject.activePlayers.forEach(element => {

        var dateUpdatedOnOld = localStorage.getItem('dateUpdatedOn');
        var registrationCode = localStorage.getItem('registrationCode');
        var oldTime = localStorage.getItem('oldMinutes');

        var diff = (new Date().getTime() - parseInt(oldTime)) / 1000;
        diff /= 60;
        // alert(diff);

        if (dateUpdatedOnOld != "" && registrationCode != "") {
          if (element.registrationCode == registrationCode) {
            if (dateUpdatedOnOld != element.dateUpdated) {
              element.groupName = 'dmbtv';
            }
            else {
              //As per client wait up to 2 min interval
              if (diff <= 2) {
                element.groupName = 'dmbtvHide';
              }
              else {
                element.groupName = 'dmbtv';
              }
            }

          }
        }

        if (element.status == 'Active' && element.isActionFileExist == true) {
          if (element.action == "restart_app") {
            element.status = 'Restarting Signage App...';
          }
          else if (element.action == "create_screenshot") {
            element.status = 'Creating Screenshot...';
          }
        }
      });
      this.playerStatusObject.inactivePlayers.forEach(element => {
        if (element.status == 'Unknown' && element.isActionFileExist == true) {
          if (element.action == "restart_app") {
            element.status = 'Restarting Signage App...';
          }
          else if (element.action == "create_screenshot") {
            element.status = 'Creating Screenshot...';
          }
        }
      });
      0      // console.log(this.playerStatusObject);
    });
  }

  show_publish_modal(publishScreen = true): any {
    this.publishOnlyVideos = !publishScreen;
    if (this.isScreenSaved === false && publishScreen === true) {
      this.authService.showNotification('', 'Please save the screen first <br/><br/> Note: Saving the screen will <br/> overwrite the existing screen', 'info');
      return false;
    }
    this.getRegisteredPlayersByUser();
    this.openModel(this.publishToPlayerModal, { size: 'xl' });
    setTimeout(function () {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });
    }, 1000);
    //OLD CODE COMMENTED ON 05/04/2021 SOUNAK
    //this.openModel(this.publishServerModal);
    //OLD CODE END
  }

  openViewSelectPlayersModal() {
    // this.getRegisteredPlayersByUser();

    // try{
    //   this.currentRule.players.forEach(element => {        
    //     this.registeredPlayers.find(p=>p.playerName === element.name).isSelected = true;
    //   });
    // }catch(error){}

    this.openModel(this.viewSelectPlayersModal, { size: 'xl' });
    setTimeout(function () {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });
    }, 1000);
  }

  openChangeResolutionModel(event) {
    this.selectedResolution = this.gActiveResolution;
    this.gActiveResolution = event.target.value;
    this.selectedModel = 'resolution';
    this.openModel(this.confirmResolutionChange);
    setTimeout(() => {
      $('#signResolution').val(this.selectedResolution);
    }, 100);
  }

  openPlayerRegistrationModal(): void {
    this.registrationCode = '';
    this.playerName = '';
    this.openModel(this.playerRegistrationModal);
  }

  openinvalidPlayerIdModal(): void {
    this.closeModal();
    this.openModel(this.invalidPlayerIdModal);
  }

  openEditPlayerModal(): void {
    this.registrationCode = '';
    this.playerName = '';

    const userName = this.username;
    this.registrationService.getTop10RegisteredPlayersByUser(userName).subscribe((response) => {
      this.registeredPlayers = response.data;

      this.openModel(this.editPlayerModal);

      var selected_player = <HTMLSelectElement>document.getElementById('ddlSelectedPlayer');

      $("#" + selected_player.id).empty();

      const heading = document.createElement('option');
      heading.value = '';
      heading.text = '-- Select Player --';
      selected_player.appendChild(heading);

      this.registeredPlayers.forEach(rp => {
        const option = document.createElement('option');
        option.value = rp.registrationCode;
        option.text = rp.playerName + ' (ID: ' + rp.registrationCode + ')';

        selected_player.appendChild(option);
      });
      $('.selectpicker').selectpicker();
    });
  }

  openEditScreenModal(): void {
    this.screenName = '';
    this.newScreenName = '';

    const userName = this.username;

    this.openModel(this.editScreenModal);

    var selected_screen = <HTMLSelectElement>document.getElementById('ddlSelectedScreen');

    $("#" + selected_screen.id).empty();

    const heading = document.createElement('option');
    heading.value = '';
    heading.text = '-- Select Screen --';
    selected_screen.appendChild(heading);

    this.currentScreens.forEach(cs => {
      const option = document.createElement('option');
      option.value = cs.name;
      option.text = cs.name;

      selected_screen.appendChild(option);
    });

    $('.selectpicker').selectpicker();
  }

  openPlayerStatusModal(): void {
    const userName = this.username;
    this.registrationService.getPlayerStatusObjectByUser(userName).subscribe((response) => {
      this.playerStatusObject = response.data;
      this.playerStatusObject.activePlayers.forEach(element => {

        if (element.status == 'Active' && element.isActionFileExist == true) {
          if (element.action == "restart_app") {
            element.status = 'Restarting Signage App...';
          }
          else if (element.action == "create_screenshot") {
            element.status = 'Creating Screenshot...';
          }
        }
      });
      this.playerStatusObject.inactivePlayers.forEach(element => {

        if (element.status == 'Unknown' && element.isActionFileExist == true) {
          if (element.action == "restart_app") {
            element.status = 'Restarting Signage App...';
          }
          else if (element.action == "create_screenshot") {
            element.status = 'Creating Screenshot...';
          }
        }
      });
      // console.log(this.playerStatusObject)
      this.openModel(this.playerStatusModal, { size: 'fullscreen_sm' }, 'player_status');

      // setTimeout(function () {
      //   $('[data-toggle="tooltip"]').tooltip({
      //     trigger : 'hover'
      //   });
      // }, 1000);

      ng.playerStatusIntervalID = setInterval(function () {
        //debugger;
        var currentDate = new Date();
        // console.log(currentDate);
        ng.getPlayerStatusObjectByUser();

        //    $('[data-toggle="tooltip"]').tooltip({
        //   trigger : 'hover'
        // }); // data-toggle not wroking so used ngTooltip

      }, 10000);  //set as 10 sec interval as per client

    });
  }

  openTimeOfdayModal(): void {
    const userName = this.username;
    var reqData = {
      userName: userName
    };
    this.spinnerService.show();
    this.screenService.readTimeOfDayFile(reqData).subscribe((response) => {
      if (response.status === 'error') {
        this.spinnerService.hide();
        this.authService.showNotification('', response.message, 'error');
      } else {
        this.currentTimeOfDay = response.data;
        this.currentRules = response.data.rules;
        this.tod_no_of_players = 0;
        this.openModel(this.timeOfDayModal, { size: 'xl' }, 'time_of_day');
        $("#divTodModalBody").addClass('disabled');
        $(".selectpicker").selectpicker();
        setTimeout(function () {
          $(".selectpicker").selectpicker('refresh');
          $("#divTodModalBody").removeClass('disabled');
          $("#divTimeOfDayLoad").addClass('d-none');
          $("#divTimeOfDayStart").removeClass('d-none');
        }, 2000);
        this.spinnerService.hide();
      }
    }, error => {
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });
  }

  ddlSelectedPlayer_change(): void {

    var selectedPlayerName = $("#ddlSelectedPlayer").val() === '' ? '' : $.trim($("#ddlSelectedPlayer option:selected").text().substr(0, $("#ddlSelectedPlayer option:selected").text().indexOf('(ID') - 1));
    this.playerName = selectedPlayerName;
  }

  ddlSelectedScreen_change(): void {

    var selectedScreenName = $("#ddlSelectedScreen").val();
    this.newScreenName = selectedScreenName;
  }

  publish_screenlist_file(): any {
    $("#lbl_publish_errmsg").hide();
    let userName = '';

    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    
    const filesToUpload = {
      images: [],
      videos: [],
      xmls: this.publishOnlyVideos ? [] : [this.gActiveScreenlistFile],
      userName: userName,
      screenName: this.signName,
      others: [],
      players: []
    };

    if (this.publishLineup) {
      filesToUpload.xmls = [];
      filesToUpload.others = ['Channel.Lineup.db'];
    } else {
      if (this.isScreenSaved === false && this.publishOnlyVideos === false) {
        this.authService.showNotification('', 'Please save the screen first <br/><br/> Note: Saving the screen will <br/> overwrite the existing screen', 'error');
        return false;
      }

      if (Object.keys(this.currentAssets).length > 0) {
        if (this.publishOnlyVideos === false) {
          // tslint:disable-next-line:forin
          for (const key in this.currentAssets) {
            const value = this.currentAssets[key];
            if (value.Type === 'video' && this.publishVideos) {
              if (value.playlist) {
                filesToUpload.others.push(value.file_name);
                // tslint:disable-next-line:forin
                for (const plKey in value.playlist_items) {
                  filesToUpload.videos.push(value.playlist_items[plKey].name);
                  // filesToUpload.images.push(value.playlist_items[plKey].name);
                }
              } else {
                filesToUpload.videos.push(value.Source);
              }
            } else if (value.Type === 'image') {
              if (value.playlist) {
                filesToUpload.others.push(value.file_name);
                // tslint:disable-next-line:forin
                for (const plKey in value.playlist_items) {
                  filesToUpload.images.push(value.playlist_items[plKey].name);
                  // filesToUpload.images.push(value.playlist_items[plKey].name);
                }
              } else {
                filesToUpload.images.push(value.Source);
              }
            }
          }
        } else {
          this.currentVideos.forEach(element => {
            if (element.isEztvItem) {
              filesToUpload.videos.push(element.url);
            } else {
              filesToUpload.videos.push(element.name);
            }
          });
        }

        filesToUpload.players = this.registeredPlayers;

      } else {
        this.authService.showNotification('', 'You must add at least one asset to the screen', 'error');
        return;
      }
    }

    this.spinnerService.show();
    this.screenService.publishScreenlistFile(filesToUpload).subscribe((response) => {
      if (response.status == 'success') {
        this.authService.showNotification('Publish Successful', 'success', 'success');
        this.closeModal();
      }
      else if (response.status == 'error') {
        $("#lbl_publish_errmsg").text(response.message);
        $("#lbl_publish_errmsg").show();
      }
      this.spinnerService.hide();
      this.publishLineup = false;
    }, error => {
      //alert(error.status);
      //console.log(error.status);
      this.spinnerService.hide();
      this.publishLineup = false;
      this.authService.showNotification('Error', 'Some error occured please try again later', 'error');
    });

    //OLD CODE COMMENTED ON 05/05/2021 SOUNAK

    // let userName = '';
    // let endpointLocationName = '';

    // if (typeof this.publichContentServerObj.endpointLocationName === 'undefined'
    //   || this.publichContentServerObj.endpointLocationName === '') {
    //   this.authService.showNotification('Please select publish profile.', 'error');
    //   return false;
    // } else {
    //   endpointLocationName = this.publichContentServerObj.endpointLocationName.toLowerCase();
    // }

    // if (typeof this.authService.currentUser.username !== 'undefined') {
    //   userName = this.authService.currentUser.username;
    // }

    // const filesToUpload = {
    //   images: [],
    //   videos: [],
    //   xmls: this.publishOnlyVideos ? [] : [this.gActiveScreenlistFile],
    //   userName: userName,
    //   serverName: 'content server',
    //   others: [],
    //   EndpointLocationName: endpointLocationName,
    //   endpointLocationName: endpointLocationName,
    // };

    // if (this.publishLineup) {
    //   filesToUpload.xmls = [];
    //   filesToUpload.others = ['Channel.Lineup.db'];
    // } else {
    //   if (this.isScreenSaved === false && this.publishOnlyVideos === false) {
    //     this.authService.showNotification('Please save the screen first', 'error');
    //     return false;
    //   }

    //   if (Object.keys(this.currentAssets).length > 0) {
    //     if (this.publishOnlyVideos === false) {
    //       // tslint:disable-next-line:forin
    //       for (const key in this.currentAssets) {
    //         const value = this.currentAssets[key];
    //         if (value.Type === 'video' && this.publishVideos) {
    //           if (value.playlist) {
    //             filesToUpload.others.push(value.file_name);
    //             // tslint:disable-next-line:forin
    //             for (const plKey in value.playlist_items) {
    //               filesToUpload.videos.push(value.playlist_items[plKey].name);
    //               // filesToUpload.images.push(value.playlist_items[plKey].name);
    //             }
    //           } else {
    //             filesToUpload.videos.push(value.Source);
    //           }
    //         } else if (value.Type === 'image') {
    //           if (value.playlist) {
    //             filesToUpload.others.push(value.file_name);
    //             // tslint:disable-next-line:forin
    //             for (const plKey in value.playlist_items) {
    //               filesToUpload.images.push(value.playlist_items[plKey].name);
    //               // filesToUpload.images.push(value.playlist_items[plKey].name);
    //             }
    //           } else {
    //             filesToUpload.images.push(value.Source);
    //           }
    //         }
    //       }
    //     } else {
    //       this.currentVideos.forEach(element => {
    //         if (element.isEztvItem) {
    //           filesToUpload.videos.push(element.url);
    //         } else {
    //           filesToUpload.videos.push(element.name);
    //         }
    //       });
    //     }
    //   } else {
    //     this.authService.showNotification('You must add at least one asset to the screen.', 'error');
    //     return;
    //   }
    // }

    // this.spinnerService.show();
    // this.screenService.previewScreenlistFile(filesToUpload).subscribe((response) => {
    //   if (response.status === 'error') {
    //     // this.authService.showNotification('', response.message, 'error');
    //     this.authService.showNotification('', 'Error: Publish failed', 'error');
    //   } else {
    //     // this.authService.showNotification(response.message, 'success');
    //     this.authService.showNotification('Publish Successful', 'success', 'success');
    //   }
    //   this.spinnerService.hide();
    //   this.closeModal();
    //   this.publishLineup = false;
    // }, error => {
    //   this.spinnerService.hide();
    //   this.publishLineup = false;
    //   this.authService.showNotification('Some error occured please try again later.', 'error');
    // });
    //OLD CODE END
  }

  select_tod_players() {
    this.closeModal();
    this.tod_no_of_players = this.registeredPlayers.filter(p => p.isSelected === true).length;
  }

  load_screenlist(xml_file): void {
    // console.log(xml_file);
    this.resetCompleteScreen();
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    let reqData = {};
    if (xml_file.templatePath !== false) {
      reqData = {
        userName: userName,
        fileName: xml_file.fileName,
        templatesRelativePath: xml_file.templatePath
      };
      this._templatePath = xml_file.templatePath;
    } else {
      reqData = {
        userName: userName,
        fileName: xml_file.fileName,
        subDirectory: xml_file.subDirectory,
        screenName: xml_file.screenName
      };
      this._templatePath = false;
    }

    this.spinnerService.show();
    this.screenService.readScreenlistFile(reqData).subscribe((response) => {
      
      if (response.status === 'error') {
        //this.isScreenSaved = false;
        this.spinnerService.hide();
        this.authService.showNotification('', response.message, 'error');
      } else {
        //this.gActiveScreenlistFile = xml_file;
        this.gActiveScreenlistFile = xml_file.fileName;
        const fileData = response.data;
        // console.log('response');
        const oScreenlist = fileData['screenlist'];
        const oScreen = fileData['screenlist']['screen'];
        const aAssets = fileData['screenlist']['screen']['asset'];
        this.gActiveResolution = response.data.screenlist.resolution;
        this.changeCanvasResolution();
        // if there is only one asset on the screen that the type will be an object
        const type = (aAssets.constructor === Object ? 'object' : 'array');
        // console.log(aAssets)
        for (let y = 0; y < (type === 'object' ? 1 : aAssets.length); y++) {
          // loop over each asset/object on the screen to add to the stage

          // get attributes defined in the xml file
          const oAsset = (type === 'object' ? aAssets : aAssets[y]);
          const asset_type = oAsset.type;
          const asset_name = oAsset.name;
          const asset_x = oAsset.x;
          const asset_y = oAsset.y;
          const asset_width = oAsset.width;
          const asset_height = oAsset.height;
          const asset_fit = oAsset.fit;
          const asset_source = oAsset.source;
          oAsset.opacity = oAsset.background_color ? oAsset.background_color.split('.')[0] : '255';
          oAsset.background_color = oAsset.background_color ? "255." + oAsset.background_color.split('.').splice(1, 3).join('.') : '255.255.255.255';

          // use the same funtion used to create a screenlist file from scratch ...
          let assetUrl = '';
          if (asset_type === 'image') {

            if (xml_file.templatePath !== false) {
              // console.log(xml_file.templatePath);
              assetUrl = this.mediaUrl + xml_file.templatePath + '/images/' + asset_source;
            } else if (asset_source != null && asset_source.includes('http')) {
              var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
              assetUrl = url;
            } else if (asset_source != null && asset_source != "") {
              var dotIndex = asset_source.lastIndexOf('.');
              var ext = asset_source.substring(dotIndex);
              if (ext == '.jpg' || ext == '.png' || ext == '.jpeg' || ext == '.gif' || ext == '.bmp' || ext == '.svg' || ext == '.ico') {
                if (asset_source.includes('assets/content/')) {
                  assetUrl = this.mediaUrl + this.authService.currentUser.username + '/images/' + asset_source;
                }
                else {
                  var imageExist = false;
                  this.currentImages.forEach(image => {
                    if (image.name === asset_source) {
                      const user = this.authService.currentUser;
                      var url = window.location + "/assets/content/" + user.userName + "/images/" + asset_source;
                      assetUrl = url;
                      imageExist = true;
                    }

                  });
                  if (!imageExist) {
                    //if image not exist then load default images
                    var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
                    assetUrl = url;
                  }
                }
              }
              else {
                //if type error then load default images
                var url = window.location + "/assets/img/layout/asset_icons/600x600-app-icon_IMAGE.png";
                assetUrl = url;
              }
            }
          } else if (asset_type === 'video') {
            // assetUrl = asset_source; // 'assets/img/video_skewed.png';
            assetUrl = this.mediaUrl + this.authService.currentUser.username + '/videos/' + asset_source;
          } else if (asset_type === 'text') {
            assetUrl = asset_source;
          } else if (asset_type === 'browser' || asset_type === 'text_crawl' || asset_type === 'text_multiline' || asset_type === 'rss' || asset_type === 'youtube') {
            assetUrl = asset_source;
          }
          // console.log(assetUrl);
          this.add_new_asset(asset_type,
            assetUrl,
            asset_width,
            asset_height,
            asset_x,
            asset_y,
            true,
            oAsset
          );
        }
        // Set the background color for the screen
        // console.log(oScreen);

        if (fileData.screenName === '') {
          this.signName = oScreen.name;
        } else {
          this.signName = fileData.screenName;
        }

        const screen_bkg_color = oScreen.background_color;
        const color = screen_bkg_color.split('.');
        this.color_picker_canvas.fromRGB(color[1], color[2], color[3]);  // set the default stage color that is defined in the screenlist
        const sel_color = this.color_picker_canvas.toHEXString();
        const stage = document.getElementById('canvasContainer');
        stage.style.backgroundColor = sel_color;
        this.layer.draw();

        // all proceess done hide the spinner
        this.spinnerService.hide();

        this.save_screenlist(false);
        this.isScreenSaved = true;

        if (xml_file.templatePath === false && xml_file.subDirectory === false) {
          // this.save_screenlist(false);
          // this.isScreenSaved = true;
        }

        // Set the Last element as active
        const lastEle = this.myElement[this.myElement.length - 1];
        ng.newAssetClicked(lastEle, lastEle.getAttr('_assetId'));
      }
    }, error => {
      this.isScreenSaved = false;
      this.spinnerService.hide();
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });
  }

  getServerSettings(): any {
    const userID = this.authService.currentUser.userID;
    this.screenService.getServerSettings(userID, '').subscribe((response) => {
      if (response.data) {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i]['serverName'] === 'preview end point') {
            this.previewEndPoint.Connection = response.data[i]['connection'];
            this.previewEndPoint.IPAddress = response.data[i]['iPAddress'];
            this.previewEndPoint.Port = response.data[i]['port'];
          } else if (response.data[i]['serverName'] === 'content server') {
            this.contentServer.Connection = response.data[i]['connection'];
            this.contentServer.IPAddress = response.data[i]['iPAddress'];
            this.contentServer.Port = response.data[i]['port'];
            this.contentServer.UserName = response.data[i]['userName'];
            this.contentServer.Password = response.data[i]['password'];
            this.contentServer.ContentDirectory = response.data[i]['contentDirectory'];
            this.contentServer.TransferDirectory = response.data[i]['transferDirectory'];
            this.contentServer.FileMasks = response.data[i]['fileMasks'];
          } else if (response.data[i]['serverName'] === 'ez tv server') {
            this.ezTvServer.IPAddress = response.data[i]['iPAddress'];
            // this.ezTvServer.Protocol = response.data[i]['protocol'];
            this.ezTvServer.UserName = response.data[i]['userName'];
            this.ezTvServer.Password = response.data[i]['password'];

            // this.ezTVLogin(this.ezTvServer.IPAddress, this.ezTvServer.UserName, this.ezTvServer.Password);
          }
        }
      }
    }, error => {
      console.log(error);
    });
  }

  savePreviewPoint(): any {
    this.previewEndPoint.UserID = this.authService.currentUser.userID;
    this.previewEndPoint.userName = this.authService.currentUser.userName;
    this.isSavingpreviewEndPoint = true;
    this.screenService.saveServerSettings(this.previewEndPoint).subscribe((response) => {
      this.spinnerService.hide();
      this.isSavingpreviewEndPoint = false;
      this.closeModal();
      this.authService.showNotification('', 'Saved Successfully', 'success');
    }, error => {
      this.spinnerService.hide();
      this.isSavingpreviewEndPoint = false;
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });
  }

  saveContentServer(myForm: NgForm): any {
    if (myForm.valid) {
      // console.log(this.contentServerUserObj);
      this.contentServer.UserID = this.contentServerUserObj.userID;
      // this.contentServer.userID = this.contentServerUserObj.userID;
      this.contentServer.userName = this.contentServerUserObj.userName;
      this.contentServer.EndpointLocationName = this.contentServer.Name.toLowerCase();
      // if(1==1){console.log(this.contentServer); return false;}
      this.isSavingContentServer = true;
      console.clear();
      // console.log(this.contentServer);
      const reqData = {
        UserID: this.contentServer.UserID,
        Connection: this.contentServer.Connection,
        IPAddress: this.contentServer.IPAddress,
        Port: this.contentServer.Port,
        UserName: this.contentServer.UserName,
        Password: this.contentServer.Password,
        ContentDirectory: this.contentServer.ContentDirectory,
        TransferDirectory: this.contentServer.TransferDirectory,
        ServerName: this.contentServer.ServerName,
        EndpointLocationName: this.contentServer.EndpointLocationName,
        Name: this.contentServer.Name.toLowerCase(),
        // iD: this.concreate_screenlist_arraytentServer.iD
      };
      // console.log(this.contentServer.iD);
      // console.log(reqData); // if(1==1){return false;}
      this.screenService.saveServerSettings(reqData).subscribe((response) => {
        this.spinnerService.hide();
        this.isSavingContentServer = false;
        this.closeModal();
        // this.authService.showNotification(response.message, 'success', 'success');
        this.authService.showNotification('', 'Saved Successfully', 'success');
        this.isAddNewUserServer = false;
        this.closeModal();
      }, error => {
        this.spinnerService.hide();
        this.isSavingContentServer = false;
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
      });
    } else {
      this.authService.showNotification('', 'All field are required', 'error');
    }
  }

  saveEzTvServer(): any {
    this.ezTvServer.UserID = this.authService.currentUser.userID;
    this.isSavingEzTvServer = true;
    this.screenService.saveServerSettings(this.ezTvServer).subscribe((response) => {
      this.spinnerService.hide();
      this.isSavingEzTvServer = false;
      this.closeModal();
      // this.authService.showNotification(response.message, 'success', 'success');
      this.authService.showNotification('', 'Saved Successfully', 'success');
    }, error => {
      this.spinnerService.hide();
      this.isSavingEzTvServer = false;
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });
  }

  changeCanvasResolution(): void {
    this.selectedResolution = this.gActiveResolution;
    this.selectedModel = null;
    this.closeModal();
    $('#signResolution').val(this.gActiveResolution);
    if (this.gActiveResolution === '1920x1080') {
      this.stageHeight = 1080;
      this.stageWidth = 1920;
      this.stage.setHeight(1080);
      this.stage.setWidth(1920);
      document.getElementById('full-hd').classList.add('full-hd');
      document.getElementById('full-hd').classList.remove('hd');
      this.isPortraitView = false;
    } else if (this.gActiveResolution === '1080x1920') {
      this.stageHeight = 1920;
      this.stageWidth = 1080;
      this.stage.setHeight(1920);
      this.stage.setWidth(1080);
      document.getElementById('full-hd').classList.add('full-hd');
      document.getElementById('full-hd').classList.remove('hd');
      this.isPortraitView = true;
    } else if (this.gActiveResolution === '1280x720') {
      this.stageHeight = 720;
      this.stageWidth = 1280;
      this.stage.setHeight(720);
      this.stage.setWidth(1280);
      document.getElementById('full-hd').classList.add('hd');
      document.getElementById('full-hd').classList.remove('full-hd');
      this.isPortraitView = false;
    } else if (this.gActiveResolution === '745x300') {
      this.stageHeight = 300;
      this.stageWidth = 745;
      this.stage.setHeight(300);
      this.stage.setWidth(745);
      document.getElementById('full-hd').classList.add('hd');
      document.getElementById('full-hd').classList.remove('full-hd');
      this.isPortraitView = false;
    }

    this.gridLayer.destroy();
    const gridLayer = this.createGridLayer();
    this.stage.add(gridLayer);

    if (this.snapToEnabled) {
      this.gridLayer.show();
      this.gridLayer.moveToBottom();
    } else {
      this.gridLayer.hide();
    }

    this.changeZoomLevel();
  }

  getTheIframeUrl(): any {
    // {{ previewUrl }}?path={{ filePath }}&file=xmls/{{ gActiveScreenlistFile }}
    // const url = this.previewUrl + '?path=' + this.filePath + '&file=xmls/' + this.gActiveScreenlistFile;
    const url = this.previewUrl + '?path=' + this.filePath + '/&file=' + this.gActiveScreenlistFile;
    // const url = 'http://digiprima.com/';
    return url;
    // return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'mod-preview', size: 'lg' });
    // console.log(this.gActiveResolution);
    if (this.gActiveResolution == '1280x720') {
      $('.mod-inner-preview').parent('.modal-content').css({
        width: this.stageWidth + 40,
        position: 'absolute',
        'left': '72%',
        'top': '25.5em',
        'transform': 'translate(-50%,-50%)'
      });
    } else {
      $('.mod-inner-preview').parent('.modal-content').css({
        width: this.stageWidth + 40,
        position: 'absolute',
        'left': '65%',
        'top': '35.5em',
        'transform': 'translate(-50%,-50%)'
      });
    }
  }

  removePlaylistItem(filename, id) {
    // $('*[data-customerID="22"]');
    // console.log(this.playListItems);
    // $('#' + id ).remove();
    var index = this.currentAssets[this.activeAssetId].playlist_items.map(function (o) { return o.name; }).indexOf(filename);
    $('[data-index="' + id + '"]').remove();
    this.playListItems.splice(index, 1);
    this.currentAssets[this.activeAssetId].playlist_items.splice(index, 1);

    if (this.currentAssets[this.activeAssetId].playlist_items.count() === 0) {
      $("#" + this.activeAssetId + '_playlist').click();
      $("#" + this.activeAssetId + '_item_duration').val('10');
    }

    // console.log(this.playListItems);
  }

  togglePlaylistAttributes(item, assetType) {
    this.isPlayListAcitve = item.checked;
    if (item.checked) {
      // const file_name = this.currentAssets[this.activeAssetId].Name + '.pl';
      const file_name = this.activeAssetId + '.pl';
      $('.attr_hidden').show();
      this.playListItems = [];
      this.currentAssets[this.activeAssetId].playlist = true;
      this.currentAssets[this.activeAssetId].item_duration = '10';
      this.currentAssets[this.activeAssetId].transtion = '';
      this.currentAssets[this.activeAssetId].image_wall = false;
      this.currentAssets[this.activeAssetId].playlist_items = [];
      this.currentAssets[this.activeAssetId].file_name = file_name;
      // (<HTMLInputElement>document.getElementById(this.activeAssetId + '_file_name')).value = file_name;
    } else {
      $('.attr_hidden').hide();
      this.playListItems = [];
      $('#sortable').html('');
      this.currentAssets[this.activeAssetId].playlist = false;
      delete this.currentAssets[this.activeAssetId].item_duration;
      delete this.currentAssets[this.activeAssetId].transtion;
      delete this.currentAssets[this.activeAssetId].image_wall;
      delete this.currentAssets[this.activeAssetId].playlist_items;
      delete this.currentAssets[this.activeAssetId].file_name;
    }
  }

  playListUpdate() {
    if (this.currentAssets[this.activeAssetId].Type === 'image') {
      const idsInOrder = $("#sortable").sortable('toArray');
      // console.log(idsInOrder[0]);
      const id = idsInOrder[0];
      const asset_src = $('#' + id).data('asset_src');
      const type = $('#' + id).data('type');
      const assetUrl = $('#' + id).data('asseturl');

      this.updateImageAttributes(asset_src, type, assetUrl);
      // console.log(this.playListItems[idsInOrder[0]]);

      const temp = [];
      idsInOrder.forEach(item => {
        temp.push(this.playListItems[item]);
      });
      // this.playListItems = temp;
      this.currentAssets[this.activeAssetId].playlist_items = temp;
    }
  }

  addItemToPlayList(asset_src, type, assetUrl?: any, assetName?: String) {
    if (type === 'image') {
      const id = this.ramdomid();
      const fileName = assetName ? assetName : asset_src.replace(/^.*[\\\/]/, '');
      const itemIndex = '' + this.playListItems.length; // - 1;
      this.playListItems[itemIndex] = { name: fileName, asset_src: asset_src, type: type, assetUrl: assetUrl };
      this.createPlayListItem(itemIndex, asset_src, type, assetUrl);
      this.playListUpdate();
    }
  }

  createPlayListItem(itemIndex, asset_src, type, assetUrl) {
    if (type === 'image') {
      // console.log(asset_src, assetUrl)
      asset_src = (asset_src === null) ? '' : asset_src;
      const id = this.ramdomid();
      const fileName = asset_src.replace(/^.*[\\\/]/, '');
      const liItem = document.createElement('div');
      // assetUrl = assetUrl.replace(/^https:\/\//i, 'http://');
      liItem.setAttribute('class', 'play-list-item row');
      liItem.setAttribute('style', 'height:50px');
      liItem.setAttribute('data-index', id);
      liItem.setAttribute('data-asset_src', asset_src);
      liItem.setAttribute('data-type', type);
      liItem.setAttribute('data-asseturl', assetUrl);
      liItem.setAttribute('id', itemIndex);

      const liChild1 = document.createElement('div');
      liChild1.setAttribute('class', 'col-lg-9 text-left playlist_item_text');
      liChild1.setAttribute('style', 'padding-left:0');

      const liChild1span = document.createElement('span');
      liChild1span.setAttribute('class', 'playlist_item_text');

      var itemText = fileName.length > 27 ? fileName.substr(0, 24) + '...' : fileName;

      liChild1span.innerText = itemText;
      liChild1.appendChild(liChild1span);
      liItem.appendChild(liChild1);

      const liChild2 = document.createElement('div');
      liChild2.setAttribute('class', 'col-lg-1 text-right');

      const liChild3 = document.createElement('a');
      liChild3.setAttribute('class', 'text-danger play-item-rm-btn');
      liChild3.innerHTML = '';

      liChild3.addEventListener('click', function () {
        // console.log(itemIndex, id)
        ng.removePlaylistItem(fileName, id);
      });

      liChild2.appendChild(liChild3);
      liItem.appendChild(liChild2);
      document.getElementById('sortable').appendChild(liItem);
    }
  }

  ezTVLogin() {
    // let data = {'username': UserName, 'password': Password};
    const userName = this.authService.currentUser.userName;
    // console.log(userName);
    this.screenService.getVideoChannelList(userName).subscribe((response) => {
      // console.log(response);
      this.videoChannelAssets = [];
      response.data.channels.forEach(element => {
        element.isEztvItem = true;
        this.videoChannelAssets.push(element);
      });
      this.currentVideos = this.currentVideos.concat(this.videoChannelAssets);
      this.rssValueOptions = [
        { "title": "- Select -", "value": "" }
      ];
      // response.data.rss.forEach(element => {
      //   this.rssValueOptions.push({ 'title': element.name, 'value': element.url });
      // });

    }, error => {
      console.log(error);
    });
  }

  uploadImageAsset() {
    // console.log('Upload Image');
    this.openModel(this.uploadImageModal, { size: 'lg' });
  }

  uploadVideoAsset() {
    // console.log('Upload Video');
    this.openModel(this.uploadVideoModal, { size: 'lg' });
  }

  onImageUploadError(e) {
    // console.log(e);
    // this.authService.showNotification('', 'The maximum image file upload <br/> resolution is 1920x1080', 'error');
    // this.authService.showNotification('', 'Some images did not get uploaded. Error occurred', 'error');
    // this.closeModal();
  }

  onVideoUploadError(e) {
    // console.log(e);
    // this.authService.showNotification('', 'The maximum video file upload <br/> size is 24MB', 'error');
    this.authService.showNotification('', 'Some files did not get uploaded. Error occurred', 'error');
    this.closeModal();
  }

  onUploadSuccess(e) {
    //console.log(e);
    this.getUserFilesList('image');
    //this.authService.showNotification('', 'Images uploaded successfully', 'success');
    $('.selectpicker').selectpicker('refresh');
    window.setTimeout(function () {
      const active_group = ng.stage.findOne('#' + ng.activeAssetId + '-Group');  // get the Konva asset object
      active_group.fire('click');
      ng.closeModal();
    }, 2000);
  }

  onVideoUploadSuccess(e) {
    const totalCurrentVideos = this.currentVideos.length;
    //this.authService.showNotification('', 'Files uploaded successfully', 'success');
    this.getUserFilesList('video');
    $('.selectpicker').selectpicker('refresh');
    // this.timer = setInterval(() => {
    //   this.getUserFilesList('video');
    //   this.BindVideoSources(<HTMLSelectElement>document.getElementById(this.activeAssetId + '_def_source'));
    //   if (totalCurrentVideos !== this.currentVideos.length) {
    //     clearInterval(this.timer);
    //   }
    // }, 2000);
    window.setTimeout(function () {
      const active_group = ng.stage.findOne('#' + ng.activeAssetId + '-Group');  // get the Konva asset object
      active_group.fire('click');
      ng.closeModal();
    }, 2000);
  }

  /// create grid layer
  createGridLayer() {
    this.gridLayer = new Konva.Layer();
    const padding = this.blockSnapSize;
    let gridHeight = this.stageHeight;
    let gridWidth = this.stageWidth;
    // console.log(this.gActiveResolution);

    for (let i = 0; i < gridWidth / padding; i++) {
      this.gridLayer.add(new Konva.Line({
        points: [Math.round(i * padding) + 0.5, 0, Math.round(i * padding) + 0.5, gridHeight],
        stroke: '#ddd',
        strokeWidth: 1,
      }));
    }

    this.gridLayer.add(new Konva.Line({ points: [0, 0, 10, 10] }));
    for (let j = 0; j < gridHeight / padding; j++) {
      this.gridLayer.add(new Konva.Line({
        points: [0, Math.round(j * padding), gridWidth, Math.round(j * padding)],
        stroke: '#ddd',
        strokeWidth: 0.5,
      }));
    }
    return this.gridLayer;
  }

  changeSnapTo() {
    this.snapToEnabled = !this.snapToEnabled;
    if (this.snapToEnabled) {
      this.gridLayer.show();
      this.gridLayer.moveToBottom();
      //console.log(this.gridLayer);
      // console.log('show');
    } else {
      this.gridLayer.hide();
      // console.log('hide');
    }
  }

  sendingFile(data, filetype, username) {
    const formData = data[2];
    // alert(data[0].width);
    // console.log(filetype, username, formData);
    formData.append('file', data[0]);
    formData.append('filetype', filetype);
    formData.append('username', username);
    formData.append('fileWidth', data[0].width);
    formData.append('fileHeight', data[0].height);
  }

  saveUser() {
    this.isSavingUser = true;
    // console.log(this.userObj)
    if (this.userObj.UserName == null || this.userObj.UserName === '') {
      this.authService.showNotification('', 'Please enter username', 'error');
      this.isSavingUser = false;
      return false;
    }
    if (this.userObj.Password == null || this.userObj.Password == '') {
      this.authService.showNotification('', 'Please enter password', 'error');
      this.isSavingUser = false;
      return false;
    }
    if (this.userObj.UserRole == null || this.userObj.UserRole == '') {
      this.authService.showNotification('', 'Please select user role', 'error');
      this.isSavingUser = false;
      return false;
    }
    let tempUser = this.userObj;
    tempUser.FirstName = this.userObj.UserName;
    tempUser.LastName = this.userObj.UserName;
    tempUser.EmailID = this.userObj.UserName + '@signbuider.com';
    tempUser.HomeDirectory = this.userObj.HomeDirectory;

    this.userService.saveUser(tempUser).subscribe((response) => {
      // console.log(response);
      if (response.status == 'error') {
        this.authService.showNotification('', response.message, 'error');
      } else {
        this.authService.showNotification('', response.message, 'success');
        this.resetUserObj();
        this.getUserList();
        this.closeModal();
      }
      this.isSavingUser = false;
    }, error => {
      console.log(error);
      this.isSavingUser = false;
    });
    // console.log('saveUser');
  }

  getUserRoleList() {
    this.userService.getUserRoleList().subscribe((response) => {
      if (response.status == 'success') {
        for (let i = 0; i < response.data.length; i++) {
          this.userRoles.push(response.data[i]);
        }
        // console.log('listed type user',this.userRoles);
      }
    }, error => {
      console.log(error);
    });
  }

  getUserList() {
    this.userService.getUserList().subscribe((response) => {
      if (response.status == 'success') {
        this.userList = response.data;
      }
    }, error => {
      console.log(error);
    });
  }
  //deleteAssetFromListUser
  onChangeUser(obj) {
    // console.log(obj);
    this.userObj.UserName = obj.userName;
    this.userObj.FirstName = obj.firstName;
    this.userObj.LastName = obj.lastName;
    this.userObj.UserId = obj.userID;
    this.userObj.EmailID = obj.emailID;
    this.userObj.UserRole = obj.userRole;
    this.userObj.HomeDirectory = obj.homeDirectory;
  }

  resetUserObj() {
    this.userObj = { UserName: null, Password: null, UserRole: '', FirstName: null, LastName: null, EmailID: '', UserId: null, HomeDirectory: null };
    this.isAddNewUser = false;
    // this.userList = [];
    this.editUserObj = {};
  }

  addNewUser() {
    // console.log('add new user');
    this.resetUserObj();
    this.isAddNewUser = true;
  }

  editExistingUser() {
    // console.log('edit existing user');
    this.resetUserObj();
    this.isAddNewUser = false;
  }

  cancleAddEditUser() {
    this.resetUserObj();
    this.closeModal();
  }
  cancleAddEditContentServer() {
    this.resetContentServerObj();
    this.closeModal();
  }

  onChangeServerUser(obj) {
    // console.log(obj)
    this.contentServerUserObj = obj;
    this.getUserServerList(obj.userID);
  }

  deleteUser(user) {
    // console.log(this.authService.currentUser.userID);
    // console.log(user.UserId);
    this.isDeletingUser = true;
    this.userService.deleteUser(this.authService.currentUser.userID, user.UserId).subscribe((response) => {
      // console.log(response);
      if (response.status == 'error') {
        this.authService.showNotification('', response.message, 'error');
      } else {
        this.authService.showNotification('', response.message, 'success');
        this.resetUserObj();
        this.getUserList();
        this.closeModal();
      }
      this.isDeletingUser = false;
    }, error => {
      console.log(error);
      this.isDeletingUser = false;
    });
  }

  getUserServerList(userId) {
    this.screenService.getUserServerList(userId).subscribe((response) => {
      // console.log(response);
      if (response.status == 'success') {
        const serverList = (typeof response.data == 'string') ? [] : response.data;
        this.userServersList = serverList;
      }
    }, error => {
      console.log(error);
    });

  }

  addNewContentServer() {
    // console.log('add new server');
    this.contentServerUserObj = { userID: '', userName: '' };
    this.resetContentServerObj();
    this.isAddNewUserServer = true;
  }

  editNewContentServer() {
    // console.log('edit new server');
    this.contentServerUserObj = { userID: '', userName: '' };
    this.resetContentServerObj();
    this.isAddNewUserServer = false;
  }

  resetContentServerObj() {
    this.contentServer = {
      Name: '',
      UserID: null,
      userID: null,
      userName: null,
      Connection: 'FTP',
      IPAddress: '127.0.0.1',
      Port: 21,
      UserName: '',
      Password: '',
      ContentDirectory: '',
      TransferDirectory: '',
      FileMasks: '',
      ServerName: 'content server',
      EndpointLocationName: null,
      iD: null
    };
    this.isAddNewUserServer = false;
    this.contentServerUserObj = { userID: null, userName: null };
    this.contentServerObj = {};
  }

  onChangeUserServer(obj) {
    // console.log(obj)
    this.contentServer = obj;

    this.contentServer = {
      Name: obj.endpointLocationName,
      UserID: obj.userID,
      userID: obj.userID,
      userName: obj.userName,
      Connection: obj.connection,
      IPAddress: obj.iPAddress,
      Port: obj.port,
      UserName: obj.userName,
      Password: obj.password,
      ContentDirectory: obj.contentDirectory,
      TransferDirectory: obj.transferDirectory,
      FileMasks: obj.fileMasks,
      ServerName: 'content server',
      EndpointLocationName: obj.endpointLocationName,
      iD: obj.iD
    };
  }
  deleteContentServer() {
    // console.log(this.contentServer)
    const data = { "ID": this.contentServer.iD, "UserID": this.contentServer.userID };
    this.screenService.deleteContentServer(data).subscribe((response) => {
      // console.log(response);
      if (response.status === 'success') {
        this.authService.showNotification('', 'Deleted Successfully', 'success');
        // console.log(this.contentServerUserObj)
        this.getUserServerList(this.contentServerUserObj.userID);
      } else {
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
      }
    }, error => {
      console.log(error);
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });
  }

  getCurrentUserServers() {
    //console.log('Get User videos');
    //console.log(this.authService.currentUser.userID);
    this.screenService.getUserServerList(this.authService.currentUser.userID).subscribe((response) => {
      this.currentUserServers = response.data;
    }, (error) => {
      console.log(error);
    });
  }

  readScreenlistFileDetails() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    const reqData = {
      userName: userName,
      fileName: null,
      templatesRelativePath: null
    };
    for (let i = 0; i < this.currentXmls.length; i++) {
      reqData.fileName = this.currentXmls[i].name;
      this.screenService.readScreenlistFile(reqData).subscribe((response) => {
        this.currentXmls[i].screenName = response.data.screenlist.name;
        this.currentXmls[i].channelNumber = this.getChannelNumber(this.currentXmls[i].name);
        // console.log(i, response.data.screenlist.name);
        this.data.changeMessage(this.currentXmls);
      }, (error) => {
        console.log(error);
      });
    }
    // for (let i = 0; i < this.currentTemplates.hdTemplate.length; i++) {
    //   reqData.fileName = this.currentTemplates.hdTemplate[i].name;
    //   reqData.templatesRelativePath = "templates\\HD Template";
    //   // console.log(reqData);
    //   this.screenService.readScreenlistFile(reqData).subscribe((response) => {
    //     this.currentTemplates.hdTemplate[i].screenName = response.data.screenlist.screen.name;
    //     // console.log(i, response.data.screenlist.name);
    //     this.data.changeTemplate(this.currentTemplates);
    //   }, (error) => {
    //     console.log(error);
    //   });
    // }
    // for (let i = 0; i < this.currentTemplates.fullHdTemplate.length; i++) {
    //   reqData.fileName = this.currentTemplates.fullHdTemplate[i].name;
    //   reqData.templatesRelativePath = 'templates\\Full HD Template';
    //   // console.log(reqData);
    //   this.screenService.readScreenlistFile(reqData).subscribe((response) => {
    //     this.currentTemplates.fullHdTemplate[i].screenName = response.data.screenlist.screen.name;
    //     // console.log(i, response.data.screenlist.name);
    //     this.data.changeTemplate(this.currentTemplates);
    //   }, (error) => {
    //     console.log(error);
    //   });
    // }


    for (let i = 0; i < this.currentTemplates.allTemplates.length; i++) {
      reqData.fileName = this.currentTemplates.allTemplates[i].name;
      reqData.templatesRelativePath = 'templates\\All Templates';
      // console.log(reqData);
      this.screenService.readScreenlistFile(reqData).subscribe((response) => {

        this.currentTemplates.allTemplates[i].screenName = response.data.screenlist.screen.name;
        this.data.changeTemplate(this.currentTemplates);
      }, (error) => {
        console.log(error);
      });
    }
  }

  onKeyupEvent($event): void {
    // console.log($event);
    this.contentServer.Name = this.contentServer.Name.toLowerCase();
  }

  removeSubString(string, stringToRemove, stringToRemoveWith) {
    return string.replace(stringToRemove, stringToRemoveWith);
  }

  showAssetsTitle(string) {
    let res = string;
    if (string === 'rss') {
      res = 'RSS';
    } else if (string === 'text_crawl') {
      res = 'Text Scroll';
    } else if (string === 'text_multiline') {
      res = 'Text Multiline';
    } else if (string === 'channel_number') {
      res = 'Channel Number';
    } else if (string === 'youtube') {
      res = 'YouTube';
    } else if (string === 'video') {
      res = 'Audio / Video';
    } else {
      res = string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
    }
    return res;
  }

  getChannelNumber(fileName: String) {
    const fileContents = fileName.split('.');
    const channelNumber = parseInt(fileContents[fileContents.length - 2], 10);
    if (channelNumber === 0) {
      return 'Default';
    }
    return 'Ch. ' + channelNumber;
  }

  videoOptionAction(element, anchoritem) {
    if (element.val === '2') {
      this.openModel(this.uploadVideoModal, { size: 'lg' });
    } else if (element.val === '3') {
      this.channelUpdatePath = this.sanitizer.bypassSecurityTrustResourceUrl(this.appSettings.getConfig('APP_NAME') + 'assets/content/' + this.currentUser.homeDirectory + '/manageclients/UpdateChannels/uc.html');
      this.openModel(this.updateChannelModal, { size: 'lg' }, 'channel-modal');
    } else if (element.val === '4') {
      this.channelUpdatePath = this.sanitizer.bypassSecurityTrustResourceUrl(this.appSettings.getConfig('APP_NAME') + 'assets/content/' + this.currentUser.homeDirectory + '/manageclients/UpdateVoDLineup/uc.html');
      this.openModel(this.updateChannelLineupModal, { windowClass: 'customModalClass' }, 'channel-modal');
    } else if (element.val == '5') {
      // ng.openScreenshotPopUp();
      if (element.text === 'Show Details') {
        $('.attr_showasdetails').show();
        element.text = 'Hide Details';
        anchoritem.text = 'Hide Details';
      }
      else if (element.text === 'Hide Details') {
        $('.attr_showasdetails').hide();
        element.text = 'Show Details';
        anchoritem.text = 'Show Details';
      }
    } else if (element.val == '6') {
      this.audiofilename = '';
      this.openModel(this.deleteAudioModal);
      this.BindAudioSources(<HTMLSelectElement>document.getElementById('ddlSelectedAudio'));
      $('.selectpicker').selectpicker();
    } else if (element.val == '7') {
      this.videofilename = '';
      this.openModel(this.deleteVideoModal);
      this.BindVideoOnlySources(<HTMLSelectElement>document.getElementById('ddlSelectedVideo'));
      $('.selectpicker').selectpicker();
    }
  }

  updateVideoChannelList() {
    this.screenService.getVideoChannelList(this.currentUser.username).subscribe((response) => {
      // console.log(response);
      this.videoChannelAssets = [];
      this.currentVideos = [];
      response.data.channels.forEach(element => {
        element.isEztvItem = true;
        this.videoChannelAssets.push(element);
      });
      this.currentVideos = this.videoAssets;
      this.currentVideos = this.currentVideos.concat(this.videoChannelAssets);

      setTimeout(function () {
        $('[data-toggle="tooltip"]').tooltip({
          trigger: 'hover'
        });
      }, 1000);
    });

  }

  loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = false;
    body.appendChild(script);
  }
  loadBrowserSource(assetId, url) {
    const asset_group = this.stage.findOne('#' + this.activeAssetId + '-Group');
    // const pos_x = document.getElementById('canvasContainer').offsetLeft + this.currentAssets[this.activeAssetId].X;
    // const pos_y = document.getElementById('canvasContainer').offsetTop + this.currentAssets[this.activeAssetId].Y;
    const pos_x = document.getElementById('canvasContainer').offsetLeft + asset_group.getX();
    const pos_y = document.getElementById('canvasContainer').offsetTop + asset_group.getY() - 1;
    const pos_width = this.currentAssets[this.activeAssetId].Width;
    const pos_height = this.currentAssets[this.activeAssetId].Height;
    const brdiv = document.createElement('div');
    brdiv.setAttribute('id', assetId + '_div_browser_source');
    brdiv.style.position = 'absolute';
    brdiv.style.left = pos_x.toString() + 'px';
    brdiv.style.top = pos_y.toString() + 'px';
    brdiv.style.zIndex = '1';
    const brframe = document.createElement('iframe');
    brframe.setAttribute('id', assetId + '_frame_browser_source');
    brframe.setAttribute('frameBorder', '0');
    brframe.setAttribute('scrolling', 'no');
    brframe.style.width = pos_width + 'px';
    brframe.style.height = pos_height + 'px';
    brframe.style.border = 'none';
    brframe.setAttribute('src', url);

    brdiv.appendChild(brframe);

    document.getElementById('canvasContainer').appendChild(brdiv);

    const timerlabel = document.createElement('label');
    timerlabel.setAttribute('id', assetId + '_lbl_browser_timer')
    timerlabel.style.fontSize = '200px';
    timerlabel.style.fontWeight = 'bold';
    timerlabel.style.color = 'green';
    timerlabel.style.position = 'absolute';
    timerlabel.style.zIndex = '100';
    timerlabel.style.top = brdiv.offsetTop + brdiv.offsetHeight / 2 - 120 + 'px';
    timerlabel.style.left = brdiv.offsetLeft + brdiv.offsetWidth / 2 - 70 + 'px';
    document.getElementById('canvasContainer').appendChild(timerlabel);

    var timeleft = 5;
    var downloadTimer = setInterval(function () {
      if (timeleft < 0) {
        clearInterval(downloadTimer);
        document.getElementById('canvasContainer').removeChild(timerlabel);
        document.getElementById('canvasContainer').removeChild(brdiv);
      }
      timerlabel.innerHTML = timeleft.toString();
      timeleft -= 1;
    }, 1000);
  }

  hideBrowserFrame(asset_id) {
    try {
      document.getElementById('canvasContainer').removeChild(document.getElementById(asset_id + '_div_browser_source'));
      document.getElementById('canvasContainer').removeChild(document.getElementById(asset_id + '_lbl_browser_timer'));
    } catch (e) { }
  }

  repositionBrowserFrame(asset_group, asset_id): void {
    const active_x = asset_group.getX();
    const active_y = asset_group.getY();
    const active_width = this.stage.findOne('#' + asset_id).getWidth();
    const active_height = this.stage.findOne('#' + asset_id).getHeight();

    const pos_x = document.getElementById('canvasContainer').offsetLeft + active_x;
    const pos_y = document.getElementById('canvasContainer').offsetTop + active_y;
    const pos_width = active_width;
    const pos_height = active_height;

    document.getElementById(asset_id + '_div_browser_source').style.left = pos_x + 'px';
    document.getElementById(asset_id + '_div_browser_source').style.top = pos_y + 'px';
    document.getElementById(asset_id + '_frame_browser_source').style.width = pos_width - 20 + 'px';
    document.getElementById(asset_id + '_frame_browser_source').style.height = pos_height - 20 + 'px';
  }

  ddlSelectedImage_change(file_name): void {
    if (file_name === '') {
      $("#imagetodelete").hide();
      return;
    }
    this.currentImages.forEach(image => {
      if (image.name === file_name) {
        $("#imagetodelete").attr("src", image.url);
        $("#imagetodelete").show();
        return;
      }
    });
  }

  delete_file(file_type, file_name): void {

    $(".deletefileasset").hide();

    let url = this.appSettings.getConfig('API_ENDPOINT') + 'deletefile';

    let userName = '';

    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }

    let filesToDelete = {
      fileType: file_type,
      fileName: file_name === '0' ? '' : file_name,
      userName: userName,
    };

    this.screenService.deleteFilesFromServer(filesToDelete).subscribe((response) => {
      this.spinnerService.hide();
      $("#imagetodelete").hide();
      $(".deletefileasset").text(response.message);
      $(".deletefileasset").show();

      this.getUserFilesList(file_type);

      if (file_type === 'image') {
        this.BindImageSources(<HTMLSelectElement>document.getElementById('ddlSelectedImage'));
        $("#ddlSelectedImage option[value='" + file_name + "']").remove();
        $("#" + this.activeAssetId + "_def_source option[value='" + file_name + "']").remove();
        for (const key in this.currentAssets) {
          if (this.currentAssets[key].Type === 'image' && file_name !== '' && this.currentAssets[key].Source.includes(file_name)) {
            $('a.tm35.play-item-rm-btn[id="' + key + '-Group"]')[0].click();
          } else if (this.currentAssets[key].Type === 'image' && file_name !== '' && typeof this.currentAssets[key].playlist !== 'undefined' && this.currentAssets[key].playlist) {
            this.currentAssets[key].playlist_items.forEach((item, itemIndex) => {
              if (item.name.includes(file_name)) {
                $('a.tm35.play-item-rm-btn[id="' + key + '-Group"]')[0].click();
              }
            });
          }
        }
      }
      else if (file_type === 'audio') {
        this.BindAudioSources(<HTMLSelectElement>document.getElementById('ddlSelectedAudio'));
        $("#ddlSelectedAudio option[value='" + file_name + "']").remove();
        $("#" + this.activeAssetId + "_audio_def_source option[value='" + file_name + "']").remove();
      }
      else if (file_type === 'video') {
        this.BindVideoOnlySources(<HTMLSelectElement>document.getElementById('ddlSelectedVideo'));
        $("#ddlSelectedVideo option[value='" + file_name + "']").remove();
        $("#" + this.activeAssetId + "_def_source option[value='" + file_name + "']").remove();
      }

      $('.selectpicker').selectpicker('refresh');

    }, error => {
      this.spinnerService.hide();
      this.authService.showNotification('', 'Some error occured please try again later', 'error');
    });

    window.setTimeout(function () {
      $(".deletefileasset").text('');
      $(".deletefileasset").hide();
    }, 3000);
  }

  openSearchYoutubeModal(): void {
    this.openModel(this.searchYoutubeModal, { size: 'fullscreen_sm_youtube' });
  }
  ReceivePlayListID(playlist_id, playlist_title): void {
    const active_asset = this.stage.findOne('#' + this.activeAssetId + '-Group');
    this.currentAssets[this.activeAssetId].Name = playlist_title;
    this.currentAssets[this.activeAssetId].Source = playlist_id;
    active_asset.attrs.name = playlist_title;
    $("#" + this.activeAssetId + "_name").val(playlist_title);
    $("#" + this.activeAssetId + "_source").val(playlist_id);
    $("#" + this.activeAssetId + "_source").focus();
    this.closeModal();
  }
  onLogout(): void {
    this.resetCompleteScreen();
    this.authService.logout();
    //this.router.navigate(['/login']);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  Publish_SelectAllPlayers(event: any): void {
    $("input:checkbox.chkPlayerName").each(function () {
      if (!this.checked) {
        this.click();
      }
    });
    //$(".chkPlayerName").prop('checked', true);
    //$(".chkPlayerName").prop('checked', event.target.checked);
    //console.log(event);
  }
  onlyNumberKey(evt: any) {
    // Only ASCII character in that range allowed
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
      return false;
    return true;
  }

  TogglePlayerRegistrationLink(): void {
    const userName = this.username;
    this.registrationService.getRegisteredPlayersByUser(userName).subscribe((response) => {

      if (response.data.length === 0) {
        $('#drplnkEditPlayer').addClass('menu-link-disabled');
        $('#drplnkEditPlayer').attr('style', 'color: #B1B8B9 !important');
      }
      else {
        $('#drplnkEditPlayer').removeClass('menu-link-disabled');
        $('#drplnkEditPlayer').attr('style', '');
      }
      if (response.data.length === 0) {
        $('#drplnkPlayerStatus').addClass('menu-link-disabled');
        $('#drplnkPlayerStatus').attr('style', 'color: #B1B8B9 !important');
      }
      else {
        $('#drplnkPlayerStatus').removeClass('menu-link-disabled');
        $('#drplnkPlayerStatus').attr('style', '');
      }

      if (response.data.length >= 10) {
        $('#drplnkRegisterNewPlayer').addClass('menu-link-disabled');
        $('#drplnkRegisterNewPlayer').attr('style', 'color: #B1B8B9 !important');
      }
      else {
        $('#drplnkRegisterNewPlayer').removeClass('menu-link-disabled');
        $('#drplnkRegisterNewPlayer').attr('style', '');
      }
    });
  }

  activePlayerAction(registrationCode, action): void {
    const data = {

      RegistrationCode: registrationCode,
      Action: action
    }
    if (!this.playerStatusObject.activePlayers.find(item => item.registrationCode === registrationCode).isActionFileExist) {

      if (action === 'restart_app') {
        this.playerStatusObject.activePlayers.find(item => item.registrationCode === registrationCode).status = 'Restarting Signage App...';
      } else if (action === 'create_screenshot') {
        this.playerStatusObject.activePlayers.find(item => item.registrationCode === registrationCode).status = 'Creating Screenshot...';
      }
      this.playerStatusObject.activePlayers.find(item => item.registrationCode === registrationCode).isActionFileExist = true;
      this.playerStatusObject.activePlayers.find(item => item.registrationCode === registrationCode).action = action;

      this.registrationService.playerAction(data).subscribe((response) => {
        if (response.status == 'success') {
          //this.authService.showNotification('Success', 'Player Registered successfully.', 'success');
        }
        else if (response.status == 'error') {
          // $("#lbl_registerplayer_errmsg").text(response.message);
          // $("#lbl_registerplayer_errmsg").show();
          // //this.authService.showNotification('Failure', response.message, 'error');
          // this.isRegisterPlayer = false;
        }

      }, error => {
        this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      });
    }
  }

  unknownPlayerAction(registrationCode, action): void {
    const data = {

      RegistrationCode: registrationCode,
      Action: action
    }
    if (this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).status === "Unknown"
      && !this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).isActionFileExist) {

      if (action === 'restart_app') {
        this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).status = 'Restarting Signage App...';
      } else if (action === 'create_screenshot') {
        this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).status = 'Creating Screenshot...';
      }
      this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).isActionFileExist = true;
      this.playerStatusObject.inactivePlayers.find(item => item.registrationCode === registrationCode).action = action;

      this.registrationService.playerAction(data).subscribe((response) => {
        if (response.status == 'success') {
          //this.authService.showNotification('Success', 'Player Registered successfully.', 'success');
        }
        else if (response.status == 'error') {
          // $("#lbl_registerplayer_errmsg").text(response.message);
          // $("#lbl_registerplayer_errmsg").show();
          // //this.authService.showNotification('Failure', response.message, 'error');
          // this.isRegisterPlayer = false;
        }

      }, error => {
        this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
      });
    }
  }

  viewScreenShot(registrationCode, playerName, isScreenshotExists): void {
    if (isScreenshotExists) {
      this.registrationService.getPlayerScreenshotTime(registrationCode).subscribe((response) => {
        ng.playerScreenshotHeader = playerName + ' @ ' + this.pipe.transform(response.data, 'M/d/yy h:mm a');
        var rand = Math.random();
        this.viewScreenshotfile = this.mediaUrl + 'Sites/' + registrationCode + '/screenshot.png?id=' + rand;
        //$("#imgScreenshot").attr('src', '/assets/content/Sites/' + registrationCode + 'screenshot.png');
        this.openModel(this.viewScreenshotModal, { size: 'xl' });
      });
    }
  }


  viewDMBTVPopup(registrationCode, status, isScreenshotExists): void {

    if (status == 'Active') {
      this.dmbTVStatusList = this.playerStatusObject.activePlayers.filter(element => element.registrationCode == registrationCode)
      this.active = true;
    }
    else {
      this.dmbTVStatusList = this.playerStatusObject.inactivePlayers.filter(element => element.registrationCode == registrationCode)
      this.active = false;
    }
    // console.log(this.dmbTVStatusList[0]);
    var status = this.dmbTVStatusList[0].screenStatus;
    this.dmbplayerName = this.dmbTVStatusList[0].playerName;
    this.dateUpdatedOnSiteStatsTable = this.dmbTVStatusList[0].dateUpdated;
    this.volumeLocally = this.dmbTVStatusList[0].volume >= 0 ? false : true;
    this.hideSlider = this.dmbTVStatusList[0].volume == -1 ? false : true;
    this.showNotSet = this.dmbTVStatusList[0].dailyRebootTime == "" ? true : false;

    this.screenStatus = this.dmbTVStatusList[0].screenStatus != "" ? this.dmbTVStatusList[0].screenStatus == 'ON' ? true : false : true;
    if (this.dmbTVStatusList[0].dailyRebootTime == "") {
      this.dmbTVStatusList[0].dailyRebootTime = "-1";
    }
    this.value = this.dmbTVStatusList[0].volume;

    var data = this.TimeArray.filter(x => x.id == this.dmbTVStatusList[0].dailyRebootTime);
    if (data.length > 0) {
      $('#rebootTime').val(this.dmbTVStatusList[0].dailyRebootTime);
    }
    else {
      this.dmbTVStatusList[0].dailyRebootTime = "-1";
      $('#rebootTime').val(this.dmbTVStatusList[0].dailyRebootTime);
    }


    // alert(JSON.stringify(this.dmbTVStatusList));
    this.openModel(this.dmbTVModel, { size: 'lg' });
  }
  saveDMBTVAction(registrationCode): void {
    document.getElementById(registrationCode).style.display = 'none'
    this.playerRegistrationCode = registrationCode;
    localStorage.setItem('registrationCode', registrationCode);

    if (this.active) {
      this.dmbTVStatusList = this.playerStatusObject.activePlayers.filter(element => element.registrationCode == registrationCode)

    }
    else {
      this.dmbTVStatusList = this.playerStatusObject.inactivePlayers.filter(element => element.registrationCode == registrationCode)

    }
    // alert(this.dmbTVStatusList);
    // console.log(this.dmbTVStatusList[0].dateUpdated);
    // alert(this.dmbTVStatusList[0].dateUpdated);
    localStorage.setItem('dateUpdatedOn', this.dmbTVStatusList[0].dateUpdated);
    //var timeNow = new Date().toString().split(' ')[4];
    var oldtime = new Date().getTime().toString();
    localStorage.setItem('oldMinutes', oldtime);
    // setTimeout(function() {
    // alert('test');
    // this.dmbTVStatusList =  this.playerStatusObject.activePlayers.filter(element => element.registrationCode == registrationCode)
    // if(this.dateUpdatedOnSiteStatsTable!= this.dmbTVStatusList[0].dateUpdated)
    // {
    //   document.getElementById(registrationCode).style.display='inline'
    // }
    // }, 1*2000);

    var rebootTime = $('#rebootTime').val();
    var volume = this.value;

    if ($("#screenStatus").is(':checked')) {
      var screenStatus = 'ON';
    }
    else {
      var screenStatus = 'OFF';
    }

    if ($("#isVolumeLocally").is(':checked')) {
      var volumeLocally = true;
      volume = -1;
    }
    else {
      var volumeLocally = true;
    }

    if (this.active) {
      this.dmbTVStatusList = this.playerStatusObject.activePlayers.filter(element => element.registrationCode == registrationCode)
    }
    else {
      this.dmbTVStatusList = this.playerStatusObject.inactivePlayers.filter(element => element.registrationCode == registrationCode)
    }
    const data = {

      RegistrationCode: registrationCode,
      Action: 'dmbTVScreen',
      Volume: volume,
      ScreenStatus: screenStatus,
      DailyRebootTime: rebootTime,
      VolumeSetLocally: volumeLocally
    }
    ng.closeModal();
    this.registrationService.dmbTVAction(data).subscribe((response) => {
      if (response.status == 'success') {
        this.authService.showNotification('Success', 'dmb settings created successfully.', 'success');
      }
      else if (response.status == 'error') {
        this.authService.showNotification('Failure', response.message, 'error');
      }

    }, error => {
      this.authService.showNotification('Error', 'Some error occured. please try again later', 'error');
    });
  }
  showVolumeSlider(): void {
    if ($("#isVolumeLocally").is(':checked')) {
      this.hideSlider = false;
    }
    else {
      this.hideSlider = true;
    }
  }

  allowDropPlayListItem(ev) {

    ev.preventDefault();  // prevent  the browser default handling of the data (default is open as link on drop)
    //var dropParent =  ev.target.parentElement.parentElement;

    //if(dropParent.classList.contains('playListItemParent')) {
    //  dropParent.classList.add('playlistitem-dragover');
    //}
  }

  dragStartPlayListItem(ev, draggedAssetId) {
    ev.dataTransfer.setData("targetId", ev.target.id);
    ev.dataTransfer.setData("draggedAssetId", draggedAssetId);

    draggedPlayListItemId = ev.target.id;

    var dragItem = document.getElementById(ev.target.id);
    var dragParent = dragItem.parentElement;

    $('.pl-asset-item').each(function () {
      this.classList.remove('pl-asset-item-active');
    });

    dragItem.classList.add('playlistitem-drag');

    // dragItem.style.opacity = '0.4';
    // dragItem.style.border = '3px dashed red';
    //dragParent.classList.remove('playListItemParent-allowDrop');
  }

  dragEnterPlayListItem(ev) {

    var dragItem = document.getElementById(draggedPlayListItemId);

    var dropItem = ev.target;
    var dropParent = dropItem.parentElement;

    if (dropParent.parentElement.classList.contains('playListItemParent')) {
      if (dragItem !== dropItem && dragItem !== dropParent) {
        //dragItem.classList.remove('playlistitem-drag');
        dropParent.classList.add('playlistitem-droppable');
      }
    }

    //alert(ev.target.id);

    // if(!dropItem.classList.contains('playlistitem-drag') && !dropParent.classList.contains('playlistitem-drag')) {

    //   //alert();
    //   dragItem.classList.remove('playlistitem-drag');
    //   dragItem.classList.add('playlistitem-droppable');
    // }
  }

  dragLeavePlayListItem(ev) {

    var dragItem = document.getElementById(draggedPlayListItemId);
    var dropItem = ev.target;
    var dropParent = dropItem.parentElement;
    //var dragParent = dragItem.parentElement;

    //dragItem.classList.add('playlistitem-drag');
    dropParent.classList.remove('playlistitem-droppable');

    //dragItem.classList.remove('playlistitem-droppable');
    //dragItem.classList.add('playlistitem-drag');
  }

  dragEndPlayListItem(ev, draggedAssetId) {

    var dragItem = document.getElementById(ev.target.id);
    var dragParent = dragItem.parentElement;

    $('.pl-asset-item').each(function () {
      this.classList.remove('playlistitem-drag');
      this.classList.remove('playlistitem-droppable');

      if (this.children[0]) {
        this.children[0].classList.remove('playlistitem-drag');
        this.children[0].classList.remove('playlistitem-droppable');
      }
    });

    //dragItem.classList.remove('playlistitem-drag');
    //dragItem.classList.remove('playlistitem-allowdrop');

    const draggedAssetGroup = this.stage.findOne('#' + draggedAssetId + '-Group');
    this.setCurrentActiveAsset(draggedAssetGroup);

    //dragItem.style.opacity = '1';
  }

  dropPlayListItem(ev, currentAssetId) {
    //alert(ev.target.id);
    //alert(currentAssetId);
    ev.preventDefault();
    var targetId = ev.dataTransfer.getData("targetId");
    var draggedAssetId = ev.dataTransfer.getData("draggedAssetId");
    var elm = document.getElementById(targetId);
    var dragParent = elm.parentElement;
    //alert(ev.dataTransfer.getData("targetId"));
    //alert(draggedAssetId);
    //alert(data);
    //alert(ev.target.id);
    //ev.target = ev.target.parentElement.parentElement;
    var dropParent = ev.target.parentElement.parentElement;
    //var dropParent =  ev.target;
    //alert(dropParent.children[0]);

    //dragParent.classList.remove('playListItemParent-allowDrop');
    //dropParent.classList.remove('playListItemParent-allowDrop');

    if (dropParent.classList.contains('playListItemParent')) {

      //elm.parentElement.appendChild(dropParent.children[0]);
      //dropParent.innerHTML = "";
      //dropParent.appendChild(elm);

      //var currentAsset = this.currentAssets[currentAssetId];
      //var draggedAsset = this.currentAssets[draggedAssetId];

      //var currentIndex = this.currentAssets.indexOf(currentAsset);
      //var draggedIndex = this.currentAssets.indexOf(draggedAsset);
      //this.currentAssets.splice(1, 0, this.currentAssets.splice(0, 1)[0]);

      //if(currentIndex < draggedIndex){
      //this.currentAssets.splice(0, 0, this.currentAssets.splice(1, 1)[0]);
      //this.currentAssets.splice(draggedIndex + 1, 0, this.currentAssets.splice(currentIndex + 1, 1)[0]);
      //} else {
      //this.currentAssets.splice(draggedIndex, 0, this.currentAssets.splice(currentIndex, 1)[0]);
      //this.currentAssets.splice(currentIndex + 1, 0, this.currentAssets.splice(draggedIndex + 1, 1)[0]);
      //}

      //var lastAsset = this.currentAssets[this.currentAssets.length - 1];

      //alert(lastAsset);
      //alert(currentAssetId);
      //alert(draggedAssetId);
      var newAssetList = [];
      var NewElementList: Array<any> = [];
      var assetId = '';

      for (const key in this.currentAssets) {
        if (key === currentAssetId) {
          newAssetList[draggedAssetId] = this.currentAssets[draggedAssetId];
          assetId = draggedAssetId;
        } else if (key === draggedAssetId) {
          newAssetList[currentAssetId] = this.currentAssets[currentAssetId];
          assetId = currentAssetId;
        } else {
          newAssetList[key] = this.currentAssets[key];
          assetId = key;
        }

        const assetGroup = this.stage.findOne('#' + assetId + '-Group');
        NewElementList.push(assetGroup);

        //const group = this.stage.findOne('#' + assetId + '-Group');  // get the asset that needs to be removed

        assetGroup.moveToTop();
        ng.stage.batchDraw();
      }

      this.currentAssets = newAssetList;
      this.myElement = NewElementList;
    }
  }

  ScreenName_keyPress(event) {

    let keycode = event.which || event.keyCode;

    if (keycode === 34 || keycode === 42 || keycode === 47 || keycode === 58 || keycode === 60 || keycode === 62 ||
      keycode === 63 || keycode === 92 || keycode === 124) {
      event.preventDefault();
      return false;
    }
  }

  ddlRules_change(): void {

    const userName = this.username;
    this.registrationService.getRegisteredPlayersByUser(userName).subscribe((response) => {
      this.registeredPlayers = response.data;

      (<HTMLInputElement>document.getElementById('chkSunday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkMonday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkTuesday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkWednesday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkThursday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkFriday')).checked = false;
      (<HTMLInputElement>document.getElementById('chkSaturday')).checked = false;

      this.isEditRule = false;

      if ($("#ddlRules").val() !== '') {

        $("#divTimeOfDayStart").addClass('d-none');
        $("#divTimeOfDayContent").removeClass('d-none');

        if ($("#ddlRules").val() === '0') {
          $("#txtRuleName").val('');
          $("#ddlTimeZone").val('');
          $("#ddlHour").val('');
          $("#ddlMeridiem").val('AM');
          $("#ddlScreenName").val('');

          this.tod_no_of_players = 0;

          $(".selectpicker").selectpicker('refresh');
          $("#txtRuleName").removeClass('d-none');
          $("#btnDeleteRule").addClass('d-none');

          return;
        }

        $("#btnDeleteRule").removeClass('d-none');
        this.isEditRule = true;
        $("#txtRuleName").val($("#ddlRules").val());
        $("#txtRuleName").addClass('d-none');
        // alert(JSON.stringify(this.currentTimeOfDay));
        this.currentRule = this.currentTimeOfDay.rules.find(r => r.name == $("#ddlRules").val());

        // alert(this.currentTimeOfDay.timeZone);
        $("#ddlTimeZone").val(this.currentTimeOfDay.timeZone);
        $("#ddlScreenName").val(this.currentRule.screenName);

        var startDays = this.currentRule.startDay.split(',');

        for (var i = 0; i < startDays.length; i++) {

          if (startDays[i] === 'SUN') {
            (<HTMLInputElement>document.getElementById('chkSunday')).checked = true;
          }
          if (startDays[i] === 'MON') {
            (<HTMLInputElement>document.getElementById('chkMonday')).checked = true;
          }
          if (startDays[i] === 'TUES') {
            (<HTMLInputElement>document.getElementById('chkTuesday')).checked = true;
          }
          if (startDays[i] === 'WED') {
            (<HTMLInputElement>document.getElementById('chkWednesday')).checked = true;
          }
          if (startDays[i] === 'THURS') {
            (<HTMLInputElement>document.getElementById('chkThursday')).checked = true;
          }
          if (startDays[i] === 'FRI') {
            (<HTMLInputElement>document.getElementById('chkFriday')).checked = true;
          }
          if (startDays[i] === 'SAT') {
            (<HTMLInputElement>document.getElementById('chkSaturday')).checked = true;
          }
        }

        var rStartH = 0;
        var rStartM = '';

        if (this.currentRule.startHour === '0') {
          rStartH = 12;
          rStartM = 'AM';
        } else if (this.currentRule.startHour === '12') {
          rStartH = this.currentRule.startHour;
          rStartM = 'PM';
        } else if (parseInt(this.currentRule.startHour) > 12) {
          rStartH = parseInt(this.currentRule.startHour) - 12;
          rStartM = 'PM';
        } else {
          rStartH = this.currentRule.startHour;
          rStartM = 'AM';
        }

        $("#ddlHour").val(rStartH);
        $("#ddlMeridiem").val(rStartM);

        this.tod_no_of_players = this.currentRule.players.length;

        this.currentRule.players.forEach(element => {
          this.registeredPlayers.find(p => p.playerName == element.name).isSelected = true;
        });

        $(".selectpicker").selectpicker('refresh');
        // this.currentTimeOfDay.rules.array.forEach(element => {

        // });

      } else {
        $("#divTimeOfDayStart").removeClass('d-none');
        $("#divTimeOfDayContent").addClass('d-none');

        $("#txtRuleName").addClass('d-none');
        $("#btnDeleteRule").addClass('d-none');
        $("#ddlTimeZone").val('');
        $(".selectpicker").selectpicker('refresh');
      }

    });
  }

  deleteTodRule(isShowNotification: boolean): void {

    const data = this.create_timeofday_array(true);

    const userName = this.username;
    var reqData = {
      userName: userName
    };

    this.screenService.saveTimeOfDay(data).subscribe((response) => {
      // this.closeModal();
      if (isShowNotification) {
        if (response.status === 'error') {
          this.authService.showNotification(response.message, '', 'error');
        } else {
          this.authService.showNotification('Rule deleted successfully', 'success', 'success');

          this.fetchTimeOfDayData(reqData);
        }
      }
    }, error => {
      if (isShowNotification) {
        //this.authService.showNotification(error.message, 'error');
        this.authService.showNotification('', 'Some error occured. please try again later', 'error');
      }
      //this.modalRef.close();
    });
  }

  resetTimeOfDayModal(): void {

    $("#ddlRules").val('');
    $("#txtRuleName").val('');
    $("#txtRuleName").addClass('d-none');
    $("#btnDeleteRule").addClass('d-none');
    $("#ddlTimeZone").val('');
    $("#ddlScreenName").val('');
    $("#ddlHour").val('');
    $("#ddlMeridiem").val('AM');

    (<HTMLInputElement>document.getElementById('chkSunday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkMonday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkTuesday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkWednesday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkThursday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkFriday')).checked = false;
    (<HTMLInputElement>document.getElementById('chkSaturday')).checked = false;

    this.tod_no_of_players = 0;
    this.registeredPlayers.forEach(rp => {
      rp.isSelected = false;
    });

    $('.selectpicker').selectpicker('refresh');

    $("#divTimeOfDayStart").removeClass('d-none');
    $("#divTimeOfDayContent").addClass('d-none');
  }

  // showZoomLevel(value) {
  //   //alert(3);
  //   //(<HTMLInputElement>document.getElementById('zoomValue')).value = value.toString() + '%';
  // }

  changeZoomLevel() {
    //alert(1);
    var value = this.zoomValue;

    var stageWidth = (parseInt(this.gActiveResolution.split('x')[0]) * value) / 100;
    var stageHeight = (parseInt(this.gActiveResolution.split('x')[1]) * value) / 100;

    $('#canvasContainer').css({
      width: stageWidth + 'px',
      height: stageHeight + 'px',
      overflow: 'auto'
    });
    //(<HTMLDivElement>document.getElementById('#no-slider-parent')).style.width = '800px!important';
    // $('#nosliderlabel').css({
    //   'text-align': 'left!important',
    //   'padding-right': '800px!important'
    // });
    var padding_base = 0;
    if (this.gActiveResolution == '1080x1920') {
      padding_base = 100 - (value - 60);
    } else {
      padding_base = 100 - value;
    }

    var text_padding = (padding_base * parseInt(this.gActiveResolution.split('x')[0])) / 100;

    if ($('#no-slider-parent').css('display') === 'none') {
      $('#no-slider-parent').attr("style", "margin-bottom: 10px;height: 90px;padding-right:" + text_padding + "px!important;display:none");
    } else {
      $('#no-slider-parent').attr("style", "margin-bottom: 10px;height: 90px;padding-right:" + text_padding + "px!important");
    }


    //alert($('#no-slider-parent'));

    //document.body.style.zoom = value.toString() + '%';
    //(<HTMLInputElement>document.getElementById('canvasContainer')).value = value.toString() + '%';
    //this.resetCompleteScreen();
    // this.gridLayer.destroy();
    // const gridLayer = this.createGridLayer();
    // this.stage.add(gridLayer);

    // if (this.snapToEnabled) {
    //   this.gridLayer.show();
    //   this.gridLayer.moveToBottom();
    // } else {
    //   this.gridLayer.hide();
    // }
  }

  setZoomLevel() {

    var targetWidth = 2688;
    var targetHeight = 910;

    var browserWidth = window.innerWidth;
    var browserHeight = window.innerHeight;

    if (browserWidth < targetWidth) {
      var zoomPercent = Math.round((browserWidth / targetWidth) * 100);
      zoomPercent = zoomPercent - 10;

      var stageWidth = (parseInt(this.gActiveResolution.split('x')[0]) * zoomPercent) / 100;
      var stageHeight = (parseInt(this.gActiveResolution.split('x')[1]) * zoomPercent) / 100;

      // if(zoomPercent<100) {
      //   zoomPercent = 50;
      // } else {
      //   zoomPercent = 100;
      // }
      //zoomPercent = zoomPercent - 10;
      // if(zoomPercent >= 30 && zoomPercent <= 130){  //if we have to reduce the browser screen size to fit the app					
      if (zoomPercent >= 40 && zoomPercent <= 100) {

        $('#canvasContainer').css({
          width: stageWidth + 'px',
          height: stageHeight + 'px',
          overflow: 'auto'
        });

        var padding_base = 0;
        if (this.gActiveResolution == '1080x1920') {
          padding_base = 100 - (zoomPercent + 20);
        } else {
          padding_base = 100 - zoomPercent;
        }

        var text_padding = (padding_base * parseInt(this.gActiveResolution.split('x')[0])) / 100;
        $('#no-slider-parent').attr("style", "margin-bottom: 10px;height: 90px;padding-right:" + text_padding + "px!important;");

        //document.body.style.zoom = zoomPercent.toString() + "%";
        //document.body.style.transformOrigin = 'left center';
        // var transform = zoomPercent/100;
        // $('body').css({
        //   transform: 'scale(' + transform + ')', // set zoom
        //   transformOrigin: 'top center' // set transform scale base
        // });
        // if(zoomPercent-10>100) $('body').css({ width: ((zoomPercent-10)*1.2)+'%' });
        // else $('body').css({ width: '100%' });
        //(<HTMLInputElement>document.getElementById('zoom-level')).value = zoomPercent.toString();
        //(<HTMLInputElement>document.getElementById('zoomValue')).value = zoomPercent.toString() + "%";

        this.zoomValue = zoomPercent;
      }
    }
    //this.resetCompleteScreen();
    //this.resetScreenAfterZoomChange();

    //$('#zoom-level').blur();

    // if(zoomPercent === 50) {
    //   //this.gActiveResolution = '745x300';
    // }
    //this.changeCanvasResolution();
    //let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
    //alert(Math.ceil(zoom));

    //this.resetCompleteScreen();
    //this.changeCanvasResolution();    
    // this.gridLayer.destroy();
    // const gridLayer = this.createGridLayer();
    // this.stage.add(gridLayer);

    // this.layer.draw();

    // if (this.snapToEnabled) {
    //   this.gridLayer.show();
    //   this.gridLayer.moveToBottom();
    // } else {
    //   this.gridLayer.hide();
    // }
  }

  create_timeofday_array(deleteRule: boolean): object {

    var ruleStartDay = '';
    var isSunday = (<HTMLInputElement>document.getElementById('chkSunday')).checked;
    var isMonday = (<HTMLInputElement>document.getElementById('chkMonday')).checked;
    var isTuesday = (<HTMLInputElement>document.getElementById('chkTuesday')).checked;
    var isWednesday = (<HTMLInputElement>document.getElementById('chkWednesday')).checked;
    var isThursday = (<HTMLInputElement>document.getElementById('chkThursday')).checked;
    var isFriday = (<HTMLInputElement>document.getElementById('chkFriday')).checked;
    var isSaturday = (<HTMLInputElement>document.getElementById('chkSaturday')).checked;

    if (isSunday) {
      ruleStartDay = 'SUN';
    }
    if (isMonday) {
      ruleStartDay = ruleStartDay === '' ? 'MON' : ruleStartDay + ',MON';
    }
    if (isTuesday) {
      ruleStartDay = ruleStartDay === '' ? 'TUES' : ruleStartDay + ',TUES';
    }
    if (isWednesday) {
      ruleStartDay = ruleStartDay === '' ? 'WED' : ruleStartDay + ',WED';
    }
    if (isThursday) {
      ruleStartDay = ruleStartDay === '' ? 'THURS' : ruleStartDay + ',THURS';
    }
    if (isFriday) {
      ruleStartDay = ruleStartDay === '' ? 'FRI' : ruleStartDay + ',FRI';
    }
    if (isSaturday) {
      ruleStartDay = ruleStartDay === '' ? 'SAT' : ruleStartDay + ',SAT';
    }

    var ruleStartHour = parseInt($("#ddlHour").val());
    var meridiem = $("#ddlMeridiem").val();

    if (meridiem === 'AM' && ruleStartHour === 12) {
      ruleStartHour = 0;
    }
    if (meridiem === 'PM') {
      if (ruleStartHour !== 12) {
        ruleStartHour = ruleStartHour + 12;
      }
    }

    var todPlayers = []

    var regPlayers = this.registeredPlayers.filter(p => p.isSelected === true);
    regPlayers.forEach(rp => {
      var todPlayer = {
        name: rp.playerName
      };
      todPlayers.push(todPlayer);
    });

    var todRule = {
      name: $("#txtRuleName").val(),
      startDay: ruleStartDay,
      startHour: ruleStartHour,
      screenName: $("#ddlScreenName").val(),
      players: todPlayers,
      deleteRule: deleteRule
    };
    var todRules = [];
    todRules.push(todRule);

    var objTimeOfDay = {
      id: Math.floor(Math.random()),
      account: this.username,
      name: 'time-of-day.xml',
      timeZone: $("#ddlTimeZone").val(),
      rules: todRules,
    };

    return objTimeOfDay;
  }

  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  save_timeofday_file(isShowNotification: boolean): void {

    var isSunday = (<HTMLInputElement>document.getElementById('chkSunday')).checked;
    var isMonday = (<HTMLInputElement>document.getElementById('chkMonday')).checked;
    var isTuesday = (<HTMLInputElement>document.getElementById('chkTuesday')).checked;
    var isWednesday = (<HTMLInputElement>document.getElementById('chkWednesday')).checked;
    var isThursday = (<HTMLInputElement>document.getElementById('chkThursday')).checked;
    var isFriday = (<HTMLInputElement>document.getElementById('chkFriday')).checked;
    var isSaturday = (<HTMLInputElement>document.getElementById('chkSaturday')).checked;

    if ($("#ddlRules").val() === '') {
      this.authService.showNotification('Please select a rule', '', 'error');
      return;
    }
    if ($("#txtRuleName").val().trim() === '') {
      this.authService.showNotification('Please enter rule name', '', 'error');
      return;
    }
    if ($("#ddlTimeZone").val() === '') {
      this.authService.showNotification('Please select time zone', '', 'error');
      return;
    }
    if (!isSunday && !isMonday && !isTuesday && !isWednesday && !isThursday && !isFriday && !isSaturday) {
      this.authService.showNotification('Please select day of week', '', 'error');
      return;
    }
    if ($("#ddlHour").val() === '') {
      this.authService.showNotification('Please select hour', '', 'error');
      return;
    }
    if ($("#ddlScreenName").val() === '') {
      this.authService.showNotification('Please select screen name', '', 'error');
      return;
    }
    if (this.tod_no_of_players === 0) {
      this.authService.showNotification('Please select players', '', 'error');
      return;
    }
    if (this.currentRules.length >= 5 && this.isEditRule === false) {
      this.authService.showNotification('Cannot create more than 5 <br/> rules', '', 'error');
      return;
    }

    const data = this.create_timeofday_array(false);

    if (!data) {
      return;
    }

    const userName = this.username;
    var reqData = {
      userName: userName
    };

    this.screenService.saveTimeOfDay(data).subscribe((response) => {
      // this.closeModal();
      if (isShowNotification) {
        if (response.status === 'error') {
          this.authService.showNotification(response.message, '', 'error');
        } else {
          this.authService.showNotification('Rules saved successfully', 'success', 'success');
          this.fetchTimeOfDayData(reqData);
        }
      }
    }, error => {
      if (isShowNotification) {
        //this.authService.showNotification(error.message, 'error');
        this.authService.showNotification('', 'Some error occured. please try again later', 'error');
      }
      //this.modalRef.close();
    });
  }

  private fetchTimeOfDayData(reqData: any): void {
    this.screenService.readTimeOfDayFile(reqData).subscribe(
      response => this.handleApiResponse(response),
      error => this.handleApiError(error)
    );
  }

  private handleApiResponse(response: any): void {
    if (response.status === 'error') {
      this.spinnerService.hide();
      this.authService.showNotification('', response.message, 'error');
    } else {
      this.currentTimeOfDay = response.data;
      this.currentRules = response.data.rules;
      this.tod_no_of_players = 0;
      this.configureModalElements();
      this.spinnerService.hide();
      this.resetTimeOfDayModal();
    }
  }

  private handleApiError(error: any): void {
    this.spinnerService.hide();
    this.authService.showNotification('', 'Some error occurred please try again later', 'error');
  }

  private configureModalElements(): void {
    $(".selectpicker").selectpicker();
    setTimeout(() => {
      $(".selectpicker").selectpicker('refresh');
      $("#divTodModalBody").removeClass('disabled');
    }, 2000);
  }

  openSubscriptionsModal() {
    if (this.username) {
      this.spinnerService.show();
      this.subscriptionService.getSubscriptionDetails(this.username).subscribe(
        (response) => {
          if (response && response.data) {
            if(response.status === 'error') {
              this.spinnerService.hide();
              this.authService.showNotification('', 'Some error occured please try again later', 'error');
            } else {
              this.subscriptionDetails = response.data;
              this.spinnerService.hide();
              this.isAddDaysView = false;
              this.openModel(this.accountSubscriptionModal, { size: 'fullscreen_sm' });
              $('.selectpicker').selectpicker('refresh');
            }
          } else {
            this.spinnerService.hide();
            this.authService.showNotification('', 'Some error occured please try again later', 'error');
          }
        },
        (error) => {
          console.error('Error fetching subscription details:', error);
          this.spinnerService.hide();
          this.authService.showNotification('', 'Some error occured please try again later', 'error');
        }
      );
    }
  }

  GetEncodedComponent(url): any {
    return encodeURIComponent(url);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/screen-builder/screen-builder.component.ts